import i18n from 'i18next';
import { PageTemplate } from '../../../types/pageBuilder';

// Portuguese to English mappings for template content
const ptToEnMappings: Record<string, string> = {
  // Common buttons and CTAs
  'Começar Grátis': 'Start Free',
  'Ver Demo': 'View Demo',
  'Saiba Mais': 'Learn More',
  'Começar Agora': 'Get Started',
  'Cadastre-se': 'Sign Up',
  'Inscrever-se': 'Subscribe',
  'Enviar': 'Send',
  'Registrar': 'Register',
  'Baixar': 'Download',
  'Comprar Agora': 'Buy Now',
  'Adicionar ao Carrinho': 'Add to Cart',
  'Contato': 'Contact',
  'Fale Conosco': 'Contact Us',
  'Quero Conhecer': 'I Want to Know More',
  'Solicitar Orçamento': 'Request a Quote',
  'Ver Ofertas': 'View Offers',
  'Baixar App': 'Download App',
  'Matricular Agora': 'Enroll Now',
  'Avise-me': 'Notify Me',
  'Agendar Consultoria': 'Schedule Consultation',
  'Garantir Minha Vaga': 'Save My Spot',
  'Baixar E-book Grátis': 'Download Free E-book',
  'Comprar': 'Buy',
  'QUERO MEU E-BOOK GRÁTIS →': 'I WANT MY FREE E-BOOK →',
  'BAIXAR E-BOOK GRÁTIS': 'DOWNLOAD FREE E-BOOK',
  'QUERO RECEBER': 'I WANT TO RECEIVE',
  'ENTRAR NA LISTA →': 'JOIN THE LIST →',
  'AGENDAR CONSULTORIA GRÁTIS': 'SCHEDULE FREE CONSULTATION',
  'QUERO EXPERIMENTAR GRÁTIS': 'I WANT TO TRY FREE',
  'GARANTIR MINHA VAGA': 'SAVE MY SPOT',
  'VER CARDÁPIO COMPLETO': 'VIEW FULL MENU',
  'FAZER RESERVA': 'MAKE RESERVATION',
  'PEDIR AGORA': 'ORDER NOW',
  'BAIXAR PARA iOS': 'DOWNLOAD FOR iOS',
  'BAIXAR PARA ANDROID': 'DOWNLOAD FOR ANDROID',
  'QUERO ME MATRICULAR': 'I WANT TO ENROLL',
  'GARANTIR MINHA MATRÍCULA →': 'SECURE MY ENROLLMENT →',
  'VER PROJETOS': 'VIEW PROJECTS',
  'INICIAR PROJETO': 'START PROJECT',
  'AGENDAR CONSULTA': 'SCHEDULE APPOINTMENT',
  'Ver Todos os Imóveis': 'View All Properties',
  'QUERO VISITAR': 'I WANT TO VISIT',
  'COMEÇAR AGORA': 'START NOW',
  'GARANTIR MINHA VAGA →': 'SAVE MY SPOT →',
  'OUVIR AGORA': 'LISTEN NOW',
  'INSCREVER-SE AGORA': 'SUBSCRIBE NOW',
  'COMPRAR AGORA': 'BUY NOW',
  'APROVEITAR OFERTA': 'GET THIS DEAL',
  'AGENDAR HORÁRIO': 'SCHEDULE TIME',

  // Form labels and placeholders
  'Nome Completo': 'Full Name',
  'Nome': 'Name',
  'E-mail': 'Email',
  'Seu e-mail': 'Your email',
  'Telefone': 'Phone',
  'WhatsApp': 'WhatsApp',
  'Empresa': 'Company',
  'Mensagem': 'Message',
  'Sua mensagem': 'Your message',
  'Digite seu e-mail': 'Enter your email',
  'Seu nome completo': 'Your full name',
  'Seu melhor e-mail': 'Your best email',
  'WhatsApp (opcional)': 'WhatsApp (optional)',
  'Preencha abaixo para receber seu exemplar': 'Fill in below to receive your copy',
  'Digite seu melhor e-mail': 'Enter your best email',
  'Seu nome': 'Your name',
  'Seu telefone': 'Your phone',
  'Nome do seu negócio': 'Your business name',
  'Qual seu principal desafio?': 'What is your main challenge?',
  'Número de pessoas': 'Number of people',
  'Selecione o horário': 'Select time',
  'Selecione a quantidade': 'Select quantity',
  'Seu celular': 'Your phone number',

  // Common phrases
  '7 dias grátis': '7-day free trial',
  'Sem cartão de crédito': 'No credit card required',
  'Cancele quando quiser': 'Cancel anytime',
  'Mais Popular': 'Most Popular',
  '/mês': '/month',
  'Todos os direitos reservados': 'All rights reserved',
  'Seus dados estão seguros e protegidos': 'Your data is safe and protected',
  '🔒 Seus dados estão seguros e protegidos': '🔒 Your data is safe and protected',
  'Política de Privacidade': 'Privacy Policy',
  'Termos de Serviço': 'Terms of Service',

  // Lead Capture Pro Template
  '📘 E-book Gratuito - Edição 2025': '📘 Free E-book - 2025 Edition',
  'O Guia Definitivo para': 'The Ultimate Guide to',
  'Dobrar Suas Vendas': 'Double Your Sales',
  'em 90 Dias': 'in 90 Days',
  'Descubra o método passo a passo que já ajudou mais de 15.000 empreendedores a escalar seus resultados de forma previsível e sustentável.':
    'Discover the step-by-step method that has helped over 15,000 entrepreneurs scale their results predictably and sustainably.',
  '47 estratégias testadas e comprovadas em diferentes mercados': '47 tested and proven strategies across different markets',
  'Planilhas e templates prontos para usar imediatamente': 'Spreadsheets and templates ready to use immediately',
  'Estudos de caso reais com resultados documentados': 'Real case studies with documented results',
  'Bônus: Checklist de implementação em 30 dias': 'Bonus: 30-day implementation checklist',
  'Baixe Agora - 100% Grátis': 'Download Now - 100% Free',
  'Método utilizado por profissionais de': 'Method used by professionals from',
  'O Que Você Vai Aprender': 'What You Will Learn',
  'Conteúdo 100% prático e aplicável, desenvolvido para gerar resultados reais no seu negócio':
    '100% practical and applicable content, developed to generate real results in your business',
  'Capítulo 1: Fundamentos': 'Chapter 1: Fundamentals',
  'Capítulo 2: Estratégias': 'Chapter 2: Strategies',
  'Capítulo 3: Escala': 'Chapter 3: Scale',
  'Capítulo 4: Otimização': 'Chapter 4: Optimization',
  'Capítulo 5: Métricas': 'Chapter 5: Metrics',
  'Bônus: Templates': 'Bonus: Templates',
  'Entenda a psicologia por trás das decisões de compra e como usar isso a seu favor para aumentar conversões.':
    'Understand the psychology behind purchase decisions and how to use it to your advantage to increase conversions.',
  '47 táticas comprovadas para atrair, engajar e converter mais clientes em qualquer nicho de mercado.':
    '47 proven tactics to attract, engage, and convert more customers in any market niche.',
  'Como automatizar e escalar seu processo de vendas mantendo a qualidade e aumentando o faturamento.':
    'How to automate and scale your sales process while maintaining quality and increasing revenue.',
  'Técnicas avançadas de teste A/B e otimização contínua para maximizar seus resultados.':
    'Advanced A/B testing techniques and continuous optimization to maximize your results.',
  'Quais números acompanhar e como interpretar dados para tomar decisões mais inteligentes.':
    'Which numbers to track and how to interpret data to make smarter decisions.',
  'Planilhas, scripts e modelos prontos para você implementar imediatamente no seu negócio.':
    'Spreadsheets, scripts, and ready-made templates for you to implement immediately in your business.',
  'Para Quem É Este E-book?': 'Who Is This E-book For?',
  'Este material foi criado especialmente para:': 'This material was created especially for:',
  'Empreendedores': 'Entrepreneurs',
  'Que querem aumentar o faturamento sem depender apenas de indicações': 'Who want to increase revenue without relying solely on referrals',
  'Profissionais de Marketing': 'Marketing Professionals',
  'Que buscam estratégias comprovadas para melhorar resultados': 'Looking for proven strategies to improve results',
  'Donos de Negócios Locais': 'Local Business Owners',
  'Que precisam atrair mais clientes de forma consistente': 'Who need to attract more customers consistently',
  'Freelancers e Consultores': 'Freelancers and Consultants',
  'Que querem sair da montanha-russa financeira': 'Who want to get off the financial roller coaster',
  'Sobre o Autor': 'About the Author',
  'Especialista em vendas e marketing digital com mais de 15 anos de experiência. Já ajudou mais de 500 empresas a multiplicarem seus resultados através de estratégias comprovadas.':
    'Sales and digital marketing specialist with over 15 years of experience. Has helped over 500 companies multiply their results through proven strategies.',
  'Fundador da Agência XYZ e palestrante reconhecido nacionalmente, João compartilha neste e-book todo o conhecimento que acumulou ao longo de sua carreira.':
    'Founder of XYZ Agency and nationally recognized speaker, João shares in this e-book all the knowledge he has accumulated throughout his career.',
  'Empresas atendidas': 'Companies served',
  'Downloads do e-book': 'E-book downloads',
  'Gerados para clientes': 'Generated for clients',
  'O Que Dizem Sobre o E-book': 'What They Say About the E-book',
  'Depoimentos reais de pessoas que já aplicaram o método': 'Real testimonials from people who have applied the method',
  'Implementei apenas 3 estratégias do e-book e aumentei minhas vendas em 40% no primeiro mês. O conteúdo é extremamente prático e vai direto ao ponto.':
    'I implemented just 3 strategies from the e-book and increased my sales by 40% in the first month. The content is extremely practical and gets straight to the point.',
  'O melhor material gratuito que já baixei. As planilhas sozinhas já valem muito mais do que muitos cursos pagos que já comprei.':
    'The best free material I\'ve ever downloaded. The spreadsheets alone are worth much more than many paid courses I\'ve bought.',
  'Finalmente um conteúdo que entrega o que promete. Sem enrolação, só estratégias que funcionam de verdade. Recomendo demais!':
    'Finally content that delivers what it promises. No fluff, just strategies that really work. Highly recommend!',
  'Empreendedora Digital': 'Digital Entrepreneur',
  'Perguntas Frequentes': 'Frequently Asked Questions',
  'Tire suas dúvidas sobre o e-book': 'Clear your doubts about the e-book',
  'O e-book é realmente gratuito?': 'Is the e-book really free?',
  'Sim, 100% gratuito! Você só precisa informar seu e-mail para receber o material completo. Não existe nenhum custo oculto.':
    'Yes, 100% free! You just need to provide your email to receive the complete material. There are no hidden costs.',
  'Para qual tipo de negócio serve?': 'What type of business is it for?',
  'O conteúdo foi desenvolvido para ser aplicável em qualquer tipo de negócio - serviços, produtos físicos, digitais, B2B ou B2C. Os princípios são universais.':
    'The content was developed to be applicable to any type of business - services, physical products, digital, B2B or B2C. The principles are universal.',
  'Em quanto tempo vou ver resultados?': 'How long will it take to see results?',
  'Depende da sua dedicação na implementação. Alguns leitores relatam resultados já nas primeiras semanas, outros em 30-60 dias. O importante é aplicar o método consistentemente.':
    'It depends on your dedication to implementation. Some readers report results in the first few weeks, others in 30-60 days. The important thing is to apply the method consistently.',
  'Vou receber spam depois de baixar?': 'Will I receive spam after downloading?',
  'Não! Você receberá apenas conteúdos relevantes sobre vendas e marketing. Pode cancelar a inscrição a qualquer momento com um clique.':
    'No! You will only receive relevant content about sales and marketing. You can unsubscribe at any time with one click.',
  'Como recebo o e-book?': 'How do I receive the e-book?',
  'Imediatamente após o cadastro, você receberá um e-mail com o link para download. Verifique também sua caixa de spam/promoções.':
    'Immediately after registration, you will receive an email with the download link. Also check your spam/promotions folder.',
  'Pronto Para Dobrar Suas Vendas?': 'Ready to Double Your Sales?',
  'Junte-se a mais de 15.000 empreendedores que já transformaram seus resultados com este método comprovado.':
    'Join over 15,000 entrepreneurs who have already transformed their results with this proven method.',
  'E-book enviado para seu e-mail! Verifique sua caixa de entrada.': 'E-book sent to your email! Check your inbox.',

  // Newsletter Premium Template
  'Newsletter Exclusiva': 'Exclusive Newsletter',
  'Receba insights semanais sobre': 'Receive weekly insights on',
  'tecnologia e inovação': 'technology and innovation',
  'Junte-se a mais de 25.000 profissionais que recebem as melhores análises e tendências do mercado tech toda segunda-feira.':
    'Join over 25,000 professionals who receive the best market tech analysis and trends every Monday.',
  'inscritos ativos': 'active subscribers',
  'taxa de abertura': 'open rate',
  'edições enviadas': 'editions sent',
  'O Que Você Vai Receber': 'What You Will Receive',
  'Conteúdo curado semanalmente para manter você à frente do mercado': 'Weekly curated content to keep you ahead of the market',
  'Análises de Mercado': 'Market Analysis',
  'Tendências e movimentações do mercado tech analisadas por especialistas': 'Tech market trends and movements analyzed by experts',
  'Cases de Sucesso': 'Success Cases',
  'Histórias de startups e empresas que estão inovando no Brasil e no mundo': 'Stories of startups and companies innovating in Brazil and worldwide',
  'Ferramentas e Recursos': 'Tools and Resources',
  'Descubra as melhores ferramentas para aumentar sua produtividade': 'Discover the best tools to boost your productivity',
  'Oportunidades': 'Opportunities',
  'Vagas, eventos e oportunidades exclusivas para nossa comunidade': 'Jobs, events, and exclusive opportunities for our community',
  'Últimas Edições': 'Latest Editions',
  'Veja o que nossos leitores estão recebendo': 'See what our readers are receiving',
  'Líderes que Já Acompanham': 'Leaders Who Already Follow',
  'Profissionais de empresas como': 'Professionals from companies like',
  'Não Perca as Próximas Edições': 'Don\'t Miss the Next Editions',
  'Toda segunda-feira, direto na sua caixa de entrada': 'Every Monday, straight to your inbox',
  'Inscrito com sucesso! Bem-vindo à comunidade.': 'Successfully subscribed! Welcome to the community.',

  // Waitlist Template
  'Algo Grande Está Chegando': 'Something Big is Coming',
  'Estamos criando': 'We are creating',
  'a próxima revolução': 'the next revolution',
  'em produtividade': 'in productivity',
  'Seja um dos primeiros a experimentar. Vagas limitadas para acesso antecipado.':
    'Be one of the first to experience it. Limited spots for early access.',
  'Fique por dentro do que vem por aí': 'Stay tuned for what\'s coming',
  'O Que Estamos Construindo': 'What We Are Building',
  'Um produto que vai mudar a forma como você trabalha': 'A product that will change the way you work',
  'IA Avançada': 'Advanced AI',
  'Inteligência artificial que realmente entende seu contexto': 'Artificial intelligence that truly understands your context',
  'Integração Total': 'Full Integration',
  'Conecta com todas as ferramentas que você já usa': 'Connects with all the tools you already use',
  'Privacidade First': 'Privacy First',
  'Seus dados são seus. Sempre.': 'Your data is yours. Always.',
  'na lista de espera': 'on the waitlist',
  'dias para o lançamento': 'days until launch',
  'Você está na lista! Entraremos em contato em breve.': 'You\'re on the list! We\'ll be in touch soon.',

  // Coaching Template
  'Transforme sua carreira com': 'Transform your career with',
  'mentoria especializada': 'specialized mentoring',
  'Metodologia comprovada para profissionais que querem acelerar resultados e alcançar o próximo nível na carreira.':
    'Proven methodology for professionals who want to accelerate results and reach the next level in their career.',
  'profissionais mentorados': 'professionals mentored',
  'de satisfação': 'satisfaction rate',
  'aumento médio de renda': 'average income increase',
  'Áreas de Mentoria': 'Mentoring Areas',
  'Programas personalizados para cada fase da sua jornada': 'Customized programs for each phase of your journey',
  'Liderança': 'Leadership',
  'Desenvolva habilidades de liderança e gestão de equipes de alta performance':
    'Develop leadership skills and high-performance team management',
  'Carreira': 'Career',
  'Planejamento estratégico para transições e crescimento profissional':
    'Strategic planning for transitions and professional growth',
  'Negócios': 'Business',
  'Estruturação e escala do seu próprio negócio ou consultoria':
    'Structuring and scaling your own business or consultancy',
  'Performance': 'Performance',
  'Técnicas e ferramentas para maximizar sua produtividade e resultados':
    'Techniques and tools to maximize your productivity and results',
  'Como Funciona': 'How It Works',
  'Diagnóstico Inicial': 'Initial Diagnosis',
  'Análise completa do seu momento atual e objetivos': 'Complete analysis of your current situation and goals',
  'Plano Personalizado': 'Personalized Plan',
  'Estratégia customizada para seus objetivos específicos': 'Customized strategy for your specific goals',
  'Sessões Semanais': 'Weekly Sessions',
  'Encontros online com acompanhamento contínuo': 'Online meetings with continuous follow-up',
  'Resultados Mensuráveis': 'Measurable Results',
  'Métricas claras de progresso e evolução': 'Clear progress and evolution metrics',
  'Depoimentos': 'Testimonials',
  'O que dizem os profissionais que já passaram pelo programa': 'What professionals who have been through the program say',
  'Agende uma Sessão Gratuita': 'Schedule a Free Session',
  'Conversa inicial sem compromisso para entender seus objetivos': 'Initial conversation with no obligation to understand your goals',
  'Sessão agendada! Você receberá um e-mail com os detalhes.': 'Session scheduled! You will receive an email with the details.',

  // SaaS Template
  'Automatize seu fluxo de trabalho com': 'Automate your workflow with',
  'inteligência artificial': 'artificial intelligence',
  'A plataforma all-in-one que empresas modernas usam para escalar operações sem aumentar custos.':
    'The all-in-one platform that modern companies use to scale operations without increasing costs.',
  'times já usam': 'teams already use',
  'horas economizadas/mês': 'hours saved/month',
  'avaliação média': 'average rating',
  'Funcionalidades': 'Features',
  'Tudo que você precisa em uma única plataforma': 'Everything you need in a single platform',
  'Automações': 'Automations',
  'Crie fluxos automatizados sem código em minutos': 'Create automated flows without code in minutes',
  'Relatórios': 'Reports',
  'Dashboards em tempo real com insights acionáveis': 'Real-time dashboards with actionable insights',
  'Integrações': 'Integrations',
  'Conecte com mais de 200 ferramentas populares': 'Connect with over 200 popular tools',
  'Segurança': 'Security',
  'Dados protegidos com criptografia de ponta': 'Data protected with cutting-edge encryption',
  'API Completa': 'Complete API',
  'Documentação completa para desenvolvedores': 'Complete documentation for developers',
  'Colaboração': 'Collaboration',
  'Trabalhe em equipe com permissões granulares': 'Work as a team with granular permissions',
  'Planos e Preços': 'Plans and Pricing',
  'Escolha o plano ideal para seu momento': 'Choose the ideal plan for your moment',
  'Ideal para freelancers e pequenos projetos': 'Ideal for freelancers and small projects',
  'Para equipes em crescimento': 'For growing teams',
  'Para empresas que precisam de mais': 'For companies that need more',
  'Comece Grátis': 'Start Free',
  'Começar Teste Grátis': 'Start Free Trial',
  'Falar com Vendas': 'Talk to Sales',
  'por usuário/mês': 'per user/month',
  'automações/mês': 'automations/month',
  'usuários': 'users',
  'integrações': 'integrations',
  'Suporte por email': 'Email support',
  'Suporte prioritário': 'Priority support',
  'Gerente dedicado': 'Dedicated manager',
  'SLA garantido': 'Guaranteed SLA',
  'Ilimitadas': 'Unlimited',
  'Ilimitados': 'Unlimited',
  'O Que Nossos Clientes Dizem': 'What Our Customers Say',
  'Empresas reais com resultados reais': 'Real companies with real results',
  'Dúvidas comuns sobre nossa plataforma': 'Common questions about our platform',
  'Posso cancelar a qualquer momento?': 'Can I cancel at any time?',
  'Sim! Não existe fidelidade. Cancele quando quiser sem taxas adicionais.':
    'Yes! There is no commitment. Cancel whenever you want without additional fees.',
  'Existe teste grátis?': 'Is there a free trial?',
  'Sim, oferecemos 7 dias de teste grátis com todas as funcionalidades do plano Pro.':
    'Yes, we offer a 7-day free trial with all Pro plan features.',
  'Como funciona o suporte?': 'How does support work?',
  'Oferecemos suporte por chat e email. Planos Pro e Enterprise têm suporte prioritário com tempo de resposta garantido.':
    'We offer chat and email support. Pro and Enterprise plans have priority support with guaranteed response time.',
  'Meus dados estão seguros?': 'Is my data secure?',
  'Sim! Usamos criptografia AES-256, backups diários e somos certificados SOC 2 Type II.':
    'Yes! We use AES-256 encryption, daily backups and are SOC 2 Type II certified.',
  'Pronto Para Começar?': 'Ready to Get Started?',
  'Junte-se a milhares de empresas que já transformaram suas operações': 'Join thousands of companies that have already transformed their operations',
  'Teste 7 dias grátis. Sem cartão de crédito.': '7-day free trial. No credit card required.',

  // Webinar Template
  '🎥 Webinar Gratuito': '🎥 Free Webinar',
  'Aprenda a criar': 'Learn how to create',
  'negócios lucrativos': 'profitable businesses',
  'do zero': 'from scratch',
  'Descubra o método que já gerou mais de R$10 milhões em vendas para nossos alunos.':
    'Discover the method that has already generated over $10 million in sales for our students.',
  'Data e Hora': 'Date and Time',
  'Quinta-feira': 'Thursday',
  '20h (Horário de Brasília)': '8 PM (EST)',
  'O Que Você Vai Aprender:': 'What You Will Learn:',
  'O passo a passo para validar sua ideia de negócio rapidamente': 'The step-by-step to quickly validate your business idea',
  'Como criar uma oferta irresistível que vende sozinha': 'How to create an irresistible offer that sells itself',
  'Estratégias de tráfego que funcionam em 2024': 'Traffic strategies that work in 2024',
  'Como escalar para 6 dígitos sem burnout': 'How to scale to 6 figures without burnout',
  'VAGAS LIMITADAS': 'LIMITED SPOTS',
  'pessoas já confirmadas': 'people already confirmed',
  'Seu Mentor': 'Your Mentor',
  'Empreendedor serial e mentor de negócios': 'Serial entrepreneur and business mentor',
  'Inscrição confirmada! Você receberá os detalhes por e-mail.': 'Registration confirmed! You will receive the details by email.',

  // Restaurant Template
  'Sabores que': 'Flavors that',
  'encantam': 'enchant',
  'Uma experiência gastronômica única no coração da cidade. Reserve sua mesa e descubra.':
    'A unique gastronomic experience in the heart of the city. Book your table and discover.',
  'Ver Cardápio': 'View Menu',
  'Reservar Mesa': 'Book Table',
  'Nosso Cardápio': 'Our Menu',
  'Pratos preparados com ingredientes selecionados e muito amor': 'Dishes prepared with selected ingredients and lots of love',
  'Entradas': 'Starters',
  'Principais': 'Main Courses',
  'Sobremesas': 'Desserts',
  'Bebidas': 'Drinks',
  'Bruschetta Clássica': 'Classic Bruschetta',
  'Tomate, manjericão e azeite extra virgem': 'Tomato, basil and extra virgin olive oil',
  'Carpaccio': 'Carpaccio',
  'Carne bovina com rúcula e parmesão': 'Beef with arugula and parmesan',
  'Risoto de Funghi': 'Mushroom Risotto',
  'Mix de cogumelos frescos e parmesão': 'Mix of fresh mushrooms and parmesan',
  'Filé ao Molho': 'Fillet with Sauce',
  'Filé mignon com molho de vinho': 'Filet mignon with wine sauce',
  'Tiramisu': 'Tiramisu',
  'Receita tradicional italiana': 'Traditional Italian recipe',
  'Petit Gâteau': 'Lava Cake',
  'Chocolate belga com sorvete': 'Belgian chocolate with ice cream',
  'Faça Sua Reserva': 'Make Your Reservation',
  'Garantia de mesa disponível': 'Table availability guaranteed',
  'Data': 'Date',
  'Horário': 'Time',
  'Observações': 'Notes',
  'Reserva confirmada! Aguardamos você.': 'Reservation confirmed! We look forward to seeing you.',
  'Delivery': 'Delivery',
  'Peça pelo app e receba em casa': 'Order on the app and receive at home',
  'Avaliação no Google': 'Google Rating',
  'Nosso Ambiente': 'Our Ambiance',
  'Horário de Funcionamento': 'Opening Hours',
  'Segunda a Sexta': 'Monday to Friday',
  'Sábados e Domingos': 'Saturdays and Sundays',
  'Endereço': 'Address',

  // App Download Template
  'Sua vida mais': 'Your life more',
  'organizada': 'organized',
  'O app que vai transformar sua produtividade. Simples, rápido e intuitivo.':
    'The app that will transform your productivity. Simple, fast and intuitive.',
  'downloads': 'downloads',
  'nota na App Store': 'App Store rating',
  'países': 'countries',
  'Por Que Escolher Nosso App?': 'Why Choose Our App?',
  'Recursos poderosos em uma interface simples': 'Powerful features in a simple interface',
  'Sincronização': 'Sync',
  'Todos seus dispositivos sempre atualizados': 'All your devices always updated',
  'Offline': 'Offline',
  'Funciona mesmo sem internet': 'Works even without internet',
  'Seguro': 'Secure',
  'Criptografia de ponta a ponta': 'End-to-end encryption',
  'Rápido': 'Fast',
  'Interface leve e responsiva': 'Light and responsive interface',
  'Veja o App em Ação': 'See the App in Action',
  'Interface intuitiva que você vai amar usar': 'Intuitive interface you\'ll love to use',
  'Avaliações': 'Reviews',
  'O que nossos usuários estão dizendo': 'What our users are saying',
  'Baixe Grátis': 'Download Free',
  'Disponível para iOS e Android': 'Available for iOS and Android',

  // Course Template
  'Domine': 'Master',
  'Marketing Digital': 'Digital Marketing',
  'em 12 semanas': 'in 12 weeks',
  'O curso mais completo do Brasil com certificação reconhecida pelo mercado.':
    'The most complete course in Brazil with market-recognized certification.',
  'alunos formados': 'graduated students',
  'aulas práticas': 'practical classes',
  'Currículo completo e atualizado com as últimas tendências': 'Complete curriculum updated with the latest trends',
  'Módulo 1': 'Module 1',
  'Fundamentos e Estratégia': 'Fundamentals and Strategy',
  'Módulo 2': 'Module 2',
  'Tráfego Pago': 'Paid Traffic',
  'Módulo 3': 'Module 3',
  'Copywriting': 'Copywriting',
  'Módulo 4': 'Module 4',
  'Automação': 'Automation',
  'Módulo 5': 'Module 5',
  'Analytics': 'Analytics',
  'Módulo 6': 'Module 6',
  'Projeto Final': 'Final Project',
  'Bônus Inclusos': 'Included Bonuses',
  'Acesso vitalício a todos os materiais': 'Lifetime access to all materials',
  'Comunidade Exclusiva': 'Exclusive Community',
  'Certificado Reconhecido': 'Recognized Certificate',
  'Mentorias ao Vivo': 'Live Mentoring Sessions',
  'Templates Profissionais': 'Professional Templates',
  'Investimento': 'Investment',
  'por apenas': 'for only',
  'ou 12x de': 'or 12x of',
  'Garantia de 7 dias': '7-day guarantee',
  'Se não gostar, devolvemos seu dinheiro': 'If you don\'t like it, we refund your money',
  'Matrícula realizada! Acesse seu email para começar.': 'Enrollment complete! Check your email to get started.',

  // Portfolio Template
  'Olá, eu sou': 'Hi, I\'m',
  'Designer criativo especializado em': 'Creative designer specialized in',
  'branding e identidade visual': 'branding and visual identity',
  'Transformo ideias em experiências visuais memoráveis.': 'I transform ideas into memorable visual experiences.',
  'Projetos': 'Projects',
  'Clientes': 'Clients',
  'Anos de XP': 'Years of XP',
  'Meus Trabalhos': 'My Work',
  'Projetos selecionados que representam minha visão e estilo': 'Selected projects that represent my vision and style',
  'Ver Projeto': 'View Project',
  'Branding': 'Branding',
  'Web Design': 'Web Design',
  'UI/UX': 'UI/UX',
  'Serviços': 'Services',
  'Como posso ajudar seu projeto': 'How I can help your project',
  'Identidade Visual': 'Visual Identity',
  'Logos, cores e tipografia que representam sua marca': 'Logos, colors and typography that represent your brand',
  'Sites e Landing Pages': 'Websites and Landing Pages',
  'Design moderno e focado em conversão': 'Modern design focused on conversion',
  'Interfaces de Apps': 'App Interfaces',
  'UX/UI para aplicativos mobile e web': 'UX/UI for mobile and web applications',
  'Vamos Trabalhar Juntos?': 'Shall We Work Together?',
  'Conte-me sobre seu projeto': 'Tell me about your project',
  'Tipo de projeto': 'Project type',
  'Conte mais sobre o projeto': 'Tell me more about the project',
  'Mensagem enviada! Retorno em até 24h.': 'Message sent! Response within 24h.',

  // Agency Template
  'Criamos': 'We create',
  'experiências digitais': 'digital experiences',
  'que convertem': 'that convert',
  'Somos uma agência full-service focada em resultados mensuráveis para nossos clientes.':
    'We are a full-service agency focused on measurable results for our clients.',
  'projetos entregues': 'projects delivered',
  'clientes ativos': 'active clients',
  'ROI médio': 'average ROI',
  'Nossos Serviços': 'Our Services',
  'Soluções completas para sua presença digital': 'Complete solutions for your digital presence',
  'Estratégia Digital': 'Digital Strategy',
  'Planejamento completo para sua presença online': 'Complete planning for your online presence',
  'Desenvolvimento': 'Development',
  'Sites, apps e sistemas sob medida': 'Websites, apps and custom systems',
  'Identidade visual que destaca sua marca': 'Visual identity that highlights your brand',
  'Tráfego pago e otimização de conversão': 'Paid traffic and conversion optimization',
  'Resultados reais de clientes reais': 'Real results from real clients',
  'Aumento em vendas': 'Increase in sales',
  'Redução no CAC': 'Reduction in CAC',
  'Leads qualificados': 'Qualified leads',
  'Nosso Time': 'Our Team',
  'Especialistas dedicados ao seu sucesso': 'Specialists dedicated to your success',
  'Vamos Crescer Juntos': 'Let\'s Grow Together',
  'Agende uma conversa sem compromisso': 'Schedule a no-obligation conversation',
  'Mensagem recebida! Entraremos em contato em breve.': 'Message received! We\'ll be in touch soon.',

  // E-commerce Product Template
  'LANÇAMENTO': 'LAUNCH',
  'O produto que você estava esperando': 'The product you\'ve been waiting for',
  'Descrição curta e impactante do produto que destaca seus principais benefícios.':
    'Short and impactful product description that highlights its main benefits.',
  'ou em até 12x sem juros': 'or up to 12x interest-free',
  'Frete grátis para todo Brasil': 'Free shipping nationwide',
  'Entrega em até 7 dias úteis': 'Delivery within 7 business days',
  'Garantia de 1 ano': '1-year warranty',
  'Troca fácil em 30 dias': 'Easy exchange within 30 days',
  'Características': 'Characteristics',
  'Material Premium': 'Premium Material',
  'Design Exclusivo': 'Exclusive Design',
  'Durabilidade': 'Durability',
  'Conforto': 'Comfort',
  'compras realizadas': 'purchases made',
  'avaliações positivas': 'positive reviews',
  'Avaliações dos Clientes': 'Customer Reviews',
  'Há 2 dias': '2 days ago',
  'Há 1 semana': '1 week ago',
  'Há 3 semanas': '3 weeks ago',

  // Clinic Template
  'Cuidamos da sua': 'We take care of your',
  'saúde': 'health',
  'com excelência': 'with excellence',
  'Atendimento humanizado com profissionais qualificados e tecnologia de ponta.':
    'Humanized care with qualified professionals and cutting-edge technology.',
  'pacientes atendidos': 'patients served',
  'especialidades': 'specialties',
  'convênios aceitos': 'insurance plans accepted',
  'Especialidades': 'Specialties',
  'Equipe multidisciplinar para cuidar de você': 'Multidisciplinary team to take care of you',
  'Clínica Geral': 'General Practice',
  'Atendimento inicial e acompanhamento geral': 'Initial care and general follow-up',
  'Cardiologia': 'Cardiology',
  'Cuidados especializados do coração': 'Specialized heart care',
  'Dermatologia': 'Dermatology',
  'Saúde e estética da pele': 'Skin health and aesthetics',
  'Ortopedia': 'Orthopedics',
  'Tratamento de ossos e articulações': 'Bone and joint treatment',
  'Nossa Estrutura': 'Our Facility',
  'Ambiente moderno e acolhedor': 'Modern and welcoming environment',
  'Agende sua Consulta': 'Schedule Your Appointment',
  'Horários flexíveis e atendimento online disponível': 'Flexible hours and online care available',
  'Especialidade': 'Specialty',
  'Selecione': 'Select',
  'Preferência de horário': 'Time preference',
  'Manhã': 'Morning',
  'Tarde': 'Afternoon',
  'Consulta agendada! Entraremos em contato para confirmar.': 'Appointment scheduled! We\'ll contact you to confirm.',

  // Real Estate Template
  'Encontre o': 'Find the',
  'imóvel dos seus sonhos': 'property of your dreams',
  'As melhores opções de imóveis em localizações privilegiadas.': 'The best property options in prime locations.',
  'imóveis disponíveis': 'properties available',
  'negócios fechados': 'deals closed',
  'corretores especializados': 'specialized agents',
  'Imóveis em Destaque': 'Featured Properties',
  'Seleção exclusiva das melhores oportunidades': 'Exclusive selection of the best opportunities',
  'quartos': 'bedrooms',
  'banheiros': 'bathrooms',
  'vagas': 'parking spots',
  'Apartamento': 'Apartment',
  'Casa': 'House',
  'Cobertura': 'Penthouse',
  'Por Que Nos Escolher': 'Why Choose Us',
  'Mais de 20 anos de experiência no mercado': 'Over 20 years of market experience',
  'Atendimento Personalizado': 'Personalized Service',
  'Corretores dedicados ao seu perfil': 'Agents dedicated to your profile',
  'Financiamento Facilitado': 'Easy Financing',
  'Parceria com os principais bancos': 'Partnership with major banks',
  'Documentação Completa': 'Complete Documentation',
  'Suporte em toda burocracia': 'Support with all paperwork',
  'Pós-Venda': 'After-Sales',
  'Acompanhamento após a compra': 'Follow-up after purchase',
  'Agende uma Visita': 'Schedule a Visit',
  'Conheça pessoalmente os imóveis': 'Visit the properties in person',
  'Tipo de imóvel': 'Property type',
  'Faixa de preço': 'Price range',
  'Região de interesse': 'Region of interest',
  'Até R$ 500 mil': 'Up to $500k',
  'R$ 500 mil - R$ 1 milhão': '$500k - $1 million',
  'Acima de R$ 1 milhão': 'Over $1 million',
  'Contato recebido! Um corretor entrará em contato.': 'Contact received! An agent will be in touch.',

  // Fitness Template
  'Transforme seu': 'Transform your',
  'corpo': 'body',
  'e sua mente': 'and your mind',
  'Academia completa com profissionais certificados para você alcançar seus objetivos.':
    'Complete gym with certified professionals for you to achieve your goals.',
  'alunos matriculados': 'enrolled students',
  'de área': 'of area',
  'modalidades': 'modalities',
  'Modalidades': 'Modalities',
  'Treinos para todos os objetivos': 'Workouts for all goals',
  'Musculação': 'Weight Training',
  'Equipamentos modernos e personal trainer': 'Modern equipment and personal trainer',
  'CrossFit': 'CrossFit',
  'Treinos funcionais de alta intensidade': 'High-intensity functional training',
  'Yoga': 'Yoga',
  'Equilíbrio corpo e mente': 'Body and mind balance',
  'Spinning': 'Spinning',
  'Aulas energéticas em grupo': 'Energetic group classes',
  'Pilates': 'Pilates',
  'Fortalecimento e flexibilidade': 'Strengthening and flexibility',
  'Natação': 'Swimming',
  'Piscina semi-olímpica aquecida': 'Heated semi-Olympic pool',
  'Equipamentos de última geração': 'State-of-the-art equipment',
  'Planos': 'Plans',
  'Escolha o ideal para você': 'Choose the ideal for you',
  'Básico': 'Basic',
  'Acesso à musculação': 'Weight room access',
  'Horário comercial': 'Business hours',
  'Completo': 'Complete',
  'Todas as modalidades': 'All modalities',
  'Acesso 24h': '24h access',
  'Personal incluso': 'Personal trainer included',
  'Premium': 'Premium',
  'Tudo do Completo': 'Everything from Complete',
  'Nutricionista': 'Nutritionist',
  'Avaliação mensal': 'Monthly evaluation',
  'Armário exclusivo': 'Exclusive locker',
  'Assinar Plano': 'Subscribe to Plan',
  'Matrícula realizada! Bem-vindo à família.': 'Enrollment complete! Welcome to the family.',

  // Podcast Template
  'Ouça histórias que': 'Listen to stories that',
  'inspiram': 'inspire',
  'Conversas com pessoas extraordinárias sobre carreira, negócios e vida.':
    'Conversations with extraordinary people about career, business and life.',
  'episódios': 'episodes',
  'ouvintes/mês': 'listeners/month',
  'Últimos Episódios': 'Latest Episodes',
  'Disponível nas principais plataformas': 'Available on major platforms',
  'Ouça no Spotify': 'Listen on Spotify',
  'Ouça no Apple': 'Listen on Apple',
  'Episódio': 'Episode',
  'duração': 'duration',
  'Como Construir um Negócio de Sucesso': 'How to Build a Successful Business',
  'Lições de Empreendedorismo': 'Entrepreneurship Lessons',
  'O Futuro do Trabalho Remoto': 'The Future of Remote Work',
  'Plataformas': 'Platforms',
  'Ouça onde preferir': 'Listen wherever you prefer',
  'O Apresentador': 'The Host',
  'Jornalista e empreendedor': 'Journalist and entrepreneur',
  'Não Perca Nenhum Episódio': 'Don\'t Miss Any Episode',
  'Receba os novos episódios no seu email': 'Receive new episodes in your email',
  'Inscrito! Você receberá os novos episódios.': 'Subscribed! You\'ll receive new episodes.',

  // Event Template
  'O maior evento de': 'The biggest',
  'tecnologia': 'technology',
  'do Brasil': 'event in Brazil',
  'Dois dias de conteúdo, networking e experiências que vão transformar sua carreira.':
    'Two days of content, networking and experiences that will transform your career.',
  'participantes esperados': 'expected participants',
  'palestrantes': 'speakers',
  'Programação': 'Schedule',
  'Dia 1': 'Day 1',
  'Dia 2': 'Day 2',
  'Keynote de Abertura': 'Opening Keynote',
  'Painel de Inovação': 'Innovation Panel',
  'Workshops Práticos': 'Practical Workshops',
  'Networking': 'Networking',
  'Palestrantes': 'Speakers',
  'Líderes e experts do mercado': 'Market leaders and experts',
  'Ingressos': 'Tickets',
  'Garanta sua vaga': 'Secure your spot',
  'Early Bird': 'Early Bird',
  'Oferta por tempo limitado': 'Limited time offer',
  'Regular': 'Regular',
  'Preço normal': 'Regular price',
  'VIP': 'VIP',
  'Experiência exclusiva': 'Exclusive experience',
  'Acesso a todas palestras': 'Access to all talks',
  'Coffee break incluso': 'Coffee break included',
  'Certificado digital': 'Digital certificate',
  'Área VIP exclusiva': 'Exclusive VIP area',
  'Jantar com palestrantes': 'Dinner with speakers',
  'Mentoria individual': 'Individual mentoring',
  'Ingresso garantido! Verifique seu email.': 'Ticket secured! Check your email.',

  // Book Launch Template
  'Novo livro de': 'New book by',
  'Uma jornada transformadora sobre liderança e propósito.':
    'A transformative journey about leadership and purpose.',
  'páginas': 'pages',
  'capítulos': 'chapters',
  'exemplares vendidos': 'copies sold',
  'Sobre o Livro': 'About the Book',
  'O Autor': 'The Author',
  'Onde Comprar': 'Where to Buy',
  'Disponível nas principais livrarias': 'Available at major bookstores',

  // Black Friday Template
  'BLACK FRIDAY': 'BLACK FRIDAY',
  'Até 70% OFF': 'Up to 70% OFF',
  'As melhores ofertas do ano por tempo limitado!': 'The best deals of the year for a limited time!',
  'Oferta termina em:': 'Offer ends in:',
  'Ofertas Imperdíveis': 'Unmissable Deals',
  'Estoque limitado!': 'Limited stock!',
  'economia': 'savings',

  // Appointment Template
  'Agende seu': 'Schedule your',
  'horário': 'appointment',
  'online': 'online',
  'Agendamento rápido e fácil, sem filas e sem espera.': 'Quick and easy scheduling, no lines or waiting.',
  'agendamentos realizados': 'appointments made',
  'profissionais': 'professionals',
  'Serviços Disponíveis': 'Available Services',
  'Selecione o serviço desejado': 'Select the desired service',
  'Consulta': 'Consultation',
  'Avaliação': 'Evaluation',
  'Procedimento': 'Procedure',
  'Retorno': 'Follow-up',
  'Selecione o Horário': 'Select Time',
  'Horários disponíveis para': 'Available times for',
  'Confirmar Agendamento': 'Confirm Appointment',
  'Horário agendado com sucesso!': 'Appointment successfully scheduled!',

  // PetShop Template
  'Cuidamos do seu': 'We take care of your',
  'melhor amigo': 'best friend',
  'Petshop completo com os melhores produtos e serviços para seu pet.':
    'Complete pet shop with the best products and services for your pet.',
  'clientes felizes': 'happy customers',
  'produtos': 'products',
  'serviços': 'services',
  'Tudo que seu pet precisa em um só lugar': 'Everything your pet needs in one place',
  'Banho e Tosa': 'Bath and Grooming',
  'Profissionais carinhosos e experientes': 'Caring and experienced professionals',
  'Veterinário': 'Veterinarian',
  'Consultas e tratamentos especializados': 'Consultations and specialized treatments',
  'Hospedagem': 'Boarding',
  'Hotel pet com todo conforto': 'Pet hotel with all comfort',
  'Pet Shop': 'Pet Shop',
  'Rações, acessórios e muito mais': 'Pet food, accessories and much more',
  'Produtos em Destaque': 'Featured Products',
  'Os preferidos dos nossos clientes': 'Our customers\' favorites',
  'Agende um Serviço': 'Schedule a Service',
  'Escolha o melhor horário para seu pet': 'Choose the best time for your pet',
  'Serviço': 'Service',
  'Nome do pet': 'Pet name',
  'Espécie': 'Species',
  'Cachorro': 'Dog',
  'Gato': 'Cat',
  'Outro': 'Other',
  'Agendamento confirmado para seu pet!': 'Appointment confirmed for your pet!',

  // Common section titles
  'Sobre': 'About',
  'FAQ': 'FAQ',
  'Preços': 'Pricing',
  'Blog': 'Blog',
  'Equipe': 'Team',
  'Parceiros': 'Partners',
  'Localização': 'Location',
  'Redes Sociais': 'Social Media',
  'Links Úteis': 'Useful Links',
  'Suporte': 'Support',
  'Central de Ajuda': 'Help Center',
  'Trabalhe Conosco': 'Work With Us',

  // Newsletter Template
  'Mais de 25.000 leitores semanais': 'Over 25,000 weekly readers',
  'Insights de': 'Insights on',
  'negócios': 'business',
  'direto no seu inbox': 'straight to your inbox',
  'Toda terça-feira, enviamos as melhores estratégias, tendências e análises do mercado. Leitura de 5 minutos que vale horas de pesquisa.':
    'Every Tuesday, we send the best strategies, trends, and market analysis. A 5-minute read worth hours of research.',
  'Inscrever-se Grátis': 'Subscribe Free',
  '100% gratuito': '100% free',
  'Sem spam, prometemos': 'No spam, we promise',
  'Assinantes': 'Subscribers',
  'Taxa de abertura': 'Open rate',
  'Edições enviadas': 'Editions sent',
  'Avaliação média': 'Average rating',
  'Conteúdo curado semanalmente para impulsionar seus resultados': 'Weekly curated content to boost your results',
  'Análises Exclusivas': 'Exclusive Analysis',
  'Dados e insights aprofundados sobre tendências de mercado que você não encontra em outro lugar.':
    'In-depth data and insights on market trends you won\'t find anywhere else.',
  'Estratégias Práticas': 'Practical Strategies',
  'Táticas testadas e aprovadas que você pode implementar imediatamente no seu negócio.':
    'Tested and proven tactics you can implement immediately in your business.',
  'Curadoria Premium': 'Premium Curation',
  'Selecionamos apenas o melhor conteúdo, economizando horas do seu tempo toda semana.':
    'We select only the best content, saving you hours every week.',
  'Acesso à comunidade exclusiva de empreendedores e profissionais.':
    'Access to exclusive community of entrepreneurs and professionals.',
  'Confira o que nossos leitores estão recebendo': 'See what our readers are receiving',
  'Edição': 'Edition',
  'Ler agora': 'Read now',
  'O Que Nossos Leitores Dizem': 'What Our Readers Say',
  'Líderes que Confiam em Nós': 'Leaders Who Trust Us',
  'Profissionais de empresas como Google, Meta, Nubank e iFood leem nossa newsletter toda semana.':
    'Professionals from companies like Google, Meta, Nubank, and iFood read our newsletter every week.',
  'Toda terça-feira, direto no seu inbox': 'Every Tuesday, straight to your inbox',

  // Waitlist Template
  'SuaMarca': 'YourBrand',
  'SuaEmpresa': 'YourCompany',
  'Em desenvolvimento': 'In development',
  'Em breve': 'Coming soon',
  'Algo incrível': 'Something amazing',
  'está chegando': 'is coming',
  'Estamos trabalhando em algo revolucionário. Entre na lista de espera para ter acesso antecipado e benefícios exclusivos de fundador.':
    'We\'re working on something revolutionary. Join the waitlist for early access and exclusive founder benefits.',
  'Entrar na Lista': 'Join the List',
  'Na lista': 'On the list',
  'Dias': 'Days',
  'Desconto': 'Discount',
  'Voce esta na lista! Enviaremos novidades em primeira mao.': 'You\'re on the list! We\'ll send you news first.',

  // Coaching Template
  'Mentoria de Alto Impacto': 'High Impact Mentoring',
  'Acelere sua carreira com': 'Accelerate your career with',
  'mentoria personalizada': 'personalized mentoring',
  'Desenvolva habilidades de liderança, tome decisões estratégicas e alcance resultados extraordinários com acompanhamento individualizado.':
    'Develop leadership skills, make strategic decisions, and achieve extraordinary results with individualized guidance.',
  'Agendar Sessão Gratuita': 'Schedule Free Session',
  'Ver Programas': 'View Programs',
  'horas de mentoria': 'hours of mentoring',
  'Programas de Mentoria': 'Mentoring Programs',
  'Escolha o programa ideal para seu momento de carreira': 'Choose the ideal program for your career stage',
  'Mentoria Individual': 'Individual Mentoring',
  'Sessões 1:1 focadas nos seus objetivos específicos com plano de ação personalizado.':
    '1:1 sessions focused on your specific goals with a personalized action plan.',
  'Mentoria em Grupo': 'Group Mentoring',
  'Aprenda com uma turma seleta de profissionais em sessões colaborativas.':
    'Learn with a select group of professionals in collaborative sessions.',
  'Imersão Intensiva': 'Intensive Immersion',
  'Programa intensivo de transformação com resultados acelerados em 30 dias.':
    'Intensive transformation program with accelerated results in 30 days.',
  '/sessão': '/session',
  '/programa': '/program',
  'Meu Método': 'My Method',
  'Um processo estruturado para garantir sua evolução': 'A structured process to ensure your evolution',
  'Diagnóstico Profundo': 'Deep Diagnosis',
  'Análise completa do seu momento atual, desafios e objetivos de carreira.':
    'Complete analysis of your current moment, challenges, and career goals.',
  'Plano Estratégico': 'Strategic Plan',
  'Desenvolvimento de roadmap personalizado com metas claras e mensuráveis.':
    'Development of personalized roadmap with clear and measurable goals.',
  'Execução Acompanhada': 'Guided Execution',
  'Implementação com suporte contínuo e ajustes em tempo real.':
    'Implementation with continuous support and real-time adjustments.',
  'Evolução Contínua': 'Continuous Evolution',
  'Análise de resultados e otimização constante do processo.':
    'Results analysis and constant process optimization.',
  'Quem Sou Eu': 'Who I Am',
  'Sua mentora': 'Your mentor',
  'Executiva com mais de 15 anos de experiência em empresas Fortune 500. Especialista em desenvolvimento de liderança e gestão de carreira.':
    'Executive with over 15 years of experience in Fortune 500 companies. Specialist in leadership development and career management.',
  'MBA em Liderança': 'MBA in Leadership',
  'Coach Certificada ICF': 'ICF Certified Coach',
  'Palestrante Internacional': 'International Speaker',
  'Autora Best-seller': 'Best-seller Author',
  'Resultados dos Mentorados': 'Mentees Results',
  'Histórias reais de transformação': 'Real transformation stories',
  'Resultado alcançado': 'Result achieved',
  'Dúvidas Frequentes': 'Frequently Asked Questions',
  'Tire suas dúvidas sobre a mentoria': 'Clear your doubts about mentoring',
  'Como funciona a mentoria individual?': 'How does individual mentoring work?',
  'As sessões são realizadas por videoconferência, com duração de 1 hora. Você terá acesso a materiais exclusivos e suporte via WhatsApp entre as sessões.':
    'Sessions are held via video conference, lasting 1 hour. You\'ll have access to exclusive materials and WhatsApp support between sessions.',
  'Qual o investimento?': 'What is the investment?',
  'O valor varia de acordo com o programa escolhido. Agende uma sessão gratuita para conhecer as opções e encontrar a melhor para você.':
    'The value varies according to the chosen program. Schedule a free session to learn about the options and find the best one for you.',
  'Vou ter resultados?': 'Will I get results?',
  'Sim! Nossos mentorados relatam resultados significativos em média em 90 dias. A mentoria inclui garantia de satisfação.':
    'Yes! Our mentees report significant results on average within 90 days. Mentoring includes a satisfaction guarantee.',
  'Pronto para Transformar sua Carreira?': 'Ready to Transform Your Career?',
  'Agende uma sessão gratuita de diagnóstico': 'Schedule a free diagnostic session',
  'Sessão agendada! Você receberá os detalhes por e-mail.': 'Session scheduled! You\'ll receive details by email.',

  // Common template texts
  '© 2025': '© 2025',
  'Todos os direitos reservados.': 'All rights reserved.',
  'Termos de Uso': 'Terms of Use',

  // SaaS Template additional
  'Simplifique seu trabalho com': 'Simplify your work with',
  'automação inteligente': 'smart automation',
  'A plataforma all-in-one que transforma a forma como sua equipe trabalha. Mais produtividade, menos complexidade.':
    'The all-in-one platform that transforms how your team works. More productivity, less complexity.',
  'Começar Gratuitamente': 'Start for Free',
  'Assistir Demo': 'Watch Demo',
  'times ativos': 'active teams',
  'uptime garantido': 'guaranteed uptime',
  'suporte 24/7': '24/7 support',
  'Por Que Escolher Nossa Plataforma?': 'Why Choose Our Platform?',
  'Recursos pensados para maximizar a produtividade da sua equipe': 'Features designed to maximize your team\'s productivity',
  'Automação de Processos': 'Process Automation',
  'Automatize tarefas repetitivas e libere tempo para o que realmente importa.':
    'Automate repetitive tasks and free up time for what really matters.',
  'Colaboração em Tempo Real': 'Real-Time Collaboration',
  'Trabalhe em conjunto com sua equipe, não importa onde estejam.':
    'Work together with your team, no matter where they are.',
  'Integrações Poderosas': 'Powerful Integrations',
  'Conecte com mais de 100 ferramentas que você já usa no dia a dia.':
    'Connect with over 100 tools you already use daily.',
  'Segurança Enterprise': 'Enterprise Security',
  'Dados protegidos com criptografia de ponta e conformidade com LGPD.':
    'Data protected with cutting-edge encryption and LGPD compliance.',
  'Analytics Inteligente': 'Smart Analytics',
  'Tome decisões baseadas em dados com dashboards personalizáveis.':
    'Make data-driven decisions with customizable dashboards.',
  'Suporte Premium': 'Premium Support',
  'Equipe dedicada disponível 24/7 para ajudar sua empresa.':
    'Dedicated team available 24/7 to help your company.',
  'Veja a Plataforma em Ação': 'See the Platform in Action',
  'Interface intuitiva que sua equipe vai adorar': 'Intuitive interface your team will love',
  'Planos para Todos os Tamanhos': 'Plans for All Sizes',
  'Escolha o plano ideal e comece hoje mesmo': 'Choose the ideal plan and start today',
  'Ideal para começar': 'Ideal to start',
  'Para times em crescimento': 'For growing teams',
  'Para grandes empresas': 'For large companies',
  'usuários inclusos': 'users included',
  'projetos ativos': 'active projects',
  'armazenamento': 'storage',
  'Chat prioritário': 'Priority chat',
  'Pronto para Começar?': 'Ready to Get Started?',
  'Junte-se a milhares de empresas que já transformaram sua produtividade': 'Join thousands of companies that have already transformed their productivity',
  'Comece seu teste grátis': 'Start your free trial',

  // Additional Form Labels & Placeholders
  'Cargo atual': 'Current position',
  'Qual seu maior desafio na carreira hoje?': 'What is your biggest career challenge today?',
  'Ocasião (opcional)': 'Occasion (optional)',
  'Orçamento': 'Budget',

  // Additional Button Texts
  'Começar grátis': 'Start free',
  'Começar teste grátis': 'Start free trial',
  'Começar gratuitamente →': 'Get started free →',
  'Agendar Conversa Grátis': 'Schedule free conversation',
  'Agende Sua Sessão Gratuita': 'Schedule Your Free Session',
  'Agende sua sessão': 'Schedule your session',
  'Quero Minha Sessão Gratuita →': 'I want my free session →',
  'Solicite Sua Sessão': 'Request Your Session',
  'Conhecer Metodologia': 'Learn methodology',
  'Pronto para começar seu projeto?': 'Ready to start your project?',
  'Pronto para transformar seu negócio?': 'Ready to transform your business?',
  'Pronto para transformar sua carreira?': 'Ready to transform your career?',
  'Ver demo': 'View demo',

  // Additional Mentoring Program Texts
  'Escolha o programa ideal para o seu momento de carreira': 'Choose the ideal program for your career stage',
  'Programa Intensivo': 'Intensive Program',
  'Histórias de Transformação': 'Transformation Stories',
  'Veja os resultados reais de quem passou pelo programa': 'See real results from program participants',
  'Metodologia comprovada que já ajudou mais de 500 profissionais a conquistarem promoções, aumentos e reconhecimento na carreira.':
    'Proven methodology that has helped over 500 professionals achieve promotions, raises, and career recognition.',
  'Sessões personalizadas 1:1 focadas nos seus objetivos específicos. Ideal para quem busca acompanhamento próximo e resultados acelerados.':
    '1:1 personalized sessions focused on your specific goals. Ideal for those seeking close guidance and accelerated results.',
  'Encontros semanais com grupo seleto de profissionais. Networking poderoso + conteúdo exclusivo + suporte contínuo.':
    'Weekly meetings with select professionals. Powerful networking + exclusive content + continuous support.',
  'Imersão de 90 dias com acompanhamento diário. Para quem precisa de uma transformação profunda e rápida na carreira.':
    '90-day intensive with daily guidance. For those needing deep and rapid career transformation.',

  // Process/Steps
  'Uma metodologia estruturada para garantir seus resultados': 'A structured methodology to guarantee your results',
  'Sessão gratuita para entender seus desafios e objetivos': 'Free session to understand your challenges and goals',
  'Estratégia sob medida baseada no seu perfil e metas': 'Custom strategy based on your profile and goals',
  'Sessões práticas com ferramentas e frameworks': 'Practical sessions with tools and frameworks',
  'Acompanhamento de métricas e ajustes contínuos': 'Metrics tracking and continuous adjustments',
  'Implementação': 'Implementation',

  // About Section
  'Minha missão é ajudar você a se tornar a melhor versão de si mesmo': 'My mission is to help you become the best version of yourself',
  'Com mais de 15 anos de experiência em desenvolvimento de lideranças em grandes corporações como Google, Nubank e XP Inc., criei uma metodologia única que combina ciência comportamental com estratégias práticas.':
    'With over 15 years of experience developing leaders in major corporations like Google, Nubank and XP Inc., I created a unique methodology combining behavioral science with practical strategies.',
  'Meus clientes conquistaram promoções, aumentos de até 40% no salário, e principalmente, clareza e confiança para tomar as melhores decisões em suas carreiras.':
    'My clients have achieved promotions, salary increases up to 40%, and most importantly, clarity and confidence to make the best decisions in their careers.',
  'Acredito que todo profissional tem um potencial único que, quando desbloqueado corretamente, pode gerar resultados extraordinários.':
    'I believe every professional has unique potential that, when unlocked correctly, can generate extraordinary results.',

  // Additional FAQ
  'Para quem é indicada a mentoria?': 'Who is mentoring indicated for?',
  'A mentoria é indicada para profissionais que buscam crescimento acelerado na carreira, seja uma promoção, transição de área, aumento salarial ou desenvolvimento de liderança. Atendo principalmente profissionais com 5+ anos de experiência.':
    'Mentoring is indicated for professionals seeking accelerated career growth, whether promotion, career transition, salary increase, or leadership development. I mainly work with professionals with 5+ years of experience.',
  'Qual a diferença entre coaching e mentoria?': 'What is the difference between coaching and mentoring?',
  'No coaching, facilito seu processo de autodescoberta através de perguntas. Na mentoria, além disso, compartilho minha experiência prática, dou conselhos diretos e ensino frameworks específicos. Meu trabalho combina os dois.':
    'In coaching, I facilitate your self-discovery process through questions. In mentoring, I also share my practical experience, give direct advice, and teach specific frameworks. My work combines both.',
  'Em quanto tempo verei resultados?': 'How long until I see results?',
  'A maioria dos clientes reporta mudanças significativas já no primeiro mês (clareza, confiança, melhores decisões). Resultados tangíveis como promoções e aumentos costumam vir entre 3-6 meses, dependendo do contexto.':
    'Most clients report significant changes in the first month (clarity, confidence, better decisions). Tangible results like promotions and raises typically come within 3-6 months, depending on context.',
  'Como funcionam as sessões?': 'How do sessions work?',
  'As sessões são online, com 1 hora de duração, e acontecem semanalmente ou quinzenalmente. Além disso, você tem acesso a materiais exclusivos e suporte via WhatsApp para dúvidas entre as sessões.':
    'Sessions are online, 1 hour long, happening weekly or bi-weekly. You also have access to exclusive materials and WhatsApp support for questions between sessions.',
  'E se eu não gostar?': 'What if I do not like it?',
  'Ofereço garantia de satisfação no primeiro mês. Se você não sentir que está evoluindo, devolvo 100% do investimento. Meu compromisso é com seu resultado.':
    'I offer a satisfaction guarantee in the first month. If you do not feel you are evolving, I refund 100% of your investment. My commitment is to your results.',

  // Contact Section
  'Tire suas dúvidas sobre o programa de mentoria': 'Clear your doubts about the mentoring program',
  'Preencha o formulário ao lado e entrarei em contato em até 24 horas para agendarmos sua sessão de diagnóstico gratuita.':
    'Fill out the form on the side and I will contact you within 24 hours to schedule your free diagnostic session.',
  '30 minutos para entender seus desafios e ver se posso te ajudar': '30 minutes to understand your challenges and see if I can help you',
  'Sem compromisso. Totalmente gratuita.': 'No commitment. Completely free.',
  'Vamos conversar?': 'Shall we talk?',
  'Vamos criar algo incrível juntos?': 'Shall we create something amazing together?',

  // Testimonials
  'Junte-se a mais de 500 profissionais que já alcançaram resultados extraordinários com a mentoria.':
    'Join over 500 professionals who have already achieved extraordinary results with mentoring.',
  'Em 6 meses de mentoria, consegui a promoção para gerente que buscava há 3 anos. A clareza que ganhei sobre meus pontos fortes mudou completamente minha abordagem.':
    'In 6 months of mentoring, I achieved the promotion to manager that I had been seeking for 3 years. The clarity I gained about my strengths completely changed my approach.',
  'O programa intensivo foi divisor de águas. Negociei um aumento de 45% e mudei para uma empresa que sempre sonhei. Investimento que se pagou em menos de 2 meses.':
    'The intensive program was a game-changer. I negotiated a 45% raise and moved to a company I had always dreamed of. Investment that paid for itself in less than 2 months.',
  'Estava completamente perdida sobre qual rumo tomar na carreira. A mentoria me ajudou a encontrar meu propósito e hoje lidero uma equipe de 20 pessoas.':
    'I was completely lost about which direction to take in my career. Mentoring helped me find my purpose and today I lead a team of 20 people.',

  // Credentials
  'ICF Certified Coach': 'ICF Certified Coach',
  'MBA FGV': 'MBA FGV',
  'Master PNL': 'Master NLP',
  '15+ anos experiência': '15+ years of experience',

  // SaaS Minimalist Template
  'A maneira mais simples de gerenciar seu negócio': 'The simplest way to manage your business',
  'Automatize processos, acompanhe métricas e escale sua operação com a plataforma mais intuitiva do mercado.':
    'Automate processes, track metrics, and scale your operation with the most intuitive platform on the market.',
  'Recursos': 'Features',
  'Usado por mais de 10.000 empresas': 'Used by over 10,000 companies',
  'Versão 3.0 lançada': 'Version 3.0 launched',

  // Success Messages (with exact spelling from templates - no accents)
  'Agendamento solicitado! Enviaremos a confirmacao por e-mail.': 'Appointment requested! We will send confirmation by email.',
  'Inscricao confirmada!': 'Registration confirmed!',
  'Inscricao confirmada! Enviamos os detalhes para seu e-mail.': 'Registration confirmed! We sent the details to your email.',
  'Inscricao confirmada! Verifique seu e-mail.': 'Registration confirmed! Check your email.',
  'Reserva solicitada! Entraremos em contato para confirmar.': 'Reservation requested! We will contact you to confirm.',
  'Solicitacao enviada! Entraremos em contato em ate 24h.': 'Request sent! We will contact you within 24 hours.',

  // Portfolio Template
  'Olá, eu sou João 👋': 'Hi, I\'m João 👋',
  'Disponível para projetos': 'Available for projects',
  'Crio experiências digitais': 'I create digital experiences',
  'memoráveis': 'memorable',
  'Designer de produto com 8+ anos de experiência criando interfaces intuitivas e marcas impactantes para startups e empresas globais.':
    'Product designer with 8+ years of experience creating intuitive interfaces and impactful brands for startups and global companies.',
  'Iniciar Projeto →': 'Start Project →',
  'Ver Portfolio': 'View Portfolio',
  'Projetos entregues': 'Projects delivered',
  'Clientes satisfeitos': 'Satisfied clients',
  'De experiência': 'Of experience',
  'Trabalhei com empresas como': 'I\'ve worked with companies like',
  'O que posso fazer por você': 'What I can do for you',
  'Ofereço soluções completas de design para transformar sua visão em realidade':
    'I offer complete design solutions to transform your vision into reality',
  'UI/UX Design': 'UI/UX Design',
  'Interfaces intuitivas e experiências que encantam usuários e geram resultados para o seu negócio.':
    'Intuitive interfaces and experiences that delight users and generate results for your business.',
  'Identidade visual completa: logo, cores, tipografia e todos os elementos que definem sua marca.':
    'Complete visual identity: logo, colors, typography and all elements that define your brand.',
  'Design de Produto': 'Product Design',
  'Do conceito ao lançamento, crio produtos digitais que resolvem problemas reais.':
    'From concept to launch, I create digital products that solve real problems.',
  'Portfolio': 'Portfolio',
  'Trabalhos Selecionados': 'Selected Works',
  'Uma seleção dos meus melhores projetos recentes': 'A selection of my best recent projects',
  'Ver todos os projetos →': 'View all projects →',
  'Sobre mim': 'About me',
  'Apaixonado por resolver problemas através do design': 'Passionate about solving problems through design',
  'Sou designer de produto baseado em São Paulo, com mais de 8 anos de experiência criando soluções digitais que equilibram estética e funcionalidade.':
    'I\'m a product designer based in São Paulo, with over 8 years of experience creating digital solutions that balance aesthetics and functionality.',
  'Minha abordagem combina pesquisa de usuário, design thinking e atenção obsessiva aos detalhes. Acredito que bom design é invisível — ele simplesmente funciona.':
    'My approach combines user research, design thinking and obsessive attention to detail. I believe good design is invisible — it just works.',
  'Quando não estou desenhando interfaces, você me encontra fotografando a cidade, lendo sobre psicologia cognitiva ou experimentando novos restaurantes.':
    'When I\'m not designing interfaces, you can find me photographing the city, reading about cognitive psychology or trying new restaurants.',
  'Design Systems': 'Design Systems',
  'Prototyping': 'Prototyping',
  'User Research': 'User Research',
  'Motion Design': 'Motion Design',
  'O que meus clientes dizem': 'What my clients say',
  'João entendeu perfeitamente nossa visão e entregou um produto que superou todas as expectativas. Nosso app teve um aumento de 200% em retenção.':
    'João understood our vision perfectly and delivered a product that exceeded all expectations. Our app had a 200% increase in retention.',
  'Trabalhar com o João foi uma experiência incrível. Ele não apenas entrega design, mas estratégia. Nossa marca nunca esteve tão forte.':
    'Working with João was an amazing experience. He doesn\'t just deliver design, but strategy. Our brand has never been stronger.',
  'Estou sempre aberto a novos projetos e parcerias interessantes. Entre em contato e vamos conversar sobre como posso ajudar.':
    'I\'m always open to new projects and interesting partnerships. Get in touch and let\'s talk about how I can help.',
  'Ex: Redesign de app, branding...': 'Ex: App redesign, branding...',
  'Conte-me sobre seu projeto...': 'Tell me about your project...',
  'Enviar Mensagem →': 'Send Message →',
  'João.design. Todos os direitos reservados.': 'João.design. All rights reserved.',

  // Agency Template
  'Agência premiada 2024': 'Award-winning agency 2024',
  'Transformamos marcas em experiências': 'We transform brands into experiences',
  'Somos uma agência de design e tecnologia que ajuda empresas a criar produtos digitais que as pessoas amam. Do conceito ao lançamento.':
    'We are a design and technology agency that helps companies create digital products that people love. From concept to launch.',
  'Ver Projetos →': 'View Projects →',
  'De mercado': 'In the market',
  'Projetos ativos': 'Active projects',
  'Empresas que confiam em nosso trabalho': 'Companies that trust our work',
  'O que fazemos de melhor': 'What we do best',
  'Oferecemos soluções completas para transformar sua presença digital': 'We offer complete solutions to transform your digital presence',
  'Criamos interfaces intuitivas que encantam usuários e geram resultados mensuráveis para o seu negócio.':
    'We create intuitive interfaces that delight users and generate measurable results for your business.',
  'Desenvolvimento Web': 'Web Development',
  'Sites e aplicações de alta performance com as melhores tecnologias do mercado.':
    'High-performance websites and applications with the best technologies on the market.',
  'Apps Mobile': 'Mobile Apps',
  'Aplicativos nativos e híbridos para iOS e Android com experiência impecável.':
    'Native and hybrid applications for iOS and Android with flawless experience.',
  'Identidade visual completa que comunica os valores e diferencia sua marca.':
    'Complete visual identity that communicates values and differentiates your brand.',
  'Estratégias de growth que trazem resultados reais e escaláveis.':
    'Growth strategies that bring real and scalable results.',
  'Consultoria': 'Consulting',
  'Análise e planejamento estratégico para otimizar seus processos digitais.':
    'Analysis and strategic planning to optimize your digital processes.',
  'Projetos em destaque': 'Featured projects',
  'Uma seleção dos nossos melhores trabalhos recentes': 'A selection of our best recent work',
  'App Bancário Digital': 'Digital Banking App',
  'Plataforma de Moda': 'Fashion Platform',
  'Dashboard Analytics': 'Analytics Dashboard',
  'Nosso Processo': 'Our Process',
  'Como trabalhamos': 'How we work',
  'Um processo estruturado para entregar resultados excepcionais': 'A structured process to deliver exceptional results',
  'Discovery': 'Discovery',
  'Entendemos seu negócio, objetivos e desafios para criar a estratégia ideal.':
    'We understand your business, goals and challenges to create the ideal strategy.',
  'Design': 'Design',
  'Criamos protótipos e designs que equilibram estética e funcionalidade.':
    'We create prototypes and designs that balance aesthetics and functionality.',
  'Construímos a solução com as melhores práticas e tecnologias.':
    'We build the solution with the best practices and technologies.',
  'Lançamento': 'Launch',
  'Deploy, monitoramento e suporte contínuo para garantir o sucesso.':
    'Deploy, monitoring and continuous support to ensure success.',
  'O que nossos clientes dizem': 'What our clients say',
  'A Studio entendeu perfeitamente nossa visão e entregou um produto que superou todas as expectativas. Nosso app teve um aumento de 200% em downloads.':
    'Studio understood our vision perfectly and delivered a product that exceeded all expectations. Our app had a 200% increase in downloads.',
  'Profissionais excepcionais! O novo site aumentou nossa taxa de conversão em 150%. Parceria que vale cada centavo investido.':
    'Exceptional professionals! The new site increased our conversion rate by 150%. Partnership worth every penny invested.',
  'Da identidade visual ao lançamento do app, a Studio cuidou de tudo. Resultado impecável e dentro do prazo.':
    'From visual identity to app launch, Studio took care of everything. Flawless result and on time.',
  'Nossa Equipe': 'Our Team',
  'As mentes por trás da magia': 'The minds behind the magic',
  'Uma equipe multidisciplinar apaixonada por criar experiências incríveis':
    'A multidisciplinary team passionate about creating amazing experiences',
  'CEO & Founder': 'CEO & Founder',
  'Design Lead': 'Design Lead',
  'Tech Lead': 'Tech Lead',
  'Project Manager': 'Project Manager',
  'Conte-nos sobre seu projeto e descubra como podemos ajudar a transformar sua visão em realidade.':
    'Tell us about your project and discover how we can help transform your vision into reality.',
  'Ex: App, Site, Branding...': 'Ex: App, Website, Branding...',
  'Conte-nos sobre seu projeto...': 'Tell us about your project...',
  'Agende uma conversa gratuita de 30 minutos para discutir suas ideias e como podemos ajudar.':
    'Schedule a free 30-minute conversation to discuss your ideas and how we can help.',
  'Transformamos ideias em produtos digitais que as pessoas amam. Design, tecnologia e estratégia sob medida.':
    'We transform ideas into digital products that people love. Design, technology and custom strategy.',
  'Sobre nós': 'About us',
  'Carreiras': 'Careers',
  'Studio. Todos os direitos reservados.': 'Studio. All rights reserved.',

  // E-commerce Product Template
  'Em estoque': 'In stock',
  'avaliações': 'reviews',
  'O smartwatch mais avançado do mercado. Monitor cardíaco, GPS integrado, resistente à água até 50m, bateria de 7 dias e mais de 100 modos de exercício.':
    'The most advanced smartwatch on the market. Heart rate monitor, integrated GPS, water resistant up to 50m, 7-day battery and over 100 exercise modes.',
  'Cor: Preto': 'Color: Black',
  '🚚 Frete grátis': '🚚 Free shipping',
  '🔄 30 dias para troca': '🔄 30-day exchange',
  '🔒 Compra segura': '🔒 Secure purchase',

  // Clinic Template
  '🏥 Referencia em Saude desde 2008': '🏥 Healthcare reference since 2008',
  'Cuidando da sua': 'Taking care of your',
  'saude': 'health',
  'com excelencia e humanidade': 'with excellence and humanity',
  'Equipe medica altamente especializada, tecnologia de ponta e atendimento humanizado.':
    'Highly specialized medical team, cutting-edge technology and humanized care.',
  'Sua saude merece o melhor cuidado - e nos estamos aqui para oferecer isso.':
    'Your health deserves the best care - and we are here to provide it.',
  'Agendar Consulta →': 'Schedule Appointment →',
  'Conheca a Clinica': 'Learn about the Clinic',
  '+50.000 pacientes': '+50,000 patients',
  'atendidos com sucesso': 'successfully served',
  '+30 Especialistas': '+30 Specialists',
  'Medicos renomados em todas as especialidades': 'Renowned doctors in all specialties',
  '15 Anos': '15 Years',
  'De excelencia em cuidados com a saude': 'Of excellence in healthcare',
  'Resultados 24h': 'Results 24h',
  'Exames com resultados rapidos e precisos': 'Tests with fast and accurate results',
  'Atendimento Humanizado': 'Humanized Care',
  'Voce e tratado como parte da familia': 'You are treated as part of the family',
  'Sobre Nos': 'About Us',
  'Uma clinica pensada para o seu bem-estar': 'A clinic designed for your well-being',
  'Fundada em 2008, a VidaClinic nasceu com o proposito de oferecer atendimento medico de alta qualidade com um diferencial: o cuidado humanizado.':
    'Founded in 2008, VidaClinic was born with the purpose of offering high-quality medical care with a difference: humanized care.',
  'Acreditamos que a medicina vai alem dos diagnosticos - ela envolve acolhimento, respeito e empatia.':
    'We believe medicine goes beyond diagnoses - it involves welcoming, respect and empathy.',
  'Nossa estrutura moderna conta com equipamentos de ultima geracao e uma equipe multidisciplinar preparada para cuidar de voce e sua familia em todas as fases da vida.':
    'Our modern facility has state-of-the-art equipment and a multidisciplinary team prepared to care for you and your family at all stages of life.',
  'Estrutura moderna e acessivel': 'Modern and accessible facility',
  'Equipamentos de ultima geracao': 'State-of-the-art equipment',
  'Convenios com principais operadoras': 'Agreements with major insurance providers',
  'Estacionamento gratuito': 'Free parking',
  'Conheca Nossa Historia →': 'Learn Our Story →',
  'Nossas Areas de Atuacao': 'Our Areas of Expertise',
  'Oferecemos atendimento completo em diversas especialidades medicas com profissionais altamente qualificados.':
    'We offer complete care in various medical specialties with highly qualified professionals.',
  'Diagnostico e tratamento de doencas cardiovasculares com tecnologia avancada e acompanhamento especializado.':
    'Diagnosis and treatment of cardiovascular diseases with advanced technology and specialized follow-up.',
  'Cuidados com a saude da pele, cabelos e unhas. Tratamentos esteticos e clinicos com resultados comprovados.':
    'Care for skin, hair and nail health. Aesthetic and clinical treatments with proven results.',
  'Tratamento de ossos, articulacoes e musculos. Reabilitacao completa e acompanhamento personalizado.':
    'Treatment of bones, joints and muscles. Complete rehabilitation and personalized follow-up.',
  'Pediatria': 'Pediatrics',
  'Cuidados completos para bebes, criancas e adolescentes. Ambiente acolhedor e equipe especializada.':
    'Complete care for babies, children and adolescents. Welcoming environment and specialized team.',
  'Neurologia': 'Neurology',
  'Diagnostico e tratamento de doencas do sistema nervoso com abordagem multidisciplinar.':
    'Diagnosis and treatment of nervous system diseases with a multidisciplinary approach.',
  'Oftalmologia': 'Ophthalmology',
  'Exames completos e tratamentos para a saude dos seus olhos. Cirurgias refrativas e muito mais.':
    'Complete exams and treatments for your eye health. Refractive surgeries and much more.',
  'Saiba mais →': 'Learn more →',
  'Conheca Nossos Especialistas': 'Meet Our Specialists',
  'Profissionais altamente qualificados e comprometidos com sua saude e bem-estar.':
    'Highly qualified professionals committed to your health and well-being.',
  'Cardiologista': 'Cardiologist',
  'Dermatologista': 'Dermatologist',
  'Ortopedista': 'Orthopedist',
  'Pediatra': 'Pediatrician',
  'O que nossos pacientes dizem': 'What our patients say',
  'Fui muito bem atendida desde a recepcao ate a consulta. O Dr. Carlos e extremamente atencioso e me explicou tudo com calma. Recomendo demais!':
    'I was very well treated from reception to consultation. Dr. Carlos is extremely attentive and explained everything to me calmly. Highly recommend!',
  'Paciente de Cardiologia': 'Cardiology Patient',
  'Ambiente impecavel e equipe super preparada. Meus filhos adoram ir ao pediatra aqui porque sao sempre muito carinhosos com eles.':
    'Impeccable environment and super prepared team. My kids love going to the pediatrician here because they are always very loving with them.',
  'Pai de paciente': 'Patient\'s father',
  'Depois de anos sofrendo com dores nas costas, finalmente encontrei uma solucao. A equipe de ortopedia mudou minha qualidade de vida.':
    'After years suffering from back pain, I finally found a solution. The orthopedics team changed my quality of life.',
  'Paciente de Ortopedia': 'Orthopedics Patient',
  'Duvidas Frequentes': 'Frequently Asked Questions',
  'Perguntas e Respostas': 'Questions and Answers',
  'Quais convenios sao aceitos?': 'Which insurance plans are accepted?',
  'Trabalhamos com os principais convenios do mercado: Unimed, Bradesco Saude, SulAmerica, Amil, Porto Seguro, entre outros. Consulte nossa equipe para verificar seu plano.':
    'We work with the main insurance plans on the market: Unimed, Bradesco Saúde, SulAmerica, Amil, Porto Seguro, among others. Consult our team to verify your plan.',
  'Como agendar uma consulta?': 'How to schedule an appointment?',
  'Voce pode agendar pelo telefone (11) 3456-7890, pelo WhatsApp ou preenchendo o formulario online. Tambem aceitamos agendamentos presenciais.':
    'You can schedule by phone (11) 3456-7890, by WhatsApp or by filling out the online form. We also accept in-person appointments.',
  'A clinica tem estacionamento?': 'Does the clinic have parking?',
  'Sim, oferecemos estacionamento gratuito para todos os pacientes durante o horario da consulta. Basta validar o ticket na recepcao.':
    'Yes, we offer free parking for all patients during appointment hours. Just validate your ticket at reception.',
  'Qual o horario de funcionamento?': 'What are the opening hours?',
  'Funcionamos de segunda a sexta das 7h as 20h e aos sabados das 8h as 14h. Alguns exames de urgencia podem ser realizados fora desse horario.':
    'We are open Monday to Friday from 7am to 8pm and Saturdays from 8am to 2pm. Some urgent exams can be performed outside these hours.',
  'Entre em contato ou agende sua consulta': 'Contact us or schedule your appointment',
  'Nossa equipe esta pronta para atende-lo. Entre em contato pelos canais abaixo ou preencha o formulario para agendar sua consulta.':
    'Our team is ready to assist you. Contact us through the channels below or fill out the form to schedule your appointment.',
  'Selecione uma especialidade': 'Select a specialty',
  'Descreva seus sintomas ou duvidas...': 'Describe your symptoms or questions...',
  'Solicitar Agendamento': 'Request Appointment',
  'Sua saude nao pode esperar': 'Your health can\'t wait',
  'Agende agora sua consulta e cuide do que mais importa: voce e sua familia.':
    'Schedule your appointment now and take care of what matters most: you and your family.',
  'Agendar Consulta Agora': 'Schedule Appointment Now',
  'Ha mais de 15 anos cuidando da saude de milhares de familias com excelencia, tecnologia e muito carinho.':
    'For over 15 years caring for the health of thousands of families with excellence, technology and lots of love.',
  'A Clinica': 'The Clinic',
  'Estrutura': 'Facility',
  'Convenios': 'Insurance',
  'Atendimento': 'Service',
  'Resultados de Exames': 'Test Results',
  'Ouvidoria': 'Ombudsman',
  'VidaClinic. Todos os direitos reservados.': 'VidaClinic. All rights reserved.',
  '🏆 ANVISA Aprovado': '🏆 ANVISA Approved',
  '✓ Certificado ISO 9001': '✓ ISO 9001 Certified',

  // Real Estate Template
  '🏆 A imobiliaria mais premiada da regiao': '🏆 The most awarded real estate agency in the region',
  'imovel perfeito': 'perfect property',
  'para voce e sua familia': 'for you and your family',
  'Mais de 5.000 imoveis disponiveis nas melhores localizacoes. Casas, apartamentos, terrenos e empreendimentos com as melhores condicoes do mercado.':
    'Over 5,000 properties available in the best locations. Houses, apartments, land and developments with the best conditions on the market.',
  'Ver Imoveis Disponiveis →': 'View Available Properties →',
  'Fale com um Corretor': 'Talk to an Agent',
  'Imoveis disponiveis': 'Properties available',
  'Nossos Servicos': 'Our Services',
  'Como podemos ajudar voce?': 'How can we help you?',
  'Oferecemos servicos completos para quem quer comprar, vender ou alugar imoveis.':
    'We offer complete services for those who want to buy, sell or rent properties.',
  'Compra': 'Purchase',
  'Encontre o imovel ideal com assessoria especializada em todo o processo.':
    'Find the ideal property with specialized assistance throughout the process.',
  'Venda': 'Sale',
  'Venda seu imovel pelo melhor preco com estrategias de marketing eficientes.':
    'Sell your property for the best price with efficient marketing strategies.',
  'Aluguel': 'Rental',
  'Alugue com seguranca e praticidade, tanto para locadores quanto locatarios.':
    'Rent with security and practicality, for both landlords and tenants.',
  'Avaliacao': 'Evaluation',
  'Avaliacao profissional do seu imovel para definir o valor de mercado.':
    'Professional evaluation of your property to define market value.',
  'Imoveis em Destaque': 'Featured Properties',
  'Todos': 'All',
  'Casas': 'Houses',
  'Apartamentos': 'Apartments',
  'Terrenos': 'Land',
  'Casa moderna em condominio fechado': 'Modern house in gated community',
  'Apartamento com vista para o mar': 'Apartment with ocean view',
  'Cobertura duplex no centro': 'Duplex penthouse downtown',
  'Casa terrea com quintal amplo': 'Single-story house with large backyard',
  'Apartamento moderno mobiliado': 'Modern furnished apartment',
  'Sobrado novo em condominio': 'New townhouse in gated community',
  'Destaque': 'Featured',
  'Novo': 'New',
  'Oportunidade': 'Opportunity',
  '/ Venda': '/ Sale',
  '/ mes': '/ month',
  'A imobiliaria que entende suas necessidades': 'The real estate agency that understands your needs',
  'Ha mais de 15 anos no mercado imobiliario, a PrimeImoveis se consolidou como referencia em compra, venda e locacao de imoveis.':
    'For over 15 years in the real estate market, PrimeImóveis has established itself as a reference in buying, selling and renting properties.',
  'Nossa equipe de corretores especializados esta pronta para ajuda-lo a encontrar o imovel dos seus sonhos.':
    'Our team of specialized agents is ready to help you find the property of your dreams.',
  'Trabalhamos com transparencia, etica e comprometimento, oferecendo as melhores oportunidades do mercado e um atendimento personalizado para cada cliente.':
    'We work with transparency, ethics and commitment, offering the best opportunities on the market and personalized service for each client.',
  'Corretores certificados': 'Certified agents',
  'Assessoria juridica': 'Legal advisory',
  'Financiamento facilitado': 'Easy financing',
  'Documentacao completa': 'Complete documentation',
  'Corretores Especializados': 'Specialized Agents',
  'Profissionais qualificados prontos para ajudar voce a encontrar o imovel perfeito.':
    'Qualified professionals ready to help you find the perfect property.',
  'Corretor Senior': 'Senior Agent',
  'Corretora de Alto Padrao': 'High-End Agent',
  'Especialista em Lancamentos': 'Launch Specialist',
  'Corretora de Locacao': 'Rental Agent',
  'Encontrei o apartamento perfeito com a ajuda da PrimeImoveis. O atendimento foi excepcional do inicio ao fim. Super recomendo!':
    'I found the perfect apartment with the help of PrimeImóveis. The service was exceptional from start to finish. Highly recommend!',
  'Compradora - Apartamento': 'Buyer - Apartment',
  'Vendi minha casa em tempo recorde e por um otimo preco. A equipe foi muito profissional e transparente em todo o processo.':
    'I sold my house in record time and for a great price. The team was very professional and transparent throughout the process.',
  'Vendedor - Casa': 'Seller - House',
  'Aluguei um escritorio comercial com toda a documentacao em dia. Processo rapido e sem complicacoes. Excelente servico!':
    'I rented a commercial office with all documentation up to date. Fast and uncomplicated process. Excellent service!',
  'Locataria - Comercial': 'Tenant - Commercial',
  'Pronto para encontrar seu imovel ideal?': 'Ready to find your ideal property?',
  'Entre em contato conosco e um de nossos corretores especializados ira ajuda-lo a encontrar a melhor opcao para voce e sua familia.':
    'Contact us and one of our specialized agents will help you find the best option for you and your family.',
  'Solicite Atendimento': 'Request Service',
  'Interesse': 'Interest',
  'Selecione seu interesse': 'Select your interest',
  'Comprar imovel': 'Buy property',
  'Vender imovel': 'Sell property',
  'Alugar imovel': 'Rent property',
  'Avaliacao de imovel': 'Property evaluation',
  'Descreva o imovel que procura ou seu interesse...': 'Describe the property you\'re looking for or your interest...',
  'Enviar Solicitacao': 'Send Request',
  'Ha mais de 15 anos realizando o sonho de milhares de familias. Compra, venda e locacao de imoveis com seguranca e transparencia.':
    'For over 15 years making the dreams of thousands of families come true. Buying, selling and renting properties with security and transparency.',
  'Imoveis': 'Properties',
  'Comerciais': 'Commercial',
  'Lancamentos': 'New Developments',
  'Vender': 'Sell',
  'Alugar': 'Rent',
  'Financiamento': 'Financing',
  'PrimeImoveis. Todos os direitos reservados.': 'PrimeImóveis. All rights reserved.',
  'Anunciar Imovel': 'List Property',
  'Anos de mercado': 'Years in the market',
  'Inicio': 'Home',
  'Corretores': 'Agents',

  // Course Online Template - Additional
  '+467% de faturamento': '+467% in revenue',
  '-82% no custo por lead': '-82% in cost per lead',
  '4x mais renda': '4x more income',
  'E-commerce de Moda': 'Fashion E-commerce',
  'Consultoria B2B': 'B2B Consulting',
  'Gestor de Tráfego': 'Traffic Manager',
  'Reduzi meu custo por lead de R$45 para R$8. Hoje gero 10x mais leads com o mesmo orçamento.':
    'I reduced my cost per lead from $45 to $8. Today I generate 10x more leads with the same budget.',
  'Larguei meu emprego CLT e hoje faturo 4x mais trabalhando como gestor de tráfego freelancer.':
    'I quit my regular job and today I earn 4x more working as a freelance traffic manager.',
  'Exclusivo': 'Exclusive',
  'Bônus especiais inclusos': 'Special bonuses included',
  'Mais de R$2.000 em bônus totalmente grátis para acelerar seus resultados':
    'Over $2,000 in completely free bonuses to accelerate your results',
  'Pack de Templates': 'Template Pack',
  '+50 templates de anúncios, landing pages e e-mails prontos para usar.':
    '+50 ad templates, landing pages and emails ready to use.',
  'Planilhas Profissionais': 'Professional Spreadsheets',
  'Dashboard de métricas, calculadora de ROI e planejador de campanhas.':
    'Metrics dashboard, ROI calculator and campaign planner.',
  '4 sessões ao vivo mensais para tirar dúvidas e fazer networking.':
    '4 monthly live sessions for Q&A and networking.',
  'Dúvidas frequentes': 'Frequently asked questions',
  'Perguntas comuns': 'Common questions',
  'O curso é para iniciantes ou avançados?': 'Is the course for beginners or advanced?',
  'O curso foi desenvolvido para atender desde iniciantes até profissionais que querem se atualizar. Começamos do básico e avançamos progressivamente até estratégias avançadas de escala.':
    'The course was developed to serve everyone from beginners to professionals who want to update themselves. We start from the basics and progressively advance to advanced scaling strategies.',
  'Por quanto tempo terei acesso ao curso?': 'How long will I have access to the course?',
  'Acesso vitalício! Uma vez inscrito, você terá acesso para sempre, incluindo todas as atualizações futuras sem custo adicional.':
    'Lifetime access! Once enrolled, you will have access forever, including all future updates at no additional cost.',
  'E se eu não gostar do curso?': 'What if I don\'t like the course?',
  'Você tem 7 dias de garantia incondicional. Se por qualquer motivo não ficar satisfeito, basta solicitar o reembolso e devolvemos 100% do valor, sem perguntas.':
    'You have a 7-day unconditional guarantee. If for any reason you are not satisfied, just request a refund and we will return 100% of the amount, no questions asked.',
  'Preciso de algum conhecimento prévio?': 'Do I need any prior knowledge?',
  'Não! O curso começa do zero absoluto. Você só precisa de um computador, internet e vontade de aprender.':
    'No! The course starts from absolute zero. You just need a computer, internet and a desire to learn.',
  'Recebo certificado ao concluir?': 'Do I receive a certificate upon completion?',
  'Sim! Ao completar todas as aulas, você recebe um certificado de conclusão reconhecido pelo mercado para adicionar ao seu LinkedIn e currículo.':
    'Yes! Upon completing all classes, you receive a market-recognized certificate of completion to add to your LinkedIn and resume.',
  'Comece sua transformação hoje': 'Start your transformation today',
  'Tudo que você precisa para dominar marketing digital em um só lugar':
    'Everything you need to master digital marketing in one place',
  '-75% OFF': '-75% OFF',
  'Acesso Completo + Bônus': 'Full Access + Bonuses',
  '8 módulos completos (+80 aulas)': '8 complete modules (+80 classes)',
  'Acesso vitalício + atualizações': 'Lifetime access + updates',
  'Comunidade exclusiva no Discord': 'Exclusive Discord community',
  'Certificado de conclusão': 'Certificate of completion',
  '+R$1.791 em bônus inclusos': '+$1,791 in included bonuses',
  'Suporte direto por 12 meses': 'Direct support for 12 months',
  'De R$ 1.997': 'From $1,997',
  'ou 12x de R$ 49,70 sem juros': 'or 12x of $49.70 interest-free',
  'GARANTIR MINHA VAGA AGORA →': 'SECURE MY SPOT NOW →',
  '🔒': '🔒',
  '7 dias de garantia incondicional • Pagamento 100% seguro': '7-day unconditional guarantee • 100% secure payment',
  '⏰ Oferta por tempo limitado': '⏰ Limited time offer',
  'O desconto de 75% é válido apenas para as próximas 48 horas. Depois disso, o preço volta ao normal de R$1.997.':
    'The 75% discount is valid only for the next 48 hours. After that, the price returns to the normal $1,997.',
  'QUERO COMEÇAR AGORA': 'I WANT TO START NOW',
  '© 2024 Marketing Digital Pro. Todos os direitos reservados.': '© 2024 Marketing Digital Pro. All rights reserved.',

  // Fitness Template
  'Matricule-se': 'Enroll Now',
  '🔥 Primeira semana gratis': '🔥 First week free',
  'transforme sua': 'transform your',
  'vida': 'life',
  'A maior academia da regiao com mais de 2.000m² de estrutura, equipamentos de ultima geracao, mais de 50 modalidades e professores altamente qualificados. Venha fazer parte dessa revolucao.':
    'The largest gym in the region with over 2,000m² of structure, state-of-the-art equipment, over 50 modalities and highly qualified instructors. Come be part of this revolution.',
  'Comecar Agora →': 'Start Now →',
  'Conhecer a Academia': 'Visit the Gym',
  'Alunos ativos': 'Active members',
  'Funcionamento': 'Operating',
  'Anos de historia': 'Years of history',
  'Musculacao': 'Weight Training',
  'Equipamentos de ultima geracao para todos os niveis': 'State-of-the-art equipment for all levels',
  'Cardio': 'Cardio',
  'Area completa com esteiras, bikes e elipticos': 'Complete area with treadmills, bikes and ellipticals',
  'Lutas': 'Combat Sports',
  'Muay Thai, Jiu-Jitsu, Boxe e muito mais': 'Muay Thai, Jiu-Jitsu, Boxing and much more',
  'Bem-estar': 'Wellness',
  'Yoga, Pilates e meditacao guiada': 'Yoga, Pilates and guided meditation',
  'Aulas para todos os estilos': 'Classes for all styles',
  'Mais de 50 modalidades diferentes para voce escolher e montar seu treino ideal.':
    'Over 50 different modalities for you to choose and build your ideal workout.',
  '45 min': '45 min',
  '60 min': '60 min',
  '50 min': '50 min',
  '600 kcal': '600 kcal',
  '700 kcal': '700 kcal',
  '800 kcal': '800 kcal',
  '500 kcal': '500 kcal',
  '550 kcal': '550 kcal',
  'Sala 1': 'Room 1',
  'Sala 2': 'Room 2',
  'Sala 3': 'Room 3',
  'Box': 'Box',
  'Area externa': 'Outdoor area',
  'Sala de lutas': 'Combat room',
  'Relaxamento': 'Relaxation',
  'Funcional': 'Functional',
  'Dance Fit': 'Dance Fit',
  'Professores Especialistas': 'Expert Trainers',
  'Profissionais certificados e apaixonados prontos para guiar sua transformacao.':
    'Certified and passionate professionals ready to guide your transformation.',
  'Personal Trainer': 'Personal Trainer',
  'CrossFit Coach': 'CrossFit Coach',
  'Instrutor': 'Instructor',
  'Instrutora': 'Instructor',
  'Musculacao e Hipertrofia': 'Weight Training and Hypertrophy',
  'CrossFit e Funcional': 'CrossFit and Functional',
  'Muay Thai e Boxe': 'Muay Thai and Boxing',
  'Spinning e Dance': 'Spinning and Dance',
  'Resultados': 'Results',
  'Transformacoes Reais': 'Real Transformations',
  'Veja os resultados incriveis que nossos alunos alcancaram.': 'See the incredible results our students have achieved.',
  '-25kg em 8 meses': '-25kg in 8 months',
  '-18kg em 6 meses': '-18kg in 6 months',
  '+12kg massa magra': '+12kg lean mass',
  'A IronFit mudou minha vida. Com a ajuda dos profissionais consegui alcançar resultados que nunca imaginei.':
    'IronFit changed my life. With the help of the professionals I was able to achieve results I never imagined.',
  'Encontrei na academia nao so um lugar para treinar, mas uma familia que me apoia todos os dias.':
    'I found in the gym not just a place to train, but a family that supports me every day.',
  'O acompanhamento personalizado fez toda diferenca. Resultados que parecem impossiveis se tornam reais.':
    'The personalized follow-up made all the difference. Results that seem impossible become real.',
  'Escolha o seu': 'Choose yours',
  'Planos flexiveis para todos os objetivos e bolsos.': 'Flexible plans for all goals and budgets.',
  'Basic': 'Basic',
  'Musculacao completa': 'Full weight training',
  'Area de cardio': 'Cardio area',
  'Vestiario com armario': 'Locker room with locker',
  'Horario comercial': 'Business hours',
  'Aulas coletivas': 'Group classes',
  'Escolher Plano': 'Choose Plan',
  'Mais popular': 'Most popular',
  'Tudo do Basic': 'Everything from Basic',
  'Todas aulas coletivas': 'All group classes',
  'Avaliacao fisica mensal': 'Monthly physical evaluation',
  'App exclusivo': 'Exclusive app',
  'Acesso 24 horas': '24-hour access',
  'Black': 'Black',
  'Tudo do Premium': 'Everything from Premium',
  'Personal trainer incluso': 'Personal trainer included',
  'Nutricionista mensal': 'Monthly nutritionist',
  'Area VIP exclusiva': 'Exclusive VIP area',
  'Convide 1 amigo': 'Invite 1 friend',
  '/mes': '/month',
  'O que nossos alunos dizem': 'What our students say',
  'Melhor academia que ja treinei. Equipamentos novos, professores atenciosos e ambiente super motivador. Recomendo demais!':
    'Best gym I\'ve ever trained at. New equipment, attentive instructors and super motivating environment. Highly recommend!',
  'Plano Premium': 'Premium Plan',
  'Plano Black': 'Black Plan',
  'As aulas de spinning sao incriveis! A Marina e uma professora excepcional que nos motiva a cada pedalada. Viciei!':
    'The spinning classes are amazing! Marina is an exceptional instructor who motivates us with every pedal. I\'m hooked!',
  'O plano Black vale cada centavo. Ter um personal e nutricionista fez toda diferenca nos meus resultados. Perdi 20kg!':
    'The Black plan is worth every penny. Having a personal trainer and nutritionist made all the difference in my results. I lost 20kg!',
  'Sua transformacao comeca agora': 'Your transformation starts now',
  'Nao deixe para amanha o que pode mudar sua vida hoje. Junte-se a mais de 5.000 alunos que ja transformaram seus corpos e mentes.':
    'Don\'t leave for tomorrow what can change your life today. Join over 5,000 students who have already transformed their bodies and minds.',
  'Agende sua aula experimental gratuita': 'Schedule your free trial class',
  'Pronto para comecar sua transformacao?': 'Ready to start your transformation?',
  'Entre em contato conosco ou preencha o formulario para agendar sua visita e conhecer nossa estrutura. A primeira aula e por nossa conta!':
    'Contact us or fill out the form to schedule your visit and see our facilities. The first class is on us!',
  'Agende sua visita': 'Schedule your visit',
  'Objetivo': 'Goal',
  'Selecione seu objetivo': 'Select your goal',
  'Perder peso': 'Lose weight',
  'Ganhar massa muscular': 'Gain muscle mass',
  'Condicionamento fisico': 'Physical conditioning',
  'Qualidade de vida': 'Quality of life',
  'Agendar Visita Gratuita': 'Schedule Free Visit',
  'Ha mais de 15 anos transformando vidas atraves do fitness. Junte-se a nos e descubra seu potencial.':
    'For over 15 years transforming lives through fitness. Join us and discover your potential.',
  'IronFit. Todos os direitos reservados.': 'IronFit. All rights reserved.',
  'Segunda a Sexta: 24 horas': 'Monday to Friday: 24 hours',
  'Sabado e Domingo: 6h - 22h': 'Saturday and Sunday: 6am - 10pm',
  'A Academia': 'The Gym',
  'Professores': 'Instructors',
  'Privacidade': 'Privacy',
  '© 2024 IronFit Academia. Todos os direitos reservados. CREF 012345-G/SP': '© 2024 IronFit Gym. All rights reserved. CREF 012345-G/SP',

  // Podcast Template
  'Episodios': 'Episodes',
  'Convidados': 'Guests',
  'Ouvir Agora': 'Listen Now',
  '🎙️ Novo episodio toda segunda-feira': '🎙️ New episode every Monday',
  'O podcast sobre': 'The podcast about',
  'startups e negocios': 'startups and business',
  'que voce precisa ouvir': 'you need to listen to',
  'Conversas honestas e sem filtro com empreendedores de sucesso sobre os bastidores de construir empresas de alto crescimento. Insights reais, historias inspiradoras e licoes que voce nao encontra em nenhum livro.':
    'Honest and unfiltered conversations with successful entrepreneurs about the behind-the-scenes of building high-growth companies. Real insights, inspiring stories and lessons you won\'t find in any book.',
  'Apple Podcasts': 'Apple Podcasts',
  'Google Podcasts': 'Google Podcasts',
  'Downloads/mes': 'Downloads/month',
  'Seu Host': 'Your Host',
  'Empreendedor serial, investidor anjo e apaixonado por startups. Fundou 3 empresas que juntas ja faturaram mais de R$100 milhoes. Agora, sua missao e compartilhar tudo que aprendeu nos bastidores do empreendedorismo.':
    'Serial entrepreneur, angel investor and passionate about startups. Founded 3 companies that together have already earned over $100 million. Now, his mission is to share everything he learned behind the scenes of entrepreneurship.',
  'No StartupCast, ele entrevista fundadores, investidores e executivos para extrair os insights mais valiosos sobre como construir negocios de sucesso no Brasil.':
    'On StartupCast, he interviews founders, investors and executives to extract the most valuable insights on how to build successful businesses in Brazil.',
  '3 exits bem-sucedidos': '3 successful exits',
  '+R$50M investidos': '+$50M invested',
  '+15 anos de experiencia': '+15 years of experience',
  '+200 entrevistas': '+200 interviews',
  'Temas': 'Topics',
  'O que voce vai aprender': 'What you will learn',
  'Conteudo pratico e relevante para quem quer empreender ou crescer no mundo dos negocios.':
    'Practical and relevant content for those who want to start or grow in the business world.',
  'Startups': 'Startups',
  'Investimentos': 'Investments',
  'Growth': 'Growth',
  'Lideranca': 'Leadership',
  'Inovacao': 'Innovation',
  'Vendas': 'Sales',
  'Cultura': 'Culture',
  'Produtividade': 'Productivity',
  'Ultimos lancamentos': 'Latest releases',
  'Mais recentes': 'Most recent',
  'Mais ouvidos': 'Most listened',
  'Como captar R$50M para sua startup': 'How to raise $50M for your startup',
  'Os segredos do product-market fit': 'The secrets of product-market fit',
  'De CLT a empreendedor: minha jornada': 'From employee to entrepreneur: my journey',
  'Especial: 200 episodios de aprendizados': 'Special: 200 episodes of learnings',
  'Vendendo sua empresa: o que aprendi': 'Selling your company: what I learned',
  'Como montar um time de alta performance': 'How to build a high-performance team',
  '2 dias atras': '2 days ago',
  '1 semana atras': '1 week ago',
  '2 semanas atras': '2 weeks ago',
  '3 semanas atras': '3 weeks ago',
  '1 mes atras': '1 month ago',
  '58 min': '58 min',
  '52 min': '52 min',
  '72 min': '72 min',
  '63 min': '63 min',
  '48 min': '48 min',
  'Ver todos os episodios →': 'View all episodes →',
  'Quem ja passou por aqui': 'Who has been here',
  'Fundadores, investidores e executivos compartilhando suas experiencias.':
    'Founders, investors and executives sharing their experiences.',
  'Receba os melhores insights': 'Get the best insights',
  'Toda semana, um resumo dos melhores momentos do podcast + conteudo exclusivo direto na sua caixa de entrada. Junte-se a +50.000 assinantes.':
    'Every week, a summary of the best moments from the podcast + exclusive content straight to your inbox. Join +50,000 subscribers.',
  'Avaliacoes': 'Reviews',
  'O que os ouvintes dizem': 'What listeners say',
  'O melhor podcast de negocios do Brasil. Os insights sao incriveis e as entrevistas sao super profundas. Escuto todos os episodios.':
    'The best business podcast in Brazil. The insights are amazing and the interviews are super deep. I listen to every episode.',
  'Obrigada por criar esse conteudo incrivel! Aprendo mais ouvindo um episodio do que lendo varios livros de negocios.':
    'Thank you for creating this amazing content! I learn more listening to one episode than reading several business books.',
  'As perguntas que o Carlos faz sao cirurgicas. Ele consegue extrair dos convidados informacoes que voce nao acha em nenhum outro lugar.':
    'The questions Carlos asks are surgical. He manages to extract information from guests that you can\'t find anywhere else.',
  'Apoiadores do Podcast': 'Podcast Supporters',
  'Comece a ouvir agora': 'Start listening now',
  'Escolha sua plataforma favorita e junte-se a +500.000 ouvintes mensais que estao transformando suas carreiras.':
    'Choose your favorite platform and join +500,000 monthly listeners who are transforming their careers.',
  'O podcast sobre startups e negocios que voce precisa ouvir. Novos episodios toda segunda-feira.':
    'The podcast about startups and business you need to listen to. New episodes every Monday.',
  'Todos Episodios': 'All Episodes',
  'O Host': 'The Host',
  'Imprensa': 'Press',
  'Parcerias': 'Partnerships',
  'RSS Feed': 'RSS Feed',
  'StartupCast. Todos os direitos reservados.': 'StartupCast. All rights reserved.',

  // Event Template
  'Summit': 'Summit',
  'O maior evento de negócios e tecnologia do Brasil. Dois dias de conteúdo transformador com os maiores nomes do mercado.':
    'The biggest business and technology event in Brazil. Two days of transformative content with the biggest names in the market.',
  'Garantir Ingresso': 'Get Ticket',
  'Ver Programação': 'View Schedule',
  'Horas': 'Hours',
  'Min': 'Min',
  'Seg': 'Sec',
  'Line-up': 'Line-up',
  'Palestrantes Confirmados': 'Confirmed Speakers',
  'Fundadora': 'Founder',
  'Investidor Anjo': 'Angel Investor',

  // Book Launch Template
  'Best-seller': 'Best-seller',

  // Common Portuguese words without accents (template specific)
  'voce': 'you',
  'negocios': 'business',
  'historias': 'stories',
  'licoes': 'lessons',
  'nao': 'not',
  'missao': 'mission',
  'milhoes': 'million',
  'conteudo': 'content',
  'informacoes': 'information',
  'ouvintes': 'listeners',

  // =============================================
  // PetShop Premium Template
  // =============================================
  'Cuidado Premium para': 'Premium Care for',
  'Seu Pet': 'Your Pet',
  'Petshop completo com serviços veterinários, banho e tosa, produtos premium e muito carinho para seu melhor amigo.':
    'Complete pet shop with veterinary services, grooming, premium products and lots of love for your best friend.',
  'Agendar Consulta': 'Schedule Appointment',
  '+2.500 pets atendidos': '+2,500 pets served',
  'NOSSOS DIFERENCIAIS': 'OUR DIFFERENTIALS',
  'Por que escolher a PetCare Plus?': 'Why choose PetCare Plus?',
  'Veterinários Especializados': 'Specialized Veterinarians',
  'Equipe de veterinários experientes e apaixonados por animais.': 'Team of experienced veterinarians passionate about animals.',
  'Banho & Tosa Premium': 'Premium Grooming',
  'Serviços de estética completos com produtos premium.': 'Complete aesthetic services with premium products.',
  'Pet Shop Completo': 'Complete Pet Shop',
  'Rações premium, medicamentos, brinquedos e acessórios.': 'Premium food, medications, toys and accessories.',
  'O que nossos clientes falam': 'What our customers say',
  'A PetCare Plus salvou a vida da minha gatinha! Super recomendo!': 'PetCare Plus saved my kitten\'s life! I highly recommend!',
  'Tutora da Mimi': 'Mimi\'s owner',
  'Meu Thor adora ir na PetCare! Banho e tosa perfeitos.': 'My Thor loves going to PetCare! Perfect grooming.',
  'Tutor do Thor': 'Thor\'s owner',
  'Atendimento humanizado e profissionais competentes.': 'Humanized care and competent professionals.',
  'Tutora da Luna': 'Luna\'s owner',
  'Planos de Cuidado': 'Care Plans',
  'Cuidado Básico': 'Basic Care',
  '1 consulta veterinária': '1 veterinary consultation',
  'Banho básico mensal': 'Monthly basic bath',
  '10% desconto em produtos': '10% discount on products',
  'MAIS POPULAR': 'MOST POPULAR',
  'Cuidado Premium': 'Premium Care',
  '3 consultas veterinárias': '3 veterinary consultations',
  'Banho e tosa completa': 'Complete grooming',
  '20% desconto em produtos': '20% discount on products',
  'Cuidado VIP': 'VIP Care',
  'Consultas ilimitadas': 'Unlimited consultations',
  'Banho e tosa premium': 'Premium grooming',
  '30% desconto + emergência 24h': '30% discount + 24h emergency',
  'Pronto para cuidar melhor do seu pet?': 'Ready to take better care of your pet?',
  'Agendar Agora': 'Schedule Now',
  'Cuidando do seu pet com amor há mais de 15 anos.': 'Caring for your pet with love for over 15 years.',
  '© 2024 PetCare Plus. Todos os direitos reservados.': '© 2024 PetCare Plus. All rights reserved.',

  // =============================================
  // Modern SaaS Template (Additional)
  // =============================================
  '✨ Novo: Integração com IA disponível': '✨ New: AI Integration available',
  'Automatize seu negócio com': 'Automate your business with',
  'inteligência': 'intelligence',
  'A plataforma completa que une automação, analytics e IA para escalar seu negócio. Mais de 10.000 empresas já confiam em nós.':
    'The complete platform that combines automation, analytics and AI to scale your business. More than 10,000 companies already trust us.',
  'Começar Grátis →': 'Get Started Free →',
  '✓ 7 dias grátis · ✓ Sem cartão de crédito · ✓ Cancele quando quiser': '✓ 7 days free · ✓ No credit card · ✓ Cancel anytime',
  'Empresas que confiam em nós': 'Companies that trust us',
  'Tudo que você precisa para crescer': 'Everything you need to grow',
  'Ferramentas poderosas para automatizar, analisar e escalar seu negócio': 'Powerful tools to automate, analyze and scale your business',
  'Automação Inteligente': 'Smart Automation',
  'Automatize tarefas repetitivas e economize horas de trabalho toda semana com nossa IA.':
    'Automate repetitive tasks and save hours of work every week with our AI.',
  'Analytics Avançado': 'Advanced Analytics',
  'Dashboards em tempo real com insights acionáveis para tomar decisões melhores.':
    'Real-time dashboards with actionable insights to make better decisions.',
  '+100 Integrações': '+100 Integrations',
  'Conecte todas suas ferramentas favoritas em um só lugar, sem código.':
    'Connect all your favorite tools in one place, no code.',
  'Triplicamos nossa produtividade em 3 meses. A automação é simplesmente incrível!':
    'We tripled our productivity in 3 months. The automation is simply amazing!',
  'O melhor investimento que fiz para minha empresa. ROI em menos de 30 dias.':
    'The best investment I made for my company. ROI in less than 30 days.',
  'Finalmente uma plataforma que entrega o que promete. Suporte excepcional!':
    'Finally a platform that delivers what it promises. Exceptional support!',
  'Planos para todos os tamanhos': 'Plans for all sizes',
  'Starter': 'Starter',
  'Para quem está começando': 'For those just starting',
  'Até 1.000 contatos': 'Up to 1,000 contacts',
  '1 automação': '1 automation',
  'Para negócios em crescimento': 'For growing businesses',
  'Contatos ilimitados': 'Unlimited contacts',
  'Automações ilimitadas': 'Unlimited automations',
  'Integrações premium': 'Premium integrations',
  'Suporte prioritário 24/7': 'Priority support 24/7',
  'Assinar Pro': 'Subscribe Pro',
  'Tudo do Pro': 'Everything from Pro',
  'Manager dedicado': 'Dedicated manager',
  'API personalizada': 'Custom API',
  'Pronto para começar?': 'Ready to get started?',
  'Junte-se a milhares de empresas que já transformaram seus negócios.':
    'Join thousands of companies that have already transformed their businesses.',
  'Criar Conta Grátis →': 'Create Free Account →',
  'Sem cartão de crédito · Setup em 2 minutos': 'No credit card · Setup in 2 minutes',
  'A plataforma de automação mais completa para escalar seu negócio.':
    'The most complete automation platform to scale your business.',
  'Produto': 'Product',
  '© 2025 SuaMarca. Todos os direitos reservados.': '© 2025 YourBrand. All rights reserved.',
  'Termos': 'Terms',

  // =============================================
  // Restaurant / Food Template
  // =============================================
  'Cardápio': 'Menu',
  '✦ Desde 1985 ✦': '✦ Since 1985 ✦',
  'Uma experiência gastronômica inesquecível': 'An unforgettable gastronomic experience',
  'Ingredientes frescos, receitas tradicionais e um ambiente acolhedor. Venha descobrir os sabores que conquistam paladares há gerações.':
    'Fresh ingredients, traditional recipes and a cozy atmosphere. Come discover the flavors that have been winning palates for generations.',
  'Fazer Reserva': 'Make Reservation',
  'Carta de Vinhos': 'Wine List',
  '+200 rótulos selecionados': '+200 selected labels',
  'Chef Premiado': 'Award-winning Chef',
  '25 anos de experiência': '25 years of experience',
  'Ingredientes locais': 'Local ingredients',
  '4.9 no Google': '4.9 on Google',
  '+2.000 avaliações': '+2,000 reviews',
  'Nossa História': 'Our Story',
  'Tradição e paixão pela gastronomia desde 1985': 'Tradition and passion for gastronomy since 1985',
  'Há quase 40 anos, o La Maison é referência em alta gastronomia na cidade. Fundado pelo Chef Pierre Dubois, nosso restaurante combina técnicas clássicas francesas com ingredientes brasileiros da mais alta qualidade.':
    'For almost 40 years, La Maison has been a reference in haute cuisine in the city. Founded by Chef Pierre Dubois, our restaurant combines classic French techniques with Brazilian ingredients of the highest quality.',
  'Cada prato é uma celebração de sabores, preparado com ingredientes frescos selecionados diariamente de produtores locais que compartilham nossa paixão por qualidade.':
    'Each dish is a celebration of flavors, prepared with fresh ingredients selected daily from local producers who share our passion for quality.',
  'Nossos Pratos em Destaque': 'Our Featured Dishes',
  'Salmão Grelhado': 'Grilled Salmon',
  'Com risoto de limão siciliano e legumes da estação': 'With Sicilian lemon risotto and seasonal vegetables',
  'Filé mignon com molho de cogumelos e batata rústica': 'Filet mignon with mushroom sauce and rustic potatoes',
  'Arroz arbóreo, mix de cogumelos e parmesão': 'Arborio rice, mushroom mix and parmesan',
  'Melhor restaurante da cidade! A experiência gastronômica é incrível e o atendimento impecável. Voltaremos com certeza.':
    'Best restaurant in town! The gastronomic experience is incredible and the service impeccable. We will definitely be back.',
  'Há 2 semanas': '2 weeks ago',
  'Há 1 mês': '1 month ago',
  'O salmão grelhado é simplesmente perfeito. Ambiente aconchegante e carta de vinhos excepcional. Recomendo muito!':
    'The grilled salmon is simply perfect. Cozy atmosphere and exceptional wine list. Highly recommend!',
  'Comemoramos nosso aniversário de casamento aqui e foi mágico. Cada detalhe pensado com carinho. Nota 10!':
    'We celebrated our wedding anniversary here and it was magical. Every detail thoughtfully crafted. 10/10!',
  'Reservas': 'Reservations',
  'Reserve sua mesa para uma noite especial': 'Reserve your table for a special night',
  'Garanta seu lugar no La Maison e viva uma experiência gastronômica única. Aceitamos reservas para grupos de até 20 pessoas.':
    'Secure your spot at La Maison and experience a unique gastronomic experience. We accept reservations for groups up to 20 people.',
  'Ter-Dom: 19h às 23h': 'Tue-Sun: 7pm to 11pm',
  'Faça sua Reserva': 'Make Your Reservation',
  'Preencha os dados abaixo': 'Fill in the details below',
  'Nome completo': 'Full name',
  '2 pessoas': '2 guests',
  '4 pessoas': '4 guests',
  '6 pessoas': '6 guests',
  '8+ pessoas': '8+ guests',
  'Aniversário': 'Birthday',
  'Jantar romântico': 'Romantic dinner',
  'Outra': 'Other',
  'Confirmar Reserva': 'Confirm Reservation',
  'Como Chegar': 'How to Get Here',
  'Ter a Dom: 19h às 23h': 'Tue to Sun: 7pm to 11pm',
  '[Mapa do Google Maps aqui]': '[Google Maps here]',

  // =============================================
  // Coaching & Mentoring Template
  // =============================================
  '⭐ Mentor de Alta Performance': '⭐ High Performance Mentor',
  'Desbloqueie seu': 'Unlock your',
  'potencial máximo': 'maximum potential',
  'e alcance resultados extraordinários': 'and achieve extraordinary results',
  'Agendar Sessão Gratuita →': 'Schedule Free Session →',
  'Profissionais transformados': 'Professionals transformed',
  'Taxa de satisfação': 'Satisfaction rate',
  'Clientes atendidos': 'Clients served',
  'Sessão Estratégica': 'Strategic Session',
  'Sessão individual de 90 minutos para clareza imediata sobre sua situação e próximos passos.':
    '90-minute individual session for immediate clarity on your situation and next steps.',
  'Acompanhamento personalizado durante 3 meses com encontros semanais e suporte via WhatsApp.':
    'Personalized follow-up for 3 months with weekly meetings and WhatsApp support.',
  'Programa Executivo': 'Executive Program',
  'Programa completo de 6 meses para profissionais em posições de liderança ou em transição.':
    'Complete 6-month program for professionals in leadership positions or in transition.',
  'Um processo estruturado para resultados consistentes': 'A structured process for consistent results',
  'Diagnóstico': 'Diagnosis',
  'Entendemos sua situação atual, objetivos e obstáculos': 'We understand your current situation, goals and obstacles',
  'Estratégia': 'Strategy',
  'Criamos um plano personalizado com metas claras': 'We create a personalized plan with clear goals',
  'Ação': 'Action',
  'Implementação com acompanhamento semanal': 'Implementation with weekly follow-up',
  'Mensuração e ajustes para evolução contínua': 'Measurement and adjustments for continuous evolution',
  'Quem é João Silva': 'Who is João Silva',
  'Executivo com 20+ anos em multinacionais, hoje dedico minha experiência a ajudar profissionais a acelerarem suas carreiras.':
    'Executive with 20+ years in multinationals, today I dedicate my experience to helping professionals accelerate their careers.',
  'Já mentorei mais de 500 profissionais, de analistas a C-levels, em empresas como Google, Itaú, Ambev e startups em crescimento.':
    'I have mentored more than 500 professionals, from analysts to C-levels, in companies like Google, Itaú, Ambev and growing startups.',
  'MBA Harvard': 'MBA Harvard',
  'ICF Certified': 'ICF Certified',
  'Ex-VP Google': 'Ex-VP Google',
  'Palestrante TEDx': 'TEDx Speaker',
  'Transformações Reais': 'Real Transformations',
  'Histórias de profissionais que transformaram suas carreiras': 'Stories of professionals who transformed their careers',
  'De gerente a diretora em 8 meses': 'From manager to director in 8 months',
  'Promoção + aumento de 40%': 'Promotion + 40% raise',
  'Transição de carreira bem-sucedida': 'Successful career transition',
  'Gerente de Produto': 'Product Manager',
  'Engenheiro de Software': 'Software Engineer',
  'Head de Marketing': 'Head of Marketing',
  'Respostas para as perguntas mais comuns': 'Answers to the most common questions',
  'Como sei se a mentoria é para mim?': 'How do I know if mentoring is for me?',
  'Se você está em busca de crescimento profissional, está travado em algum aspecto da carreira ou quer acelerar seus resultados, a mentoria pode ajudar. Agende uma sessão gratuita para conversarmos.':
    'If you are looking for professional growth, are stuck in some aspect of your career or want to accelerate your results, mentoring can help. Schedule a free session to talk.',
  'Quanto tempo leva para ver resultados?': 'How long does it take to see results?',
  'Muitos mentorados relatam clareza e direcionamento já na primeira sessão. Resultados tangíveis como promoções ou mudanças de emprego geralmente acontecem entre 2-6 meses.':
    'Many mentees report clarity and direction from the first session. Tangible results like promotions or job changes usually happen between 2-6 months.',
  'Como são os encontros?': 'How are the meetings?',
  'Os encontros são por videochamada (Zoom), em horários flexíveis. Entre os encontros, você terá acesso a mim por WhatsApp para dúvidas rápidas.':
    'Meetings are by video call (Zoom), at flexible times. Between meetings, you will have access to me via WhatsApp for quick questions.',
  'Vamos Conversar?': 'Shall We Talk?',
  'Agende uma sessão estratégica gratuita de 30 minutos': 'Schedule a free 30-minute strategic session',
  'Preencha o formulário que entraremos em contato em até 24h.': 'Fill out the form and we will contact you within 24 hours.',
  'Conte-nos sobre você e seus objetivos': 'Tell us about yourself and your goals',
  'Enviar Mensagem': 'Send Message',
  'Não espere mais para dar o próximo passo. Agende agora sua sessão gratuita.':
    'Don\'t wait any longer to take the next step. Schedule your free session now.',
  '© 2024 João Silva Mentoria. Todos os direitos reservados.': '© 2024 João Silva Mentoring. All rights reserved.',

  // =============================================
  // Booking / Consultation Template
  // =============================================
  '📅 Agende sua consulta': '📅 Schedule your consultation',
  'Sessões personalizadas de 1 hora para acelerar seus resultados profissionais. Mais de 500 profissionais já transformaram suas carreiras.':
    'Personalized 1-hour sessions to accelerate your professional results. Over 500 professionals have already transformed their careers.',
  'Sessões de 60 minutos via Zoom': '60-minute sessions via Zoom',
  'Plano de ação personalizado': 'Personalized action plan',
  'Suporte por WhatsApp por 7 dias': 'WhatsApp support for 7 days',
  'Escolha o melhor horário para você': 'Choose the best time for you',
  'Mentoria de Carreira - R$ 297': 'Career Mentoring - $297',
  'Revisão de Currículo - R$ 147': 'Resume Review - $147',
  'Preparação para Entrevista - R$ 197': 'Interview Preparation - $197',
  'Data preferida': 'Preferred date',
  'Agendar Agora →': 'Schedule Now →',
  '🔒 Pagamento seguro • Satisfação garantida': '🔒 Secure payment • Satisfaction guaranteed',
  'Pagamento seguro': 'Secure payment',
  'Satisfação garantida': 'Satisfaction guaranteed',

  // =============================================
  // Black Friday / Promotion Template
  // =============================================
  '🔥 Oferta por tempo limitado': '🔥 Limited time offer',
  'Os maiores descontos do ano. Só até domingo!': 'The biggest discounts of the year. Only until Sunday!',
  'Ver Ofertas →': 'See Offers →',
  '*Válido enquanto durarem os estoques': '*Valid while supplies last',
  'Ofertas em Destaque': 'Featured Offers',
  'Smart Watch Pro': 'Smart Watch Pro',
  'Headphone Wireless': 'Wireless Headphone',
  'Perfume Premium': 'Premium Perfume',

  // =============================================
  // Book Launch Template (Additional)
  // =============================================
  'Depois de construir 5 empresas de sucesso, João Silva revela neste livro as estratégias e mentalidades que o ajudaram a prosperar mesmo nos momentos mais difíceis do mercado.':
    'After building 5 successful companies, João Silva reveals in this book the strategies and mindsets that helped him thrive even in the most difficult market moments.',
  'Comprar Agora - R$ 59,90': 'Buy Now - $59.90',
  'Ler Primeiro Capítulo': 'Read First Chapter',

  // =============================================
  // Webinar / Event Template
  // =============================================
  '🔴 AO VIVO - Vagas Limitadas': '🔴 LIVE - Limited Spots',
  'Masterclass Gratuita:': 'Free Masterclass:',
  'Como Escalar para 7 Dígitos': 'How to Scale to 7 Figures',
  'Descubra o método exato que usei para sair de R$0 para R$1M em faturamento em apenas 18 meses.':
    'Discover the exact method I used to go from $0 to $1M in revenue in just 18 months.',
  'Inscricao confirmada! Verifique seu e-mail para os detalhes.': 'Registration confirmed! Check your email for details.',
  'GARANTIR MINHA VAGA GRÁTIS': 'SECURE MY FREE SPOT',
  'Restam apenas 127 vagas': 'Only 127 spots remaining',
  '20 de Janeiro, 20h': 'January 20, 8pm',
  '2 horas de conteúdo': '2 hours of content',
  'Bônus exclusivos': 'Exclusive bonuses',
  'Empreendedor serial com mais de 15 anos de experiência. Fundador de 3 startups de sucesso e mentor de mais de 500 empreendedores.':
    'Serial entrepreneur with over 15 years of experience. Founder of 3 successful startups and mentor to over 500 entrepreneurs.',
  'em vendas geradas': 'in sales generated',
  'alunos mentorados': 'students mentored',

  // =============================================
  // Common Action Buttons & CTAs
  // =============================================
  'Agendar Diagnóstico Gratuito': 'Schedule Free Diagnosis',
  'Baixar para iOS': 'Download for iOS',
  'Baixar para Android': 'Download for Android',
  'Começar um projeto': 'Start a project',
  'Ver portfólio': 'View portfolio',
  'Ver todos os projetos': 'View all projects',
  'Falar com vendas': 'Talk to sales',
  'Baixe o App': 'Download the App',
  'Evento ao vivo': 'Live event',
  'Entrar na lista': 'Join the list',
  'Quero ser avisado': 'I want to be notified',

  // =============================================
  // Course / Education Templates
  // =============================================
  'Fundamentos do Python': 'Python Fundamentals',
  'Estruturas de Dados e Algoritmos': 'Data Structures and Algorithms',
  'Web com Django e Flask': 'Web with Django and Flask',
  'Programação Orientada a Objetos': 'Object-Oriented Programming',
  'O método definitivo para você se tornar um programador Python completo': 'The definitive method for you to become a complete Python programmer',
  '+150 aulas em vídeo HD': '+150 HD video lessons',
  'Projetos práticos do mundo real': 'Real-world practical projects',
  'Certificado reconhecido pelo mercado': 'Market-recognized certificate',
  'Comunidade exclusiva de alunos': 'Exclusive student community',
  'Garantia Incondicional de 30 Dias': '30-Day Unconditional Guarantee',
  '© 2024 Curso Python Completo. Todos os direitos reservados.': '© 2024 Complete Python Course. All rights reserved.',

  // =============================================
  // SaaS / App Templates
  // =============================================
  '+15 anos de experiência': '+15 years of experience',
  '+2.500 pessoas já estão na lista de espera': '+2,500 people are already on the waiting list',
  'Valor: R$ 197,00/ano - GRÁTIS': 'Value: $197.00/year - FREE',
  'Valor: R$ 297,00 - GRÁTIS': 'Value: $297.00 - FREE',
  '✓ 1 automação': '✓ 1 automation',
  '✓ Até 1.000 contatos': '✓ Up to 1,000 contacts',
  '✓ Automações ilimitadas': '✓ Unlimited automations',
  '✓ 1 usuário': '✓ 1 user',
  '✓ 5 usuários': '✓ 5 users',
  '✓ Até 100 contatos': '✓ Up to 100 contacts',
  'Automatize tarefas repetitivas e foque no que realmente importa': 'Automate repetitive tasks and focus on what really matters',
  'Criptografia de ponta e autenticação biométrica': 'Cutting-edge encryption and biometric authentication',
  'Consigo importar dados de outra ferramenta?': 'Can I import data from another tool?',
  'Posso testar antes de assinar?': 'Can I try before subscribing?',
  'Vocês oferecem suporte em português?': 'Do you offer support in Portuguese?',
  '© 2025 Finança+. Todos os direitos reservados.': '© 2025 Finance+. All rights reserved.',

  // =============================================
  // Agency / Portfolio Templates
  // =============================================
  'Criamos marcas memoráveis com identidade visual única': 'We create memorable brands with unique visual identity',
  '© 2025 StudioX. Todos os direitos reservados.': '© 2025 StudioX. All rights reserved.',
  '© 2024 Studio. Todos os direitos reservados.': '© 2024 Studio. All rights reserved.',

  // =============================================
  // Newsletter / Content Templates
  // =============================================
  'Edição #147 • O futuro do trabalho remoto': 'Edition #147 • The future of remote work',
  'Tendências de E-commerce para 2025': 'E-commerce Trends for 2025',
  'Receba insights exclusivos toda semana': 'Receive exclusive insights every week',
  'Junte-se a milhares de leitores': 'Join thousands of readers',

  // =============================================
  // Fitness / Gym Templates
  // =============================================
  '+45% de aumento salarial': '+45% salary increase',
  '7 dias de garantia incondicional': '7 days unconditional guarantee',
  '4.9 (2.847 avaliações)': '4.9 (2,847 reviews)',

  // =============================================
  // Contact & Location Info
  // =============================================
  'Rua das Flores, 123 - Jardins, São Paulo': 'Rua das Flores, 123 - Jardins, São Paulo',
  'São Paulo, Brasil': 'São Paulo, Brazil',
  'WhatsApp: (11) 98765-4321': 'WhatsApp: (11) 98765-4321',

  // =============================================
  // Testimonials - Common Phrases
  // =============================================
  'Transformou minha carreira': 'Transformed my career',
  'Recomendo para todos': 'I recommend to everyone',
  'Melhor investimento que fiz': 'Best investment I made',
  'Superou minhas expectativas': 'Exceeded my expectations',
  'Atendimento excelente': 'Excellent service',
  'Produto de qualidade': 'Quality product',
  'Entrega rápida': 'Fast delivery',
  'Voltarei a comprar': 'I will buy again',
  'Muito satisfeito': 'Very satisfied',
  'Vale cada centavo': 'Worth every penny',

  // =============================================
  // Common Text Without Accents (normalize)
  // =============================================
  'sao': 'are',
  'tambem': 'also',
  'esta': 'is',
  'entao': 'then',
  'ja': 'already',
  'ate': 'until',
  'documentacao': 'documentation',
  'recepcao': 'reception',
  'promocao': 'promotion',
  'comunicacao': 'communication',
  'organizacao': 'organization',

  // =============================================
  // Lead Capture Pro Template - Additional
  // =============================================
  'E-book Gratuito - Edição 2025': 'Free E-book - 2025 Edition',
  '© 2025 SuaEmpresa. Todos os direitos reservados.': '© 2025 YourCompany. All rights reserved.',

  // =============================================
  // Newsletter Premium Template - Additional
  // =============================================
  'Inscrição confirmada! Verifique seu e-mail.': 'Registration confirmed! Check your email.',
  '✓ 100% gratuito': '✓ 100% free',
  '✓ Cancele quando quiser': '✓ Cancel anytime',
  '✓ Sem spam, prometemos': '✓ No spam, we promise',
  'Direto ao Ponto': 'Straight to the Point',
  'Conteúdo objetivo e bem estruturado. Leitura de apenas 5 minutos que vale horas de pesquisa.':
    'Objective and well-structured content. Just 5 minutes of reading worth hours of research.',
  '100% Acionável': '100% Actionable',
  'Estratégias práticas que você pode implementar imediatamente no seu negócio.':
    'Practical strategies you can implement immediately in your business.',
  'Cases Reais': 'Real Cases',
  'Estudos de caso detalhados de empresas que estão inovando e crescendo.':
    'Detailed case studies of companies that are innovating and growing.',
  'Tendências': 'Trends',
  'Fique à frente da concorrência com previsões e análises de para onde o mercado está indo.':
    'Stay ahead of the competition with forecasts and analysis of where the market is heading.',
  'Recursos Exclusivos': 'Exclusive Resources',
  'Templates, checklists e ferramentas gratuitas disponíveis apenas para assinantes.':
    'Templates, checklists and free tools available only to subscribers.',
  'Veja Uma Prévia do Conteúdo': 'See a Content Preview',
  'Cada edição é cuidadosamente preparada para entregar valor real. Sem enrolação, sem conteúdo de preenchimento.':
    'Each edition is carefully prepared to deliver real value. No fluff, no filler content.',
  'Resumo executivo das principais notícias da semana': 'Executive summary of the week\'s top news',
  'Uma estratégia detalhada para implementar': 'A detailed strategy to implement',
  'Case de sucesso com análise completa': 'Success case with complete analysis',
  'Ferramenta ou recurso recomendado da semana': 'Tool or recommended resource of the week',
  'Dica rápida para aplicar hoje mesmo': 'Quick tip to apply today',
  '🚀 Esta semana: Como a IA está transformando vendas B2B':
    '🚀 This week: How AI is transforming B2B sales',
  'Empresas que adotaram ferramentas de IA em seus processos de vendas viram um aumento médio de 35% na taxa de conversão. Nesta edição, vamos explorar exatamente quais ferramentas estão gerando esses resultados e como você pode implementá-las...':
    'Companies that adopted AI tools in their sales processes saw an average 35% increase in conversion rate. In this edition, we\'ll explore exactly which tools are generating these results and how you can implement them...',
  'Milhares de profissionais já transformaram suas terças-feiras': 'Thousands of professionals have already transformed their Tuesdays',
  'A única newsletter que eu realmente leio toda semana. Conteúdo relevante e insights que já apliquei várias vezes no meu negócio.':
    'The only newsletter I actually read every week. Relevant content and insights I have applied multiple times in my business.',
  'Me sinto mais preparado para as reuniões de diretoria. Os insights desta newsletter me deram argumentos que impressionaram o board.':
    'I feel more prepared for board meetings. The insights from this newsletter gave me arguments that impressed the board.',
  'Diretor de Marketing': 'Marketing Director',
  '5 minutos de leitura que valem mais que muitos cursos. Cancelei outras 3 newsletters depois de assinar esta.':
    '5 minutes of reading worth more than many courses. I cancelled 3 other newsletters after subscribing to this one.',
  'Fundadora, AgênciaX': 'Founder, AgencyX',
  'Edições Recentes': 'Recent Editions',
  'Confira alguns dos temas que já abordamos': 'Check out some of the topics we have covered',
  'O Futuro da IA Generativa nos Negócios': 'The Future of Generative AI in Business',
  'Como empresas estão usando ChatGPT e similares...': 'How companies are using ChatGPT and similar tools...',
  'As 5 mudanças que vão definir o varejo online...': 'The 5 changes that will define online retail...',
  'Como Escalar Sem Perder Qualidade': 'How to Scale Without Losing Quality',
  'Lições de empresas que triplicaram de tamanho...': 'Lessons from companies that tripled in size...',
  'Planejamento Estratégico que Funciona': 'Strategic Planning That Works',
  'Framework usado pelas maiores empresas...': 'Framework used by the largest companies...',
  'Junte-se a 25.000+ Leitores': 'Join 25,000+ Readers',
  'Receba insights valiosos toda terça-feira. Grátis para sempre.':
    'Receive valuable insights every Tuesday. Free forever.',
  'Quero Receber': 'I Want to Receive',
  '© 2025 Newsletter Premium. Todos os direitos reservados.': '© 2025 Newsletter Premium. All rights reserved.',
  'Edições Anteriores': 'Previous Editions',

  // =============================================
  // Waitlist / Coming Soon Template
  // =============================================
  'Você está na lista! Enviaremos novidades em primeira mão.': 'You are on the list! We will send you news first-hand.',

  // =============================================
  // App Download Template
  // =============================================
  '📱 +2 milhões de downloads': '📱 +2 million downloads',
  'Sua vida financeira': 'Your financial life',
  'simplificada': 'simplified',
  'Controle gastos, crie metas de economia e invista de forma inteligente. Tudo em um único app, na palma da sua mão.':
    'Control spending, create savings goals and invest smartly. All in one app, in the palm of your hand.',
  'Baixar na': 'Download on',
  'Disponível no': 'Available on',
  'Satisfação': 'Satisfaction',
  'Tudo que você precisa em um único app': 'Everything you need in one app',
  'Funcionalidades pensadas para simplificar sua vida financeira':
    'Features designed to simplify your financial life',
  'Dashboard Intuitivo': 'Intuitive Dashboard',
  'Visualize todos seus gastos e receitas em gráficos fáceis de entender':
    'View all your expenses and income in easy-to-understand charts',
  'Metas Inteligentes': 'Smart Goals',
  'Defina objetivos financeiros e acompanhe seu progresso em tempo real':
    'Set financial goals and track your progress in real time',
  'Alertas Personalizados': 'Custom Alerts',
  'Receba notificações sobre gastos, vencimentos e metas atingidas':
    'Receive notifications about expenses, due dates and goals achieved',
  'Multi-bancos': 'Multi-bank',
  'Conecte todas suas contas em um só lugar automaticamente':
    'Connect all your accounts in one place automatically',
  'Offline Mode': 'Offline Mode',
  'Acesse seus dados mesmo sem conexão com a internet':
    'Access your data even without internet connection',
  '100% Seguro': '100% Secure',
  'Comece em 3 passos simples': 'Get started in 3 simple steps',
  'Configure tudo em menos de 2 minutos': 'Set up everything in less than 2 minutes',
  'Disponível gratuitamente na App Store e Google Play': 'Available for free on the App Store and Google Play',
  'Crie sua Conta': 'Create Your Account',
  'Cadastro rápido com e-mail ou redes sociais': 'Quick registration with email or social networks',
  'Conecte Bancos': 'Connect Banks',
  'Importe suas contas de forma segura e automática': 'Import your accounts securely and automatically',
  'Acompanhe': 'Track',
  'Veja tudo organizado e tome decisões melhores': 'See everything organized and make better decisions',
  'O que dizem sobre o app': 'What they say about the app',
  'Mais de 50.000 avaliações 5 estrelas nas lojas': 'More than 50,000 5-star reviews in the stores',
  'Finalmente consegui organizar minhas finanças! O app é super intuitivo e as metas me ajudam a economizar todos os meses.':
    'I finally managed to organize my finances! The app is super intuitive and the goals help me save every month.',
  'Melhor app de finanças que já usei. A conexão com os bancos é perfeita e os relatórios são muito completos.':
    'Best finance app I have ever used. The connection with banks is perfect and the reports are very complete.',
  'Economizei R$3.000 em 3 meses usando as metas do app. Recomendo para todo mundo que quer ter controle do dinheiro.':
    'I saved $3,000 in 3 months using the app\'s goals. I recommend it to everyone who wants to have control of their money.',
  'Baixe grátis e comece hoje': 'Download for free and start today',
  'Junte-se a mais de 2 milhões de pessoas que já transformaram sua vida financeira':
    'Join more than 2 million people who have already transformed their financial life',
  '© 2025 FinanceApp. Todos os direitos reservados.': '© 2025 FinanceApp. All rights reserved.',

  // =============================================
  // Course Online Pro Template - Additional
  // =============================================
  'do zero ao avançado': 'from zero to advanced',
  'O método definitivo para você se tornar um programador Python completo, mesmo que nunca tenha escrito uma linha de código.':
    'The definitive method for you to become a complete Python programmer, even if you have never written a line of code.',
  'Oferta especial por tempo limitado': 'Special offer for limited time',
  'de R$ 1.997': 'from R$ 1,997',
  '12x de R$99,70': '12x of $99.70',
  'ou R$997 à vista': 'or $997 cash',
  'O Problema': 'The Problem',
  'Você já se sentiu assim?': 'Have you ever felt this way?',
  'Muitos iniciantes enfrentam esses desafios ao tentar aprender programação':
    'Many beginners face these challenges when trying to learn programming',
  'Conteúdo confuso e desorganizado': 'Confusing and disorganized content',
  'Tutoriais espalhados que não seguem uma lógica progressiva':
    'Scattered tutorials that don\'t follow progressive logic',
  'Falta de prática real': 'Lack of real practice',
  'Teoria demais sem aplicação em projetos do mundo real':
    'Too much theory without application in real-world projects',
  'Sem suporte adequado': 'No proper support',
  'Ficar travado sem ter a quem recorrer para tirar dúvidas':
    'Getting stuck with no one to turn to for questions',
  'A Solução': 'The Solution',
  'O que você vai conquistar': 'What you will achieve',
  'Com o método certo, você vai dominar Python e transformar sua carreira':
    'With the right method, you will master Python and transform your career',
  'Código limpo e organizado': 'Clean and organized code',
  'Aprenda as melhores práticas desde o início':
    'Learn best practices from the start',
  'Projetos reais no portfólio': 'Real projects in your portfolio',
  'Construa aplicações que impressionam recrutadores':
    'Build applications that impress recruiters',
  'Confiança para entrevistas': 'Confidence for interviews',
  'Domine conceitos que são cobrados em processos seletivos':
    'Master concepts that are tested in selection processes',
  'Comunidade de suporte': 'Support community',
  'Tire dúvidas e faça networking com outros alunos':
    'Ask questions and network with other students',
  'Conteúdo do Curso': 'Course Content',
  'Uma jornada completa do básico ao avançado': 'A complete journey from basic to advanced',
  'Módulo': 'Module',
  'aulas': 'lessons',

  // =============================================
  // Portfolio / Creative Template
  // =============================================
  '© 2024 João.design. Todos os direitos reservados.': '© 2024 João.design. All rights reserved.',

  // =============================================
  // Digital Agency Template - Additional
  // =============================================
  '✨ Agência premiada 2024': '✨ Award-winning agency 2024',
  'CMO, E-commerce XYZ': 'CMO, E-commerce XYZ',
  'Vamos começar seu projeto?': 'Shall we start your project?',
  'Conte-nos sobre sua ideia e entraremos em contato em até 24 horas.':
    'Tell us about your idea and we will get back to you within 24 hours.',
  'Pronto para transformar sua ideia em realidade?': 'Ready to turn your idea into reality?',
  'Entre em contato e vamos criar algo incrível juntos.':
    'Get in touch and let\'s create something amazing together.',
  'Iniciar Projeto': 'Start Project',
  'Iniciar Conversa': 'Start Conversation',
  'Agência de design e tecnologia criando produtos digitais que as pessoas amam.':
    'Design and technology agency creating digital products that people love.',
  'Legal': 'Legal',

  // =============================================
  // Restaurant / Food Template - Additional
  // =============================================
  '© 2025 La Maison Restaurante. Todos os direitos reservados.':
    '© 2025 La Maison Restaurant. All rights reserved.',

  // =============================================
  // Clinic / Health Template
  // =============================================
  'Cuidando da sua saude': 'Taking care of your health',
  'com excelencia e dedicacao': 'with excellence and dedication',
  'Ha mais de 15 anos, oferecemos atendimento medico de qualidade com profissionais especializados e infraestrutura moderna para cuidar de voce e sua familia.':
    'For over 15 years, we have provided quality medical care with specialized professionals and modern infrastructure to take care of you and your family.',
  'Conheca Nossa Estrutura': 'See Our Facilities',
  'Anos de experiencia': 'Years of experience',
  'Consultas realizadas': 'Consultations performed',
  'Sobre a Clinica': 'About the Clinic',
  'Referencia em atendimento medico de qualidade': 'Reference in quality medical care',
  'Fundada em 2009, a VidaClinic nasceu com a missao de oferecer atendimento medico humanizado e de excelencia.':
    'Founded in 2009, VidaClinic was born with the mission of providing humanized and excellent medical care.',
  'Contamos com uma equipe de mais de 30 especialistas dedicados a cuidar da sua saude.':
    'We have a team of more than 30 specialists dedicated to taking care of your health.',
  'Mensagem (opcional)': 'Message (optional)',
  '© 2024 VidaClinic. Todos os direitos reservados.': '© 2024 VidaClinic. All rights reserved.',
  'ANVISA Aprovado': 'ANVISA Approved',
  'Certificado ISO 9001': 'ISO 9001 Certified',
  'Seg a Sex: 7h - 20h': 'Mon to Fri: 7am - 8pm',
  'Sabado: 8h - 14h': 'Saturday: 8am - 2pm',

  // =============================================
  // Real Estate Template
  // =============================================
  'Seu imovel dos sonhos': 'Your dream property',
  'esta aqui': 'is here',
  'Encontre o imovel perfeito para sua familia. Casas, apartamentos e terrenos nas melhores localizacoes da cidade.':
    'Find the perfect property for your family. Houses, apartments and land in the best locations in the city.',
  'Ver Imoveis': 'View Properties',
  'Falar com Corretor': 'Talk to Agent',
  'Imoveis vendidos': 'Properties sold',
  'O Que Fazemos': 'What We Do',
  'Servicos completos para sua jornada imobiliaria': 'Complete services for your real estate journey',
  'Compra de Imoveis': 'Property Purchase',
  'Ajudamos voce a encontrar o imovel perfeito': 'We help you find the perfect property',
  'Venda de Imoveis': 'Property Sale',
  'Vendemos seu imovel pelo melhor preco': 'We sell your property for the best price',
  'Imoveis para alugar com toda seguranca': 'Properties for rent with complete security',
  'Avaliacao profissional do seu imovel': 'Professional appraisal of your property',
  'Quem Somos': 'Who We Are',
  'Sua imobiliaria de confianca ha 20 anos': 'Your trusted real estate agency for 20 years',
  'Com duas decadas de experiencia no mercado imobiliario, a PrimeImoveis se consolidou como referencia em qualidade e confianca.':
    'With two decades of experience in the real estate market, PrimeImoveis has established itself as a reference in quality and trust.',
  'Nossa equipe de corretores altamente qualificados esta pronta para encontrar o imovel ideal para voce.':
    'Our team of highly qualified agents is ready to find the ideal property for you.',
  'Atendimento personalizado': 'Personalized service',
  'Documentacao assistida': 'Assisted documentation',
  'Nossos Corretores': 'Our Agents',
  'Profissionais experientes prontos para ajudar': 'Experienced professionals ready to help',
  'CRECI': 'CRECI',
  'Encontre seu lar': 'Find your home',
  'Entre em contato e deixe-nos ajudar voce a realizar o sonho da casa propria.':
    'Get in touch and let us help you achieve the dream of owning your own home.',
  'Tipo de imovel': 'Property type',
  'Sua imobiliaria de confianca para encontrar o imovel perfeito.':
    'Your trusted real estate agency to find the perfect property.',
  'Institucional': 'Institutional',
  'Acompanhamento': 'Follow-up',
  '© 2025 PrimeImoveis. Todos os direitos reservados. CRECI 12345-J':
    '© 2025 PrimeImoveis. All rights reserved. CRECI 12345-J',

  // =============================================
  // Fitness / Gym Template
  // =============================================
  'Primeira semana gratis': 'First week free',

  // =============================================
  // Common Miscellaneous
  // =============================================
  'Servicos': 'Services',

  // =============================================
  // Lead Capture Pro - Additional
  // =============================================
  'João Silva': 'John Silva',
  '"Implementei apenas 3 estratégias do e-book e aumentei minhas vendas em 40% no primeiro mês. O conteúdo é extremamente prático e vai direto ao ponto."': '"I implemented just 3 strategies from the e-book and increased my sales by 40% in the first month. The content is extremely practical and gets straight to the point."',
  'Maria Silva': 'Maria Silva',
  '"O melhor material gratuito que já baixei. As planilhas sozinhas já valem muito mais do que muitos cursos pagos que já comprei."': '"The best free material I have ever downloaded. The spreadsheets alone are worth much more than many paid courses I have bought."',
  'Pedro Santos': 'Pedro Santos',
  'CEO, TechStartup': 'CEO, TechStartup',
  '"Finalmente um conteúdo que entrega o que promete. Sem enrolação, só estratégias que funcionam de verdade. Recomendo demais!"': '"Finally content that delivers what it promises. No fluff, just strategies that really work. Highly recommend!"',
  'Ana Costa': 'Ana Costa',
  'Marketing Manager': 'Marketing Manager',

  // =============================================
  // Lead Capture (templateData)
  // =============================================
  '📚 E-book Gratuito': '📚 Free E-book',
  'Guia Completo: Como Dobrar Suas Vendas em 90 Dias': 'Complete Guide: How to Double Your Sales in 90 Days',
  'Descubra as estratégias que os top performers usam para escalar resultados de forma previsível.': 'Discover the strategies that top performers use to scale results predictably.',
  '47 estratégias comprovadas': '47 proven strategies',
  'Planilhas e templates prontos': 'Ready-to-use spreadsheets and templates',
  'Casos de sucesso reais': 'Real success stories',
  'Baixe Grátis Agora': 'Download Free Now',
  'Preencha abaixo para receber o e-book': 'Fill in below to receive the e-book',
  '🔒 Seus dados estão seguros. Não enviamos spam.': '🔒 Your data is secure. We do not send spam.',
  'Mais de': 'More than',
  '15.000 downloads': '15,000 downloads',
  'e avaliação 4.9/5': 'and 4.9/5 rating',
  '"Mudou minha perspectiva"': '"Changed my perspective"',
  '"Conteúdo de altíssima qualidade"': '"Extremely high quality content"',
  '"Implementei e vi resultados"': '"I implemented and saw results"',

  // =============================================
  // Product Launch
  // =============================================
  '⭐ LANÇAMENTO EXCLUSIVO': '⭐ EXCLUSIVE LAUNCH',
  'O Produto Que Vai': 'The Product That Will',
  'Revolucionar': 'Revolutionize',
  'Seu Mercado': 'Your Market',
  'Prepare-se para conhecer a inovação que todos estavam esperando. Seja um dos primeiros a ter acesso.': 'Get ready to discover the innovation everyone has been waiting for. Be one of the first to have access.',
  'QUERO SER AVISADO': 'NOTIFY ME',
  'Ver Teaser': 'Watch Teaser',
  'Lançamento em:': 'Launch in:',

  // =============================================
  // Agency Modern
  // =============================================
  'Studio.': 'Studio.',
  '8 anos': '8 years',
  '"A Studio entendeu perfeitamente nossa visão e entregou um produto que superou todas as expectativas. Nosso app teve um aumento de 200% em downloads."': '"Studio perfectly understood our vision and delivered a product that exceeded all expectations. Our app had a 200% increase in downloads."',
  'Marina Costa': 'Marina Costa',
  '"Profissionais excepcionais! O novo site aumentou nossa taxa de conversão em 150%. Parceria que vale cada centavo investido."': '"Exceptional professionals! The new website increased our conversion rate by 150%. A partnership worth every penny invested."',
  'Rafael Mendes': 'Rafael Mendes',
  '"Da identidade visual ao lançamento do app, a Studio cuidou de tudo. Resultado impecável e dentro do prazo."': '"From visual identity to app launch, Studio took care of everything. Impeccable result and on time."',
  'Julia Santos': 'Julia Santos',
  'Founder, HealthApp': 'Founder, HealthApp',
  'Lucas Oliveira': 'Lucas Oliveira',
  'Ana Beatriz': 'Ana Beatriz',
  'Carla Mendes': 'Carla Mendes',
  'contato@studio.com.br': 'contact@studio.com.br',
  'São Paulo, SP - Brasil': 'São Paulo, SP - Brazil',
  'São Paulo, SP': 'São Paulo, SP',

  // =============================================
  // Agency Services
  // =============================================
  'Trabalhos': 'Work',
  'Disponível para novos projetos': 'Available for new projects',
  'Criamos experiências digitais que': 'We create digital experiences that',
  'impactam': 'make an impact',
  'Somos uma agência de design e tecnologia. Transformamos ideias em produtos digitais que geram resultados reais para nossos clientes.': 'We are a design and technology agency. We transform ideas into digital products that generate real results for our clients.',
  'Soluções completas para sua marca crescer': 'Complete solutions for your brand to grow',
  'Branding & Identidade': 'Branding & Identity',
  'Criamos marcas memoráveis com identidade visual única que conecta com seu público.': 'We create memorable brands with unique visual identity that connects with your audience.',
  'Web Design & Dev': 'Web Design & Dev',
  'Sites e aplicações web de alta performance com foco em conversão e experiência.': 'High-performance websites and web applications focused on conversion and experience.',
  'Estratégias de growth, SEO, mídia paga e conteúdo para escalar seu negócio.': 'Growth strategies, SEO, paid media and content to scale your business.',
  'Portfólio': 'Portfolio',
  'Trabalhos selecionados': 'Selected works',
  'TechVentures': 'TechVentures',
  'FinanceApp': 'FinanceApp',
  'GrowthStartup': 'GrowthStartup',
  'Anos no mercado': 'Years in the market',
  'Clientes ativos': 'Active clients',
  'Tem um projeto em mente?': 'Have a project in mind?',
  'Vamos conversar sobre como podemos ajudar sua empresa a alcançar novos patamares.': 'Let\'s talk about how we can help your company reach new heights.',
  'Agendar uma conversa': 'Schedule a call',
  'Transformando marcas através do design e tecnologia desde 2016.': 'Transforming brands through design and technology since 2016.',
  'Social': 'Social',
  'Behance': 'Behance',

  // =============================================
  // Black Friday - Additional
  // =============================================
  'Friday': 'Friday',

  // =============================================
  // App Download Pro / Mobile App
  // =============================================
  'App Store': 'App Store',
  'Google Play': 'Google Play',
  '2M+': '2M+',
  '"Finalmente consegui organizar minhas finanças! O app é super intuitivo e as metas me ajudam a economizar todos os meses."': '"I finally managed to organize my finances! The app is super intuitive and the goals help me save every month."',
  'Carla M.': 'Carla M.',
  '"Melhor app de finanças que já usei. A conexão com os bancos é perfeita e os relatórios são muito completos."': '"Best finance app I have ever used. The connection with banks is perfect and the reports are very complete."',
  'Pedro S.': 'Pedro S.',
  '"Economizei R$3.000 em 3 meses usando as metas do app. Recomendo para todo mundo que quer ter controle do dinheiro."': '"I saved R$3,000 in 3 months using the app goals. I recommend it to everyone who wants to have control of their money."',
  'Ana L.': 'Ana L.',
  '🚀 Novo: PIX instantâneo 24h': '🚀 New: 24h instant PIX',
  'Suas finanças no': 'Your finances under',
  'controle total': 'total control',
  'Organize gastos, invista com inteligência e acompanhe seu patrimônio em tempo real. O app financeiro mais completo do Brasil.': 'Organize expenses, invest smartly and track your assets in real time. The most complete financial app in Brazil.',
  '+85k avaliações': '+85k reviews',
  '5M+': '5M+',
  'R$2B+': 'R$2B+',
  'Transacionados': 'Transacted',
  'Tudo que você precisa em um só app': 'Everything you need in one app',
  'Controle de Gastos': 'Expense Tracking',
  'Categorize automaticamente e veja para onde vai seu dinheiro.': 'Automatically categorize and see where your money goes.',
  'Invista em renda fixa e variável a partir de apenas R$1.': 'Invest in fixed and variable income starting from just R$1.',
  'Metas Financeiras': 'Financial Goals',
  'Defina objetivos e acompanhe seu progresso em tempo real.': 'Set objectives and track your progress in real time.',
  'PIX Instantâneo': 'Instant PIX',
  'Transfira e receba dinheiro 24h por dia, sem taxas.': 'Transfer and receive money 24 hours a day, without fees.',
  'O que nossos usuários dizem': 'What our users say',
  '"Finalmente consegui organizar minha vida financeira. O app é super intuitivo e as metas me ajudam a economizar!"': '"I finally managed to organize my financial life. The app is super intuitive and the goals help me save!"',
  'Mariana S.': 'Mariana S.',
  'Usuária há 2 anos': 'User for 2 years',
  '"Comecei a investir pelo app e já consegui um retorno incrível. A interface é muito fácil de usar."': '"I started investing through the app and already got an incredible return. The interface is very easy to use."',
  'Rafael M.': 'Rafael M.',
  'Investidor iniciante': 'Beginner investor',
  '"O PIX 24h salvou minha vida várias vezes! Transferências instantâneas e sem taxas."': '"The 24h PIX saved my life many times! Instant transfers and no fees."',
  'Carla P.': 'Carla P.',
  'Empreendedora': 'Entrepreneur',
  'Comece agora sua jornada financeira': 'Start your financial journey now',
  'Baixe grátis e descubra como é fácil ter controle total das suas finanças. Sem taxas escondidas.': 'Download free and discover how easy it is to have total control of your finances. No hidden fees.',
  'Finança': 'Finance',

  // =============================================
  // Course Sales Pro
  // =============================================
  '🎓 +5.000 alunos • Certificado incluso': '🎓 +5,000 students • Certificate included',
  'e Multiplique Seus Resultados': 'and Multiply Your Results',
  'O método passo a passo usado por profissionais de alto nível que já gerou milhões em resultados para empresas de todos os tamanhos.': 'The step-by-step method used by high-level professionals that has generated millions in results for companies of all sizes.',
  '+80 horas de conteúdo prático em vídeo HD': '+80 hours of practical HD video content',
  'Acesso vitalício + Todas as atualizações futuras': 'Lifetime access + All future updates',
  'Comunidade exclusiva no Discord com 5.000+ alunos': 'Exclusive Discord community with 5,000+ students',
  'QUERO ME INSCREVER AGORA →': 'I WANT TO ENROLL NOW →',
  'Você se identifica?': 'Do you relate?',
  'Os 3 maiores erros de quem quer crescer online': 'The 3 biggest mistakes of those who want to grow online',
  'Se você está cometendo algum desses erros, está deixando dinheiro na mesa todos os dias.': 'If you are making any of these mistakes, you are leaving money on the table every day.',
  'Gastar sem retorno': 'Spending without return',
  'Investir em anúncios sem estratégia e ver o dinheiro desaparecer sem gerar vendas ou leads qualificados.': 'Investing in ads without strategy and watching money disappear without generating sales or qualified leads.',
  'Informação demais': 'Too much information',
  'Consumir conteúdo gratuito desorganizado que só gera mais confusão e paralisia por análise.': 'Consuming disorganized free content that only generates more confusion and analysis paralysis.',
  'Resultados lentos': 'Slow results',
  'Trabalhar meses sem ver crescimento porque não sabe exatamente o que fazer e em qual ordem.': 'Working for months without seeing growth because you don\'t know exactly what to do and in what order.',
  'A transformação': 'The transformation',
  'Não é só sobre aprender marketing. É sobre transformar seu negócio e sua vida.': 'It\'s not just about learning marketing. It\'s about transforming your business and your life.',
  'Estratégia Clara': 'Clear Strategy',
  'Plano de ação definido para cada etapa do crescimento': 'Defined action plan for each stage of growth',
  'ROI Positivo': 'Positive ROI',
  'Campanhas que geram mais do que custam desde o início': 'Campaigns that generate more than they cost from the start',
  'Escala Previsível': 'Predictable Scale',
  'Sistema replicável para crescer de forma consistente': 'Replicable system to grow consistently',
  'Posicionamento como referência no seu mercado': 'Positioning as a reference in your market',
  'Seu mentor': 'Your mentor',
  'Ricardo Oliveira': 'Ricardo Oliveira',
  'Especialista em Marketing Digital & Growth': 'Digital Marketing & Growth Specialist',
  'Com mais de 12 anos de experiência em marketing digital, Ricardo já ajudou mais de 500 empresas a escalarem seus negócios online. Foi head de marketing em startups que juntas captaram mais de R$50 milhões em investimentos. Hoje dedica seu tempo a formar a nova geração de profissionais de marketing através deste curso.': 'With over 12 years of experience in digital marketing, Ricardo has helped more than 500 companies scale their online businesses. He was head of marketing at startups that together raised more than R$50 million in investments. Today he dedicates his time to training the new generation of marketing professionals through this course.',
  'Gerados em vendas': 'Generated in sales',
  '12 anos': '12 years',
  'Conteúdo Completo': 'Complete Content',
  'O que você vai aprender': 'What you will learn',
  '8 módulos • 80+ aulas • 40+ horas de conteúdo prático': '8 modules • 80+ lessons • 40+ hours of practical content',
  'Fundamentos do Marketing Digital': 'Digital Marketing Fundamentals',
  'Entenda os pilares, monte sua estratégia do zero e defina seu público ideal.': 'Understand the pillars, build your strategy from scratch and define your ideal audience.',
  '📹 12 aulas • 4h de conteúdo': '📹 12 lessons • 4h of content',
  'Tráfego Pago: Meta Ads': 'Paid Traffic: Meta Ads',
  'Domine Facebook e Instagram Ads: criação, segmentação, otimização e escala.': 'Master Facebook and Instagram Ads: creation, targeting, optimization and scale.',
  '📹 15 aulas • 6h de conteúdo': '📹 15 lessons • 6h of content',
  'Tráfego Pago: Google Ads': 'Paid Traffic: Google Ads',
  'Search, Display, YouTube e Performance Max. Do básico ao avançado.': 'Search, Display, YouTube and Performance Max. From basic to advanced.',
  '📹 14 aulas • 5h de conteúdo': '📹 14 lessons • 5h of content',
  'SEO e Tráfego Orgânico': 'SEO and Organic Traffic',
  'Posicione seu site no topo do Google e atraia visitantes gratuitos 24/7.': 'Position your site at the top of Google and attract free visitors 24/7.',
  '📹 10 aulas • 4h de conteúdo': '📹 10 lessons • 4h of content',
  'Copywriting & Persuasão': 'Copywriting & Persuasion',
  'Escreva textos que vendem, convertam e criem conexão com seu público.': 'Write texts that sell, convert and create connection with your audience.',
  'Landing Pages que Convertem': 'Landing Pages that Convert',
  'Estrutura, design e psicologia por trás de páginas que vendem.': 'Structure, design and psychology behind pages that sell.',
  '📹 8 aulas • 3h de conteúdo': '📹 8 lessons • 3h of content',
  'E-mail Marketing & Automação': 'Email Marketing & Automation',
  'Crie funis automatizados que nutrem leads e geram vendas no piloto automático.': 'Create automated funnels that nurture leads and generate sales on autopilot.',
  'Analytics & Otimização': 'Analytics & Optimization',
  'Meça, analise e otimize suas campanhas com dados reais para maximizar ROI.': 'Measure, analyze and optimize your campaigns with real data to maximize ROI.',
  '📹 8 aulas • 4h de conteúdo': '📹 8 lessons • 4h of content',
  'Histórias reais': 'Real stories',
  '"Em 3 meses aplicando o método, saí de R$15k para R$85k de faturamento mensal. O curso se pagou 100x."': '"In 3 months applying the method, I went from R$15k to R$85k in monthly revenue. The course paid for itself 100x."',
  'Bruno Santos': 'Bruno Santos',
  '"Reduzi meu custo por lead de R$45 para R$8. Hoje gero 10x mais leads com o mesmo orçamento."': '"I reduced my cost per lead from R$45 to R$8. Today I generate 10x more leads with the same budget."',
  '"Larguei meu emprego CLT e hoje faturo 4x mais trabalhando como gestor de tráfego freelancer."': '"I quit my job and today I earn 4x more working as a freelance traffic manager."',
  'Lucas Ferreira': 'Lucas Ferreira',
  'Valor: R$497': 'Value: R$497',
  'Valor: R$297': 'Value: R$297',
  'Valor: R$997': 'Value: R$997',

  // =============================================
  // Course Sales (templateData) - Python Course
  // =============================================
  '🎓 Curso Completo + Certificado': '🎓 Complete Course + Certificate',
  'Python': 'Python',
  'do Zero ao Avançado em 8 Semanas': 'from Zero to Advanced in 8 Weeks',
  'O método definitivo para você se tornar um programador Python completo e conquistar as melhores vagas do mercado de tecnologia.': 'The definitive method for you to become a complete Python programmer and land the best jobs in the technology market.',
  'Aulas em Vídeo': 'Video Lessons',
  'Semanas': 'Weeks',
  'Projetos Práticos': 'Practical Projects',
  'De R$ 997,00': 'From R$ 997.00',
  'R$ 297': 'R$ 297',
  'ou 12x R$29,70': 'or 12x R$29.70',
  'QUERO ME MATRICULAR →': 'I WANT TO ENROLL →',
  'Alunos matriculados': 'Enrolled students',
  '4.9/5.0': '4.9/5.0',
  'Conseguiram emprego': 'Got hired',
  'Um currículo completo que vai te levar do zero ao profissional em Python': 'A complete curriculum that will take you from zero to professional in Python',
  '📹 18 aulas': '📹 18 lessons',
  '⏱️ 4h 30min': '⏱️ 4h 30min',
  '📹 22 aulas': '📹 22 lessons',
  '⏱️ 5h 15min': '⏱️ 5h 15min',
  '📹 20 aulas': '📹 20 lessons',
  '⏱️ 4h 45min': '⏱️ 4h 45min',
  '📹 35 aulas': '📹 35 lessons',
  '⏱️ 8h 30min': '⏱️ 8h 30min',
  'Data Science e Machine Learning': 'Data Science and Machine Learning',
  '📹 40 aulas': '📹 40 lessons',
  '⏱️ 10h 00min': '⏱️ 10h 00min',
  'Projetos Profissionais': 'Professional Projects',
  '📹 25 aulas': '📹 25 lessons',
  '⏱️ 6h 00min': '⏱️ 6h 00min',
  'Carlos Eduardo Silva': 'Carlos Eduardo Silva',
  'Senior Software Engineer & Educador': 'Senior Software Engineer & Educator',
  'Engenheiro de Software com mais de 15 anos de experiência em grandes empresas de tecnologia. Já formei mais de 12.000 alunos em Python e ajudei centenas a conquistarem suas primeiras vagas na área de tecnologia. Minha missão é tornar a programação acessível e prática para todos.': 'Software Engineer with over 15 years of experience in large technology companies. I have trained more than 12,000 students in Python and helped hundreds land their first jobs in technology. My mission is to make programming accessible and practical for everyone.',
  'Alunos formados': 'Graduated students',
  'Cursos publicados': 'Published courses',
  'Histórias reais de transformação de quem já passou pelo curso': 'Real transformation stories from those who have taken the course',
  '"Consegui minha primeira vaga como desenvolvedor Python 2 meses após terminar o curso. O conteúdo é muito prático e o professor explica de forma clara."': '"I got my first job as a Python developer 2 months after finishing the course. The content is very practical and the teacher explains clearly."',
  'Rafael Santos': 'Rafael Santos',
  'Desenvolvedor Python Jr.': 'Python Developer Jr.',
  '"Já fiz vários cursos online, mas esse é de longe o mais completo. Os projetos práticos fizeram toda diferença no meu aprendizado."': '"I have taken several online courses, but this is by far the most complete. The practical projects made all the difference in my learning."',
  'Ana Paula Costa': 'Ana Paula Costa',
  'Data Scientist': 'Data Scientist',
  '"Mudou completamente minha carreira. Saí de analista para desenvolvedor e dobrei meu salário. Recomendo demais!"': '"It completely changed my career. I went from analyst to developer and doubled my salary. Highly recommend!"',
  'Lucas Mendes': 'Lucas Mendes',
  'Full Stack Developer': 'Full Stack Developer',
  'Bônus Exclusivos': 'Exclusive Bonuses',
  'Você também vai receber': 'You will also receive',
  'Materiais extras para acelerar ainda mais seu aprendizado': 'Extra materials to accelerate your learning even more',
  'E-book: Python Pro Tips': 'E-book: Python Pro Tips',
  '100 dicas e truques avançados para escrever código Python mais eficiente e profissional.': '100 advanced tips and tricks to write more efficient and professional Python code.',
  'Valor: R$ 97,00 - GRÁTIS': 'Value: R$ 97.00 - FREE',
  'Acesso ao grupo VIP no Discord com outros alunos e suporte direto com o professor.': 'Access to the VIP Discord group with other students and direct support from the teacher.',
  'Mentoria de Carreira': 'Career Mentoring',
  '2 sessões ao vivo de orientação profissional para preparar seu currículo e LinkedIn.': '2 live professional guidance sessions to prepare your resume and LinkedIn.',
  'Simulado de Entrevistas': 'Interview Simulation',
  '50 questões técnicas mais cobradas em entrevistas para vagas de Python.': '50 most asked technical questions in Python job interviews.',
  'Valor: R$ 47,00 - GRÁTIS': 'Value: R$ 47.00 - FREE',
  'Preciso saber programar para fazer o curso?': 'Do I need to know how to code to take the course?',
  'Não! O curso foi desenvolvido para iniciantes absolutos. Começamos do zero e vamos avançando gradualmente. Basta ter um computador e vontade de aprender.': 'No! The course was developed for absolute beginners. We start from zero and gradually advance. All you need is a computer and willingness to learn.',
  'O acesso é vitalício! Uma vez matriculado, você terá acesso para sempre, incluindo todas as atualizações futuras do conteúdo.': 'Access is lifetime! Once enrolled, you will have access forever, including all future content updates.',
  'O certificado é reconhecido?': 'Is the certificate recognized?',
  'Sim! Ao concluir o curso, você receberá um certificado de conclusão que pode ser compartilhado no LinkedIn e adicionado ao seu currículo.': 'Yes! Upon completing the course, you will receive a completion certificate that can be shared on LinkedIn and added to your resume.',
  'Oferecemos garantia incondicional de 30 dias. Se por qualquer motivo você não estiver satisfeito, devolvemos 100% do seu investimento.': 'We offer an unconditional 30-day guarantee. If for any reason you are not satisfied, we refund 100% of your investment.',
  'Oferta Especial': 'Special Offer',
  'Garanta sua vaga agora': 'Secure your spot now',
  'Condição especial por tempo limitado': 'Special limited-time offer',
  '🔥 70% OFF - Últimas vagas!': '🔥 70% OFF - Last spots!',
  'R$ 997,00': 'R$ 997.00',
  'ou 12x de R$ 29,70 sem juros': 'or 12x of R$ 29.70 interest-free',
  '12 projetos práticos': '12 practical projects',
  'Comunidade exclusiva': 'Exclusive community',
  'Todos os bônus inclusos': 'All bonuses included',
  'QUERO ME MATRICULAR AGORA': 'I WANT TO ENROLL NOW',
  '🔒 Pagamento 100% seguro': '🔒 100% secure payment',
  'Se em 30 dias você não estiver 100% satisfeito com o curso, basta enviar um e-mail e devolvemos todo o seu investimento. Sem perguntas, sem burocracia. O risco é todo nosso!': 'If within 30 days you are not 100% satisfied with the course, just send an email and we will refund your entire investment. No questions, no hassle. The risk is all ours!',

  // =============================================
  // Coming Soon
  // =============================================
  'Em Breve': 'Coming Soon',
  'Algo incrível está chegando': 'Something amazing is coming',
  'Estamos trabalhando em algo especial. Cadastre-se para ser o primeiro a saber quando lançarmos.': 'We are working on something special. Sign up to be the first to know when we launch.',
  'Cadastre-se na lista': 'Join the waitlist',
  'Seja o primeiro a saber': 'Be the first to know',

  // =============================================
  // Consulting (additional - main keys defined earlier)
  // =============================================
  'Transforme seu negócio': 'Transform your business',
  'Consultoria especializada para empresas que querem crescer de forma sustentável.': 'Specialized consulting for companies that want to grow sustainably.',
  'Diagnóstico Gratuito': 'Free Diagnosis',
  'Consultoria Estratégica': 'Strategic Consulting',
  'Análise completa do seu negócio com plano de ação personalizado.': 'Complete analysis of your business with personalized action plan.',
  'Mentoria Executiva': 'Executive Mentoring',
  'Acompanhamento individual para líderes e gestores.': 'Individual coaching for leaders and managers.',
  'Treinamento de Equipe': 'Team Training',
  'Capacitação customizada para sua equipe alcançar resultados.': 'Customized training for your team to achieve results.',

  // =============================================
  // SaaS Minimal
  // =============================================
  'Simplifique seu trabalho': 'Simplify your work',
  'A ferramenta que sua equipe precisa para ser mais produtiva.': 'The tool your team needs to be more productive.',
  'Comece grátis': 'Start free',
  'Por que escolher': 'Why choose',
  'Simples e Intuitivo': 'Simple and Intuitive',
  'Interface limpa que qualquer um consegue usar.': 'Clean interface that anyone can use.',
  'Rápido e Confiável': 'Fast and Reliable',
  '99.9% de uptime garantido.': '99.9% guaranteed uptime.',
  'Suporte 24/7': '24/7 Support',
  'Equipe dedicada sempre disponível.': 'Dedicated team always available.',

  // =============================================
  // COMPLETE TRANSLATIONS - ALL TEMPLATES
  // =============================================

  // Testimonials & Reviews
  '"5 minutos de leitura que valem mais que muitos cursos. Cancelei outras 3 newsletters depois de assinar esta."': '"5 minutes of reading worth more than many courses. I cancelled 3 other newsletters after subscribing to this one."',
  '"A IronFit mudou minha vida. Com a ajuda dos profissionais consegui alcançar resultados que nunca imaginei."': '"IronFit changed my life. With the help of the professionals I achieved results I never imagined."',
  '"A PetCare Plus salvou a vida da minha gatinha! Super recomendo!"': '"PetCare Plus saved my kitten\'s life! Highly recommend!"',
  '"A melhor decisão que tomamos foi migrar para o Acme. ROI positivo em menos de 3 meses."': '"The best decision we made was migrating to Acme. Positive ROI in less than 3 months."',
  '"A única newsletter que eu realmente leio toda semana. Conteúdo relevante e insights que já apliquei várias vezes no meu negócio."': '"The only newsletter I actually read every week. Relevant content and insights I\'ve applied several times in my business."',
  '"Aluguei um escritorio comercial com toda a documentacao em dia. Processo rapido e sem complicacoes. Excelente servico!"': '"I rented a commercial office with all documentation up to date. Fast process without complications. Excellent service!"',
  '"Ambiente impecavel e equipe super preparada. Meus filhos adoram ir ao pediatra aqui porque sao sempre muito carinhosos com eles."': '"Impeccable environment and super prepared team. My children love going to the pediatrician here because they are always very caring with them."',
  '"As aulas de spinning sao incriveis! A Marina e uma professora excepcional que nos motiva a cada pedalada. Viciei!"': '"The spinning classes are amazing! Marina is an exceptional instructor who motivates us with every pedal. I\'m hooked!"',
  '"As perguntas que o Carlos faz sao cirurgicas. Ele consegue extrair dos convidados informacoes que voce nao acha em nenhum outro lugar."': '"The questions Carlos asks are surgical. He manages to extract information from guests that you can\'t find anywhere else."',
  '"Atendimento humanizado e profissionais competentes."': '"Humanized care and competent professionals."',
  '"Comemoramos nosso aniversário de casamento aqui e foi mágico. Cada detalhe pensado com carinho. Nota 10!"': '"We celebrated our wedding anniversary here and it was magical. Every detail thoughtfully crafted. Perfect 10!"',
  '"Depois de anos sofrendo com dores nas costas, finalmente encontrei uma solucao. A equipe de ortopedia mudou minha qualidade de vida."': '"After years suffering from back pain, I finally found a solution. The orthopedics team changed my quality of life."',
  '"Em 6 meses de mentoria, consegui a promoção para gerente que buscava há 3 anos. A clareza que ganhei sobre meus pontos fortes mudou completamente minha abordagem."': '"In 6 months of mentoring, I got the promotion to manager I had been seeking for 3 years. The clarity I gained about my strengths completely changed my approach."',
  '"Encontrei na academia nao so um lugar para treinar, mas uma familia que me apoia todos os dias."': '"I found at the gym not just a place to train, but a family that supports me every day."',
  '"Encontrei o apartamento perfeito com a ajuda da PrimeImoveis. O atendimento foi excepcional do inicio ao fim. Super recomendo!"': '"I found the perfect apartment with the help of PrimeImoveis. The service was exceptional from start to finish. Highly recommend!"',
  '"Estava completamente perdida sobre qual rumo tomar na carreira. A mentoria me ajudou a encontrar meu propósito e hoje lidero uma equipe de 20 pessoas."': '"I was completely lost about which direction to take in my career. The mentoring helped me find my purpose and today I lead a team of 20 people."',
  '"Finalmente uma plataforma que entrega o que promete. Suporte excepcional!"': '"Finally a platform that delivers what it promises. Exceptional support!"',
  '"Fui muito bem atendida desde a recepcao ate a consulta. O Dr. Carlos e extremamente atencioso e me explicou tudo com calma. Recomendo demais!"': '"I was very well attended from reception to consultation. Dr. Carlos is extremely attentive and explained everything calmly. Highly recommend!"',
  '"João entendeu perfeitamente nossa visão e entregou um produto que superou todas as expectativas. Nosso app teve um aumento de 200% em retenção."': '"João perfectly understood our vision and delivered a product that exceeded all expectations. Our app had a 200% increase in retention."',
  '"Me sinto mais preparado para as reuniões de diretoria. Os insights desta newsletter me deram argumentos que impressionaram o board."': '"I feel more prepared for board meetings. The insights from this newsletter gave me arguments that impressed the board."',
  '"Melhor academia que ja treinei. Equipamentos novos, professores atenciosos e ambiente super motivador. Recomendo demais!"': '"Best gym I\'ve ever trained at. New equipment, attentive instructors and super motivating environment. Highly recommend!"',
  '"Melhor restaurante da cidade! A experiência gastronômica é incrível e o atendimento impecável. Voltaremos com certeza."': '"Best restaurant in the city! The gastronomic experience is incredible and the service impeccable. We will definitely return."',
  '"Meu Thor adora ir na PetCare! Banho e tosa perfeitos."': '"My Thor loves going to PetCare! Perfect bath and grooming."',
  '"O acompanhamento personalizado fez toda diferenca. Resultados que parecem impossiveis se tornam reais."': '"The personalized follow-up made all the difference. Results that seem impossible become real."',
  '"O melhor investimento que fiz para minha empresa. ROI em menos de 30 dias."': '"The best investment I made for my company. ROI in less than 30 days."',
  '"O melhor podcast de negocios do Brasil. Os insights sao incriveis e as entrevistas sao super profundas. Escuto todos os episodios."': '"The best business podcast in Brazil. The insights are incredible and the interviews are super deep. I listen to every episode."',
  '"O plano Black vale cada centavo. Ter um personal e nutricionista fez toda diferenca nos meus resultados. Perdi 20kg!"': '"The Black plan is worth every penny. Having a personal trainer and nutritionist made all the difference in my results. I lost 20kg!"',
  '"O programa intensivo foi divisor de águas. Negociei um aumento de 45% e mudei para uma empresa que sempre sonhei. Investimento que se pagou em menos de 2 meses."': '"The intensive program was a game changer. I negotiated a 45% raise and moved to a company I always dreamed of. Investment that paid for itself in less than 2 months."',
  '"O salmão grelhado é simplesmente perfeito. Ambiente aconchegante e carta de vinhos excepcional. Recomendo muito!"': '"The grilled salmon is simply perfect. Cozy atmosphere and exceptional wine list. Highly recommend!"',
  '"O suporte é incrível. Qualquer dúvida é resolvida em minutos. Recomendo muito!"': '"The support is incredible. Any question is resolved in minutes. Highly recommend!"',
  '"Obrigada por criar esse conteudo incrivel! Aprendo mais ouvindo um episodio do que lendo varios livros de negocios."': '"Thank you for creating this incredible content! I learn more listening to one episode than reading several business books."',
  '"Reduzimos o tempo gasto em tarefas manuais em 70%. A equipe finalmente pode focar no que realmente importa."': '"We reduced time spent on manual tasks by 70%. The team can finally focus on what really matters."',
  '"Trabalhar com o João foi uma experiência incrível. Ele não apenas entrega design, mas estratégia. Nossa marca nunca esteve tão forte."': '"Working with João was an incredible experience. He doesn\'t just deliver design, but strategy. Our brand has never been stronger."',
  '"Triplicamos nossa produtividade em 3 meses. A automação é simplesmente incrível!"': '"We tripled our productivity in 3 months. The automation is simply amazing!"',
  '"Vendi minha casa em tempo recorde e por um otimo preco. A equipe foi muito profissional e transparente em todo o processo."': '"I sold my house in record time and for a great price. The team was very professional and transparent throughout the process."',

  // Names & Titles
  'Ana Carolina': 'Ana Carolina',
  'Ana Oliveira': 'Ana Oliveira',
  'Ana Paula': 'Ana Paula',
  'Ana Santos': 'Ana Santos',
  'Ana Silva': 'Ana Silva',
  'Beatriz Ramos': 'Beatriz Ramos',
  'Camila Oliveira': 'Camila Oliveira',
  'Carlos Ferreira': 'Carlos Ferreira',
  'Carlos Mendes': 'Carlos Mendes',
  'Carlos Silva': 'Carlos Silva',
  'Carolina Mendes': 'Carolina Mendes',
  'Carolina Silva': 'Carolina Silva',
  'Fernanda Lima': 'Fernanda Lima',
  'Fernando Alves': 'Fernando Alves',
  'João.design': 'João.design',
  'Juliana Costa': 'Juliana Costa',
  'Juliana Santos': 'Juliana Santos',
  'Lucia Andrade': 'Lucia Andrade',
  'Marcos Silva': 'Marcos Silva',
  'Maria Costa': 'Maria Costa',
  'Maria Fernanda': 'Maria Fernanda',
  'Maria Santos': 'Maria Santos',
  'Marina Lima': 'Marina Lima',
  'Paulo Ricardo': 'Paulo Ricardo',
  'Pedro Augusto': 'Pedro Augusto',
  'Pedro Lima': 'Pedro Lima',
  'Roberto Lima': 'Roberto Lima',
  'Roberto Silva': 'Roberto Silva',
  'Ricardo Santos': 'Ricardo Santos',
  'Dr. Carlos Mendes': 'Dr. Carlos Mendes',
  'Dr. Roberto Silva': 'Dr. Roberto Silva',
  'Dra. Ana Costa': 'Dr. Ana Costa',
  'Dra. Marina Lima': 'Dr. Marina Lima',
  'CEO, TechCorp': 'CEO, TechCorp',
  'CEO, TechStart': 'CEO, TechStart',
  'CMO, BigCompany': 'CMO, BigCompany',
  'CMO, Unicornio': 'CMO, Unicorn',
  'COO, GrowthCo': 'COO, GrowthCo',
  'Tech Lead, Google': 'Tech Lead, Google',
  'Gerente de Marketing, Nubank': 'Marketing Manager, Nubank',
  'Head de Produto, iFood': 'Product Head, iFood',
  'VP Growth, ScaleUp': 'VP Growth, ScaleUp',
  'Partner, VC Fund': 'Partner, VC Fund',
  'Angel Investor': 'Angel Investor',
  'Serial Entrepreneur': 'Serial Entrepreneur',
  'Founder, E-commerce XYZ': 'Founder, E-commerce XYZ',
  'Founder, SaaS Co': 'Founder, SaaS Co',
  'Fundador, E-commerce Plus': 'Founder, E-commerce Plus',
  'Fundadora, FintechX': 'Founder, FintechX',
  'Fundadora, StartupXYZ': 'Founder, StartupXYZ',
  'Empreendedor Serial • +R$10M faturados': 'Serial Entrepreneur • +R$10M revenue',
  'Empreendedor e Autor Bestseller': 'Entrepreneur and Bestselling Author',

  // Companies & Brands
  'Acme': 'Acme',
  'Airbnb': 'Airbnb',
  'GrowthCo': 'GrowthCo',
  'InnovateLab': 'InnovateLab',
  'La Maison': 'La Maison',
  'Magazine': 'Magazine',
  'Microsoft': 'Microsoft',
  'PetCare Plus': 'PetCare Plus',
  'StartupHub': 'StartupHub',
  'Studio': 'Studio',
  'TechCorp': 'TechCorp',
  'Uber': 'Uber',
  'VentureX': 'VentureX',
  'Iron': 'Iron',
  'Fit': 'Fit',
  'Cast': 'Cast',

  // Sections & Headings
  'A Arte de Empreender no Caos': 'The Art of Entrepreneurship in Chaos',
  'A maior academia da regiao com mais de 2.000m² de estrutura, equipamentos de ultima\n        geracao, mais de 50 modalidades e professores altamente qualificados. Venha fazer parte\n        dessa revolucao.': 'The largest gym in the region with over 2,000m² of structure, state-of-the-art equipment, more than 50 modalities and highly qualified instructors. Come be part of this revolution.',
  'A maior promoção do ano. Ofertas imperdíveis por tempo limitado!': 'The biggest sale of the year. Unmissable offers for a limited time!',
  'A plataforma mais simples para gerenciar e escalar seu negócio.': 'The simplest platform to manage and scale your business.',
  'Ajudamos empresas a desbloquearem seu potencial máximo com estratégias personalizadas e execução impecável.': 'We help companies unlock their maximum potential with personalized strategies and impeccable execution.',
  'Analytics em Tempo Real': 'Real-Time Analytics',
  'Acompanhe todas as métricas do seu negócio em dashboards atualizados em tempo real.': 'Track all your business metrics in real-time updated dashboards.',
  'Automatize tarefas repetitivas e foque no que realmente importa para crescer.': 'Automate repetitive tasks and focus on what really matters to grow.',
  'Automações Inteligentes': 'Smart Automations',
  'Como Criar um Negócio de': 'How to Create a Business of',
  'Como escalar sem queimar dinheiro': 'How to scale without burning money',
  'Como transformar crises em oportunidades de crescimento': 'How to turn crises into growth opportunities',
  'Como validar uma ideia em 7 dias': 'How to validate an idea in 7 days',
  'Conecte com todas as ferramentas que você já usa no dia a dia.': 'Connect with all the tools you already use daily.',
  'Conecte suas ferramentas favoritas': 'Connect your favorite tools',
  'Consultoria estratégica para': 'Strategic consulting for',
  'Conversas honestas e sem filtro com empreendedores de sucesso sobre os bastidores\n            de construir empresas de alto crescimento. Insights reais, historias inspiradoras e\n            licoes que voce nao encontra em nenhum livro.': 'Honest and unfiltered conversations with successful entrepreneurs about the behind-the-scenes of building high-growth companies. Real insights, inspiring stories and lessons you won\'t find in any book.',
  'De IC para Liderança': 'From IC to Leadership',
  'De experiencia': 'Of experience',
  'Descubra o método passo a passo que usei para sair do zero e faturar mais de R$100.000 mensais. Vou revelar tudo nesta masterclass exclusiva.': 'Discover the step-by-step method I used to go from zero to earning over R$100,000 monthly. I will reveal everything in this exclusive masterclass.',
  'Desenvolvemos roadmaps estratégicos para escalar sua empresa de forma sustentável.': 'We develop strategic roadmaps to scale your company sustainably.',
  'Em resultados gerados': 'In generated results',
  'Empreendedor serial, investidor anjo e apaixonado por startups. Fundou 3 empresas\n            que juntas ja faturaram mais de R$100 milhoes. Agora, sua missao e compartilhar\n            tudo que aprendeu nos bastidores do empreendedorismo.': 'Serial entrepreneur, angel investor and passionate about startups. Founded 3 companies that together have already earned more than R$100 million. Now, his mission is to share everything he learned behind the scenes of entrepreneurship.',
  'Entre em contato conosco e um de nossos corretores especializados ira ajuda-lo\n          a encontrar a melhor opcao para voce e sua familia.': 'Contact us and one of our specialized brokers will help you find the best option for you and your family.',
  'Entre em contato conosco ou preencha o formulario para agendar sua visita\n          e conhecer nossa estrutura. A primeira aula e por nossa conta!': 'Contact us or fill out the form to schedule your visit and see our facilities. The first class is on us!',
  'Equipe medica altamente especializada, tecnologia de ponta e atendimento humanizado.\n          Sua saude merece o melhor cuidado - e nos estamos aqui para oferecer isso.': 'Highly specialized medical team, cutting-edge technology and humanized care. Your health deserves the best care - and we are here to offer that.',
  'Estratégia de Crescimento': 'Growth Strategy',
  'Estratégias de vendas que funcionam em qualquer nicho': 'Sales strategies that work in any niche',
  'Estruturamos times de alta performance e cultura organizacional forte.': 'We structure high-performance teams and strong organizational culture.',
  'Estamos trabalhando em algo especial. Seja o primeiro a saber quando lançarmos!': 'We are working on something special. Be the first to know when we launch!',
  'Ferramentas poderosas com interface simples para você focar no que importa': 'Powerful tools with simple interface so you can focus on what matters',
  'Fundada em 2008, a VidaClinic nasceu com o proposito de oferecer atendimento medico\n          de alta qualidade com um diferencial: o cuidado humanizado. Acreditamos que a medicina\n          vai alem dos diagnosticos - ela envolve acolhimento, respeito e empatia.': 'Founded in 2008, VidaClinic was born with the purpose of offering high-quality medical care with a difference: humanized care. We believe that medicine goes beyond diagnoses - it involves welcoming, respect and empathy.',
  'Gestão de Pessoas': 'People Management',
  'Ha mais de 15 anos cuidando da saude de milhares de familias com\n          excelencia, tecnologia e muito carinho.': 'For over 15 years caring for the health of thousands of families with excellence, technology and much care.',
  'Ha mais de 15 anos no mercado imobiliario, a PrimeImoveis se consolidou como\n          referencia em compra, venda e locacao de imoveis. Nossa equipe de corretores\n          especializados esta pronta para ajuda-lo a encontrar o imovel dos seus sonhos.': 'For over 15 years in the real estate market, PrimeImoveis has established itself as a reference in buying, selling and renting properties. Our team of specialized brokers is ready to help you find your dream property.',
  'Ha mais de 15 anos realizando o sonho de milhares de familias.\n          Compra, venda e locacao de imoveis com seguranca e transparencia.': 'For over 15 years making the dreams of thousands of families come true. Buying, selling and renting properties with security and transparency.',
  'Ha mais de 15 anos transformando vidas atraves do fitness.\n          Junte-se a nos e descubra seu potencial.': 'For over 15 years transforming lives through fitness. Join us and discover your potential.',
  'Identificamos gargalos e implementamos melhorias para aumentar eficiência.': 'We identify bottlenecks and implement improvements to increase efficiency.',
  'Junte-se a mais de 10.000 empresas que já estão crescendo com o Acme': 'Join over 10,000 companies already growing with Acme',
  'Mais de 5.000 imoveis disponiveis nas melhores localizacoes. Casas, apartamentos,\n        terrenos e empreendimentos com as melhores condicoes do mercado.': 'More than 5,000 properties available in the best locations. Houses, apartments, land and developments with the best market conditions.',
  'No StartupCast, ele entrevista fundadores, investidores e executivos para extrair\n            os insights mais valiosos sobre como construir negocios de sucesso no Brasil.': 'On StartupCast, he interviews founders, investors and executives to extract the most valuable insights on how to build successful businesses in Brazil.',
  'Nossa equipe esta pronta para atende-lo. Entre em contato pelos canais abaixo\n          ou preencha o formulario para agendar sua consulta.': 'Our team is ready to serve you. Contact us through the channels below or fill out the form to schedule your appointment.',
  'Nossa estrutura moderna conta com equipamentos de ultima geracao e uma equipe\n          multidisciplinar preparada para cuidar de voce e sua familia em todas as fases da vida.': 'Our modern facility has state-of-the-art equipment and a multidisciplinary team prepared to take care of you and your family at all stages of life.',
  'Nossas Especialidades': 'Our Specialties',
  'O podcast sobre startups e negocios que voce precisa ouvir.\n            Novos episodios toda segunda-feira.': 'The podcast about startups and business you need to listen to. New episodes every Monday.',
  'O que você vai aprender:': 'What you will learn:',
  'Os 3 pilares de um negócio lucrativo': 'The 3 pillars of a profitable business',
  'Otimização de Processos': 'Process Optimization',
  'PetCare Plus - O melhor cuidado para seu pet': 'PetCare Plus - The best care for your pet',
  'Planos para cada momento do seu negócio': 'Plans for every moment of your business',
  'Pronto para dar o próximo passo?': 'Ready to take the next step?',
  'Promoção para Gerente': 'Promotion to Manager',
  'Reserve sua vaga agora': 'Reserve your spot now',
  'Seus dados protegidos com criptografia de ponta e compliance LGPD.': 'Your data protected with end-to-end encryption and LGPD compliance.',
  'Soluções completas para transformar seu negócio': 'Complete solutions to transform your business',
  'Toda semana, um resumo dos melhores momentos do podcast + conteudo exclusivo\n          direto na sua caixa de entrada. Junte-se a +50.000 assinantes.': 'Every week, a summary of the best podcast moments + exclusive content straight to your inbox. Join +50,000 subscribers.',
  'Trabalhamos com transparencia, etica e comprometimento, oferecendo as melhores\n          oportunidades do mercado e um atendimento personalizado para cada cliente.': 'We work with transparency, ethics and commitment, offering the best market opportunities and personalized service for each client.',
  'Tudo que você precisa, nada que não precisa': 'Everything you need, nothing you don\'t',
  'Veja seus resultados crescerem': 'Watch your results grow',
  'Agende uma conversa gratuita de 30 minutos com um de nossos consultores.': 'Schedule a free 30-minute conversation with one of our consultants.',
  'negócios ambiciosos': 'ambitious businesses',
  'do Zero em 2025': 'from Zero in 2025',

  // Plan Names & Features
  'Pro': 'Pro',
  'Enterprise': 'Enterprise',
  'Custom': 'Custom',
  'Grátis': 'Free',
  'Para grandes operações': 'For large operations',
  'Para sempre': 'Forever',
  'Personalizado': 'Personalized',
  'Personalize para seu negócio em minutos': 'Customize for your business in minutes',
  'Cobrado mensalmente': 'Billed monthly',
  'Comece em menos de 5 minutos': 'Get started in less than 5 minutes',
  'Comece grátis e escale conforme você cresce': 'Start free and scale as you grow',
  '✓ API dedicada': '✓ Dedicated API',
  '✓ API personalizada': '✓ Custom API',
  '✓ Automações avançadas': '✓ Advanced automations',
  '✓ Contatos ilimitados': '✓ Unlimited contacts',
  '✓ Dashboard básico': '✓ Basic dashboard',
  '✓ Gerente de conta': '✓ Account manager',
  '✓ Integrações premium': '✓ Premium integrations',
  '✓ Manager dedicado': '✓ Dedicated manager',
  '✓ SLA garantido': '✓ Guaranteed SLA',
  '✓ Suporte por email': '✓ Email support',
  '✓ Suporte prioritário': '✓ Priority support',
  '✓ Suporte prioritário 24/7': '✓ 24/7 priority support',
  '✓ Tudo do Pro': '✓ Everything from Pro',
  '✓ Usuários ilimitados': '✓ Unlimited users',
  'Sob consulta': 'Upon request',
  'Acesso vitalício ao curso': 'Lifetime course access',

  // FAQ & Support
  'Absolutamente. Sem multas, sem burocracia. Você pode cancelar direto pelo painel.': 'Absolutely. No fines, no bureaucracy. You can cancel directly from the dashboard.',
  'Sim! Nossa equipe de suporte é 100% brasileira e está disponível 24/7 para te ajudar.': 'Yes! Our support team is 100% Brazilian and is available 24/7 to help you.',
  'Sim! Oferecemos 7 dias de teste grátis em todos os planos pagos. Não pedimos cartão de crédito para começar.': 'Yes! We offer 7 days free trial on all paid plans. We don\'t ask for a credit card to start.',
  'Sim! Temos importadores prontos para as principais ferramentas do mercado. Nossa equipe também pode ajudar na migração.': 'Yes! We have importers ready for the main tools on the market. Our team can also help with migration.',
  'Usamos criptografia de ponta a ponta e somos compliance com LGPD. Seus dados nunca são compartilhados.': 'We use end-to-end encryption and are LGPD compliant. Your data is never shared.',
  'Equipe dedicada para te ajudar quando você precisar.': 'Dedicated team to help you when you need it.',
  'Acesse de qualquer lugar com nossos apps para iOS e Android.': 'Access from anywhere with our iOS and Android apps.',

  // Actions & Buttons
  'COMPRAR': 'BUY',
  'Configure': 'Configure',
  'Crie sua conta': 'Create your account',
  'Escale': 'Scale',
  'Integre': 'Integrate',
  'Saiba mais': 'Learn more',
  'Ver Cases': 'View Cases',
  'VER OFERTAS →': 'VIEW OFFERS →',

  // Categories & Types
  'Brand Identity System': 'Brand Identity System',
  'Branding • Visual Identity': 'Branding • Visual Identity',
  'Digital Banking': 'Digital Banking',
  'E-commerce': 'E-commerce',
  'E-commerce Premium': 'E-commerce Premium',
  'Farm to Table': 'Farm to Table',
  'Fintech': 'Fintech',
  'Fintech App Redesign': 'Fintech App Redesign',
  'Lancamento': 'Launch',
  'Muay Thai': 'Muay Thai',
  'Negocios': 'Business',
  'Newsletter': 'Newsletter',
  'Product Design • Web': 'Product Design • Web',
  'SaaS': 'SaaS',
  'UI/UX Design • Fintech': 'UI/UX Design • Fintech',
  'UI/UX Design • Mobile': 'UI/UX Design • Mobile',
  'Vinhos': 'Wines',

  // Contact & Location
  '(11) 3456-7890': '(11) 3456-7890',
  '(11) 99999-9999': '(11) 99999-9999',
  '+55 11 99999-9999': '+55 11 99999-9999',
  'Av. Brasil, 1500 - Centro': 'Av. Brasil, 1500 - Downtown',
  'Av. Paulista, 1000 - Bela Vista': 'Av. Paulista, 1000 - Bela Vista',
  'Endereco': 'Address',
  'Horario': 'Hours',
  'Rua das Flores, 123 - Jardins': 'Rua das Flores, 123 - Jardins',
  'Sao Paulo - SP, 01310-100': 'São Paulo - SP, 01310-100',
  'Sao Paulo - SP, 01430-000': 'São Paulo - SP, 01430-000',
  'Seg a Sex: 9h - 18h': 'Mon to Fri: 9am - 6pm',
  'Sabado: 9h - 13h': 'Saturday: 9am - 1pm',
  'contato@petcareplus.com.br': 'contact@petcareplus.com.br',
  'contato@seucoach.com': 'contact@yourcoach.com',
  'ola@joaodesign.com': 'hello@joaodesign.com',

  // Social & Links
  'API': 'API',
  'Figma': 'Figma',
  'Links': 'Links',
  'Notion': 'Notion',
  'Slack': 'Slack',
  'Spotify': 'Spotify',
  'Status': 'Status',
  'Twitter': 'Twitter',
  'YouTube': 'YouTube',
  'ig': 'ig',
  'in': 'in',
  'tw': 'tw',
  'yt': 'yt',
  '@camilaoliveira': '@camilaoliveira',
  '@fernandal': '@fernandal',
  '@rafaelmendes': '@rafaelmendes',

  // Stats & Numbers
  '#1 Best Seller': '#1 Best Seller',
  '100% Online': '100% Online',
  '12 episodios': '12 episodes',
  '15 anos': '15 years',
  '15 episodios': '15 episodes',
  '18 episodios': '18 episodes',
  '22 episodios': '22 episodes',
  '24h': '24h',
  '25K+': '25K+',
  '28 episodios': '28 episodes',
  '32 episodios': '32 episodes',
  '35 episodios': '35 episodes',
  '4.9/5': '4.9/5',
  '45 episodios': '45 episodes',
  '500K+': '500K+',
  '6 Dígitos': '6 Figures',
  '70% OFF': '70% OFF',
  'Anos de experiência': 'Years of experience',
  '-31%': '-31%',
  '-40%': '-40%',
  '-50%': '-50%',
  '-60%': '-60%',
  '-70%': '-70%',
  '/único': '/one-time',
  'Resultado': 'Result',

  // Prices
  'R$': 'R$',
  'R$ 1.200.000': 'R$ 1,200,000',
  'R$ 1.299': 'R$ 1,299',
  'R$ 135': 'R$ 135',
  'R$ 2.499,90': 'R$ 2,499.90',
  'R$ 299': 'R$ 299',
  'R$ 299,90': 'R$ 299.90',
  'R$ 3.500': 'R$ 3,500',
  'R$ 399': 'R$ 399',
  'R$ 4.997': 'R$ 4,997',
  'R$ 450': 'R$ 450',
  'R$ 450.000': 'R$ 450,000',
  'R$ 497': 'R$ 497',
  'R$ 539,90': 'R$ 539.90',
  'R$ 599': 'R$ 599',
  'R$ 599,90': 'R$ 599.90',
  'R$ 650.000': 'R$ 650,000',
  'R$ 750.000': 'R$ 750,000',
  'R$ 79,90': 'R$ 79.90',
  'R$ 89,90': 'R$ 89.90',
  'R$ 890.000': 'R$ 890,000',
  'R$ 899': 'R$ 899',
  'R$ 899,90': 'R$ 899.90',
  'R$ 99,90': 'R$ 99.90',
  'R$ 997': 'R$ 997',
  'R$ 999': 'R$ 999',
  'R$ 999,90': 'R$ 999.90',
  'R$0': 'R$0',
  'R$149': 'R$149',
  'R$249': 'R$249',
  'R$50M': 'R$50M',
  'R$97': 'R$97',
  'R$99': 'R$99',
  'R\\$ 159': 'R$ 159',
  'R\\$ 259': 'R$ 259',
  'R\\$ 89': 'R$ 89',

  // Products
  'Câmera Profissional': 'Professional Camera',
  'Headphone Premium': 'Premium Headphone',
  'Smart Watch Pro Series 5': 'Smart Watch Pro Series 5',

  // Time & Events
  'Jan': 'Jan',
  'Terça, 15 de Janeiro • 20h (Brasília)': 'Tuesday, January 15 • 8pm (Brasília)',
  '📅 1 mes atras': '📅 1 month ago',
  '📅 1 semana atras': '📅 1 week ago',
  '📅 15-16 Março 2025 • São Paulo': '📅 March 15-16, 2025 • São Paulo',
  '📅 2 dias atras': '📅 2 days ago',
  '📅 2 semanas atras': '📅 2 weeks ago',
  '📅 3 semanas atras': '📅 3 weeks ago',

  // LGPD & Legal
  'LGPD': 'LGPD',
  'EM DESENVOLVIMENTO': 'IN DEVELOPMENT',
  'ATÉ': 'UP TO',

  // Misc Labels
  'Sobre Nós': 'About Us',
  'Autoridade': 'Authority',
  'CRECI 12345-SP': 'CRECI 12345-SP',
  'CRECI 23456-SP': 'CRECI 23456-SP',
  'CRECI 34567-SP': 'CRECI 34567-SP',
  'CRECI 45678-SP': 'CRECI 45678-SP',
  'CRM 12345-SP': 'CRM 12345-SP',
  'CRM 23456-SP': 'CRM 23456-SP',
  'CRM 34567-SP': 'CRM 34567-SP',
  'CRM 45678-SP': 'CRM 45678-SP',
  'Cadastro rápido e sem cartão de crédito': 'Quick signup without credit card',

  // Footers
  '© 2024 PrimeImoveis. Todos os direitos reservados. CRECI-J 12345': '© 2024 PrimeImoveis. All rights reserved. CRECI-J 12345',
  '© 2024 StartupCast. Todos os direitos reservados.': '© 2024 StartupCast. All rights reserved.',
  '© 2025 Acme. Todos os direitos reservados.': '© 2025 Acme. All rights reserved.',
  '© 2025 Seu Nome Coach. Todos os direitos reservados.': '© 2025 Your Name Coach. All rights reserved.',

  // Badges & Labels
  '✨ Versão 3.0 lançada': '✨ Version 3.0 launched',
  '⚠️ Apenas 147 vagas disponíveis': '⚠️ Only 147 spots available',
  '⚡ Ofertas Relâmpago': '⚡ Flash Deals',
  '🎁 GRATUITO': '🎁 FREE',
  '🎓 MBA FGV': '🎓 MBA FGV',
  '🎙️ Startup': '🎙️ Startup',
  '📊 15+ anos experiência': '📊 15+ years experience',
  '📍 Alphaville, Sao Paulo': '📍 Alphaville, São Paulo',
  '📍 Area externa': '📍 Outdoor area',
  '📍 Barra da Tijuca, RJ': '📍 Barra da Tijuca, RJ',
  '📍 Box': '📍 Box',
  '📍 Centro, Curitiba': '📍 Downtown, Curitiba',
  '📍 Granja Viana, SP': '📍 Granja Viana, SP',
  '📍 Itaim Bibi, Sao Paulo': '📍 Itaim Bibi, São Paulo',
  '📍 Morumbi, Sao Paulo': '📍 Morumbi, São Paulo',
  '📍 Sala 1': '📍 Room 1',
  '📍 Sala 2': '📍 Room 2',
  '📍 Sala 3': '📍 Room 3',
  '📍 Sala de lutas': '📍 Fighting room',
  '📐 120m²': '📐 120m²',
  '📐 180m²': '📐 180m²',
  '📐 200m²': '📐 200m²',
  '📐 250m²': '📐 250m²',
  '📐 320m²': '📐 320m²',
  '📐 75m²': '📐 75m²',
  '📚 Novo Lançamento': '📚 New Release',
  '📜 ICF Certified Coach': '📜 ICF Certified Coach',
  '📦 Amazon': '📦 Amazon',
  '📦 Livraria Cultura': '📦 Livraria Cultura',
  '📦 Saraiva': '📦 Saraiva',
  '🔥 500 kcal': '🔥 500 kcal',
  '🔥 550 kcal': '🔥 550 kcal',
  '🔥 600 kcal': '🔥 600 kcal',
  '🔥 700 kcal': '🔥 700 kcal',
  '🔥 800 kcal': '🔥 800 kcal',
  '🕐 45 min': '🕐 45 min',
  '🕐 48 min': '🕐 48 min',
  '🕐 50 min': '🕐 50 min',
  '🕐 52 min': '🕐 52 min',
  '🕐 58 min': '🕐 58 min',
  '🕐 60 min': '🕐 60 min',
  '🕐 63 min': '🕐 63 min',
  '🕐 72 min': '🕐 72 min',
  '🚗 1 vaga': '🚗 1 parking spot',
  '🚗 2 vagas': '🚗 2 parking spots',
  '🚗 3 vagas': '🚗 3 parking spots',
  '🛏️ 2 quartos': '🛏️ 2 bedrooms',
  '🛏️ 3 quartos': '🛏️ 3 bedrooms',
  '🛏️ 4 quartos': '🛏️ 4 bedrooms',
  '🛏️ 5 quartos': '🛏️ 5 bedrooms',
  '🧘 Relaxamento': '🧘 Relaxation',
  '🧠 Master PNL': '🧠 Master NLP',
  '🍎 Apple Podcasts': '🍎 Apple Podcasts',
  '🎵 Spotify': '🎵 Spotify',
  '▶️ YouTube': '▶️ YouTube',
  'Novo: PIX instantâneo 24h': 'New: 24h instant PIX',

  // Remaining items - Emojis as keys (keep same)
  '📘': '📘',
  '🎯': '🎯',
  '📈': '📈',
  '🚀': '🚀',
  '💡': '💡',
  '📊': '📊',
  '🎁': '🎁',
  '👨‍💼': '👨‍💼',
  '📱': '📱',
  '🏪': '🏪',
  '💻': '💻',
  '🔮': '🔮',
  '👥': '👥',
  '📧': '📧',
  '📍': '📍',
  '🔗': '🔗',
  '💬': '💬',
  '🍷': '🍷',
  '👨‍🍳': '👨‍🍳',
  '🌿': '🌿',
  '📞': '📞',
  '📷': '📷',
  '🐦': '🐦',
  '🍎': '🍎',
  '▶️': '▶️',
  '🔔': '🔔',
  '🏦': '🏦',
  '😰': '😰',
  '😵': '😵',
  '😤': '😤',
  '💰': '💰',
  '🏆': '🏆',
  '📋': '📋',
  '🎓': '🎓',
  '🎨': '🎨',
  '📸': '📸',
  '💼': '💼',
  '🔧': '🔧',
  '🏥 VidaClinic': '🏥 VidaClinic',
  '👨‍⚕️': '👨‍⚕️',
  '❤️': '❤️',
  '🧴': '🧴',
  '🦴': '🦴',
  '👶': '👶',
  '🧠': '🧠',
  '👁️': '👁️',
  '🕐': '🕐',
  '🏠 PrimeImoveis': '🏠 PrimeImoveis',
  '🏠': '🏠',
  '🔑': '🔑',
  '✉️': '✉️',
  '💪': '💪',
  '🏃': '🏃',
  '🥊': '🥊',
  '🧘': '🧘',
  '🎵': '🎵',
  '🎧': '🎧',
  '🎤': '🎤',
  '🤝': '🤝',
  '📅': '📅',
  '⏱️': '⏱️',
  '🎉': '🎉',
  '💳': '💳',
  '⭐⭐⭐⭐⭐': '⭐⭐⭐⭐⭐',
  '📚': '📚',
  '📝': '📝',
  '🛡️': '🛡️',
  '⚙️': '⚙️',
  '★★★★★': '★★★★★',

  // Company names (keep same)
  'Google': 'Google',
  'Meta': 'Meta',
  'Nubank': 'Nubank',
  'iFood': 'iFood',
  'Mercado Livre': 'Mercado Livre',
  'Instagram': 'Instagram',
  'LinkedIn': 'LinkedIn',
  'Marketing': 'Marketing',
  'Email': 'Email',
  'Downloads': 'Downloads',

  // Numbers and stats
  '500+': '500+',
  '15.000+': '15,000+',
  '52%': '52%',
  '150+': '150+',
  '28': '28',
  '21': '21',
  '14': '14',
  '07': '07',
  '98%': '98%',
  '4.9': '4.9',
  '497': '497',
  '50+': '50+',
  '12': '12',
  '01': '01',
  '02': '02',
  '03': '03',
  '04': '04',
  '5.000+': '5,000+',
  '2.500+': '2,500+',
  '15+': '15+',
  '200+': '200+',
  '4.9★': '4.9★',
  '#1': '#1',
  '203': '203',
  '202': '202',
  '201': '201',
  '200': '200',
  '199': '199',
  '198': '198',
  '15': '15',
  '08': '08',
  '45': '45',
  '8+': '8+',
  '32': '32',
  '+150': '+150',
  '+12.500': '+12,500',
  '89%': '89%',
  '12.500+': '12,500+',
  '97%': '97%',
};

// English to Portuguese mappings (reverse)
const enToPtMappings: Record<string, string> = Object.fromEntries(
  Object.entries(ptToEnMappings).map(([pt, en]) => [en, pt])
);

/**
 * Translate template HTML content based on current language
 * Only translates EXACT MATCHES - the entire text must match a translation key
 */
export const translateTemplateHtml = (html: string, targetLang?: string): string => {
  const lang = targetLang || i18n.language;
  const isEnglish = lang === 'en' || lang === 'en-US';

  if (!html || !isEnglish) return html;

  // Step 1: Extract and preserve <style> blocks
  const styleBlocks: string[] = [];
  let processedHtml = html.replace(/<style[^>]*>[\s\S]*?<\/style>/gi, (match) => {
    styleBlocks.push(match);
    return `__STYLE_BLOCK_${styleBlocks.length - 1}__`;
  });

  // Step 2: Extract and preserve <script> blocks
  const scriptBlocks: string[] = [];
  processedHtml = processedHtml.replace(/<script[^>]*>[\s\S]*?<\/script>/gi, (match) => {
    scriptBlocks.push(match);
    return `__SCRIPT_BLOCK_${scriptBlocks.length - 1}__`;
  });

  // Step 3: Translate TEXT CONTENT between tags - EXACT MATCH ONLY
  processedHtml = processedHtml.replace(/>([^<]+)</g, (match, textContent) => {
    const trimmed = textContent.trim();
    // Only translate if the ENTIRE trimmed text exactly matches a key
    if (trimmed && ptToEnMappings[trimmed]) {
      // Preserve original whitespace
      const leadingSpace = textContent.match(/^\s*/)?.[0] || '';
      const trailingSpace = textContent.match(/\s*$/)?.[0] || '';
      return `>${leadingSpace}${ptToEnMappings[trimmed]}${trailingSpace}<`;
    }
    return match;
  });

  // Step 4: Translate specific safe attributes - EXACT MATCH ONLY
  const safeAttributes = ['placeholder', 'title', 'alt', 'data-success-message', 'aria-label'];
  for (const attr of safeAttributes) {
    const attrRegex = new RegExp(`(${attr}=")([^"]+)(")`, 'gi');
    processedHtml = processedHtml.replace(attrRegex, (match, prefix, value, suffix) => {
      const trimmed = value.trim();
      if (trimmed && ptToEnMappings[trimmed]) {
        return `${prefix}${ptToEnMappings[trimmed]}${suffix}`;
      }
      return match;
    });
  }

  // Step 5: Restore style blocks
  styleBlocks.forEach((block, index) => {
    processedHtml = processedHtml.replace(`__STYLE_BLOCK_${index}__`, block);
  });

  // Step 6: Restore script blocks
  scriptBlocks.forEach((block, index) => {
    processedHtml = processedHtml.replace(`__SCRIPT_BLOCK_${index}__`, block);
  });

  return processedHtml;
};

/**
 * Get templates with translated content
 */
export const getTranslatedTemplates = (templates: PageTemplate[], targetLang?: string): PageTemplate[] => {
  const lang = targetLang || i18n.language;
  const isEnglish = lang === 'en' || lang === 'en-US';

  if (!isEnglish) {
    return templates; // Return original PT templates
  }

  return templates.map(template => ({
    ...template,
    name: translateTemplateName(template.name),
    description: translateTemplateDescription(template.description),
    gjsHtml: template.gjsHtml ? translateTemplateHtml(template.gjsHtml) : template.gjsHtml,
  }));
};

// Template name translations
const templateNames: Record<string, string> = {
  // templateData.ts templates (10)
  'SaaS Moderno': 'Modern SaaS',
  'Captura de Leads': 'Lead Capture',
  'Webinar/Evento': 'Webinar/Event',
  'Registro de Webinar': 'Webinar Registration',
  'Lançamento de Produto': 'Product Launch',
  'Agência Digital': 'Digital Agency',
  'Serviços de Agência': 'Agency Services',
  'Black Friday': 'Black Friday',
  'Promoção E-commerce': 'E-commerce Promo',
  'App Mobile': 'Mobile App',
  'Curso Online': 'Online Course',
  'Venda de Curso': 'Course Sales',
  'Em Breve': 'Coming Soon',

  // newTemplates.ts templates (21)
  'Captura de Leads Pro': 'Pro Lead Capture',
  'Newsletter Premium': 'Premium Newsletter',
  'Waitlist / Em Breve': 'Waitlist / Coming Soon',
  'Coaching & Mentoria': 'Coaching & Mentoring',
  'SaaS Minimalista': 'Minimalist SaaS',
  'Webinar Profissional': 'Professional Webinar',
  'Restaurante & Food': 'Restaurant & Food',
  'Download de App': 'App Download',
  'Curso Online Pro': 'Pro Online Course',
  'Portfolio Criativo': 'Creative Portfolio',
  'E-commerce Produto': 'E-commerce Product',
  'Clínica & Saúde': 'Clinic & Health',
  'Imobiliária': 'Real Estate',
  'Fitness & Academia': 'Fitness & Gym',
  'Podcast': 'Podcast',
  'Evento & Conferência': 'Event & Conference',
  'Lançamento de Livro': 'Book Launch',
  'Black Friday / Promoção': 'Black Friday / Sale',
  'Agendamento & Consulta': 'Appointment & Consultation',
  'PetShop Premium': 'Premium PetShop',
};

const translateTemplateName = (name: string): string => {
  return templateNames[name] || name;
};

// Template description translations
const templateDescriptions: Record<string, string> = {
  // templateData.ts descriptions
  'Landing page moderna para produtos SaaS e startups de tecnologia':
    'Modern landing page for SaaS products and tech startups',
  'Página otimizada para captura de leads com e-book ou material rico':
    'Page optimized for lead capture with e-book or rich content',
  'Página de registro para webinars e eventos online':
    'Registration page for webinars and online events',
  'Apresentação de novo produto com countdown e cadastro antecipado':
    'New product presentation with countdown and early registration',
  'Portfolio e serviços para agências digitais':
    'Portfolio and services for digital agencies',
  'Página de vendas com produtos em promoção':
    'Sales page with products on sale',
  'Landing page para aplicativos mobile':
    'Landing page for mobile applications',
  'Página de vendas para cursos online':
    'Sales page for online courses',
  'Página de pré-lançamento com countdown':
    'Pre-launch page with countdown',
  'Serviços de consultoria empresarial':
    'Business consulting services',
  'Promoção com timer para Black Friday e datas especiais':
    'Promotion with timer for Black Friday and special dates',
  'Landing page para download de aplicativo mobile':
    'Landing page for mobile app download',
  'Página completa de vendas para cursos online':
    'Complete sales page for online courses',

  // newTemplates.ts descriptions
  'Página completa para captura de leads com design premium e alta conversão':
    'Complete page for lead capture with premium design and high conversion',
  'Página completa para captura de inscritos em newsletter com design dark mode':
    'Complete page for newsletter subscribers with dark mode design',
  'Página de lista de espera com design minimalista e elegante':
    'Waitlist page with minimalist and elegant design',
  'Página completa para coaches, mentores e consultores com seções de serviços, depoimentos e agendamento':
    'Complete page for coaches, mentors and consultants with services, testimonials and scheduling sections',
  'Landing page completa para produtos SaaS com pricing, depoimentos e FAQ':
    'Complete landing page for SaaS products with pricing, testimonials and FAQ',
  'Página de inscrição para webinars e eventos com urgência':
    'Registration page for webinars and events with urgency',
  'Landing page completa para restaurantes com cardápio, reservas, delivery e avaliações':
    'Complete landing page for restaurants with menu, reservations, delivery and reviews',
  'Landing page completa para apps com screenshots, reviews e download links':
    'Complete landing page for apps with screenshots, reviews and download links',
  'Página de vendas profissional para cursos e infoprodutos':
    'Professional sales page for courses and digital products',
  'Portfolio moderno para designers, fotógrafos e criativos':
    'Modern portfolio for designers, photographers and creatives',
  'Landing page profissional para agências e consultorias':
    'Professional landing page for agencies and consultancies',
  'Página de produto para lojas virtuais':
    'Product page for online stores',
  'Landing page profissional para clínicas e profissionais de saúde':
    'Professional landing page for clinics and health professionals',
  'Landing page elegante para imóveis e corretores':
    'Elegant landing page for properties and real estate agents',
  'Landing page energética para academias e personal trainers':
    'Energetic landing page for gyms and personal trainers',
  'Landing page moderna para podcasts e shows':
    'Modern landing page for podcasts and shows',
  'Landing page impactante para eventos e conferências':
    'Impactful landing page for events and conferences',
  'Landing page elegante para lançamento de livros e autores':
    'Elegant landing page for book launches and authors',
  'Landing page de alta conversão para promoções e ofertas':
    'High conversion landing page for promotions and offers',
  'Landing page para profissionais que agendam consultas':
    'Landing page for professionals who schedule consultations',
  'Landing page completa para petshops, clínicas veterinárias e serviços para pets':
    'Complete landing page for pet shops, veterinary clinics and pet services',
};

const translateTemplateDescription = (description: string): string => {
  return templateDescriptions[description] || description;
};
